export default {
  hkMarket: {
    deskSubtitle: 'Sellable pay catalog + onboarding + simulate paid · stub ≠ live PSP/PayPal/Meta',
    sellableCatalogTitle: 'Sellable payment catalog (§1-11)',
    sellableCatalogHint: 'Apple/Google via local PSP; PayPal backup; crypto in catalog (compliance before live). BYO/Referral optional.',
    colTitle: 'Title',
    colTrack: 'Track',
    colEnabled: 'Enabled',
    colMerchant: 'Merchant ref',
    colNote: 'Note'
  },
  produceOutputCatalog: {
    pageTitle: 'Output map',
    pageDesc: 'Model-first: which outputs each machine can make; then categories and scene kits for Leo auto-produce.',
    tabCategories: 'Categories',
    tabBinds: 'Model → outputs',
    tabKits: 'Kits',
    categoryKey: 'Category key',
    name: 'Name',
    bucket: 'Bucket',
    pickBucket: 'Select an output bucket',
    bucketFreshDrink: 'Fresh drink',
    bucketDessert: 'Dessert',
    bucketVending: 'Vending',
    bucketLightMeal: 'Light meal',
    bucketHotKitchen: 'Hot kitchen',
    bucketBakery: 'Bakery',
    status: 'Status',
    sortNo: 'Sort',
    modelKey: 'Model code',
    deviceFamily: 'Device family',
    pickModel: 'Select a model',
    pickDeviceFamily: 'Select a device family',
    bindRole: 'Bind role',
    boundOutputs: 'Bound outputs',
    secondaryOutputs: 'Secondary among them',
    secondaryHint: 'Marked secondary = secondary capability for this model.',
    kitKey: 'Kit key',
    members: 'Members',
    coverCategories: 'Covers',
    optional: 'Optional',
    startPipeline: 'Start standard pipeline',
    guideStarted: 'Output map guide started',
    guideStartFail: 'Failed to start guide'
  },
  trainingWorkBoard: {
    title: 'Train work board',
    desc: 'Germany daily-training ledger: filter by family/content; spot healthy, stuck, utterance fuel, and training ROI.',
    toDesk: 'Decision desk',
    refresh: 'Refresh',
    searchPh: 'Search title/content/model',
    deviceFamily: 'Device family',
    contentCategory: 'Content',
    status: 'Report status',
    workState: 'Work state',
    stuckOnly: 'Stuck only',
    fuelStallOnly: 'Fuel stall only',
    total: 'All',
    stuck: 'Stuck',
    healthy: 'Healthy',
    recent: 'Recent',
    fuelStall: 'Fuel stall',
    fuelActive: 'Fuel active',
    roiTitle: 'Training ROI',
    roiAvg: 'Avg',
    roiImprove: 'Improve',
    roiWaste: 'Waste',
    roiPlateau: 'Plateau/low',
    roiNext: 'Next cut',
    fuelTitle: 'Utterance fuel',
    colTitle: 'Item',
    colContent: 'Content',
    colFamily: 'Family',
    colCategory: 'Category',
    colFreq: 'Frequency',
    colWorkState: 'Work state',
    colFuel: 'Fuel',
    colFuelPending: 'Pending',
    colFuelT6: 'T6 merge',
    colFuelPromoted: 'Promoted',
    colRoi: 'ROI',
    colRoiScore: 'Score',
    colRoiReason: 'ROI advice',
    colStatus: 'Report',
    colAge: 'Age(h)',
    colReportAt: 'Report at',
    colModels: 'Model keys',
    colActions: 'Actions',
    nodeOpen: 'Open board',
    nodeFilter: 'Filter stuck',
    nodeDesk: 'Open desk',
    nodeDone: 'Done',
    nodeTodo: 'Todo',
    ws: { HEALTHY: 'Healthy', STUCK: 'Stuck', RECENT: 'Recent' },
    fuel: { FUEL_ACTIVE: 'Active', FUEL_STALL: 'Stall', FUEL_OK: 'Idle', N_A: '—' },
    family: {
      tea_machine: 'Tea',
      coffee_machine: 'Coffee',
      cross_cutting: 'Cross',
      factory: 'Factory'
    },
    category: {
      device_gate: 'Device gate',
      routing_nl: 'Routing NL',
      portal_nl: 'Portal NL',
      hm_engine: 'HM engine',
      commerce_nl: 'Mall NL',
      store_ops: 'Store ops',
      intelligence: 'Intelligence',
      healer: 'Healer',
      factory: 'Factory',
      other: 'Other'
    }
  },
  aiSpendAudit: {
    title: 'AI Spend Audit',
    desc: 'Central audit for all AI token/USD burn: Germany training, cloud healer, edge merchant, expandable categories.',
    reconcileOr: 'Reconcile OpenRouter',
    importOr: 'Import OR activity',
    refresh: 'Refresh',
    kpiMeasured: 'Measured USD',
    kpiEstimate: 'Estimate USD',
    kpiCombined: 'Combined visible',
    kpiTokens: 'Measured tokens',
    kpiTrainStatus: 'Training cost status',
    kpiHealer: 'Healer',
    group: 'Spend group',
    deviceFamily: 'Device family',
    applyFilter: 'Filter',
    colCategory: 'Category',
    colGroup: 'Group',
    colMetering: 'Metering',
    colUsd: 'MTD USD',
    colTokens: 'Tokens',
    colBudget: 'Budget',
    colStatus: 'Status',
    colHint: 'Hint',
    detail: 'Detail',
    budgetPanel: 'Budget gates',
    healerMode: 'Healer mode',
    rounds: 'Monthly rounds',
    trainBudget: 'Training monthly budget USD',
    saveHealer: 'Save Healer',
    saveTrainBudget: 'Save training budget',
    nodeOpen: 'Open spend audit',
    nodeCap: 'Confirm USD cap',
    nodeDone: 'Ready',
    nodeTodo: 'Todo',
    loadFail: 'Failed to load spend audit',
    reconcileOk: 'Reconcile done',
    importOk: 'Import done',
    saveOk: 'Saved',
    stepOverview: 'Overview',
    stepCategories: 'Categories',
    stepDetail: 'Detail',
    stepBudget: 'Caps',
    stepOps: 'Reconcile',
    stepOverviewTitle: 'This month AI spend overview',
    stepOverviewLead: 'See totals first, then walk categories and caps one step at a time.',
    stepCategoriesTitle: 'Browse categories',
    stepCategoriesLead: 'Pick a category card for detail; filter by group if needed.',
    stepDetailTitle: 'Category detail',
    stepDetailLead: 'Amounts, metering, and hints for the selected category — no raw JSON wall.',
    stepBudgetTitle: 'Set monthly caps',
    stepBudgetLead: 'Cloud Healer USD/rounds and training monthly budget.',
    stepOpsTitle: 'Reconcile & import',
    stepOpsLead: 'Optional OpenRouter reconcile/import, then you are done.',
    groupAll: 'All groups',
    emptyCategories: 'No categories yet. Refresh or check Germany ledgers.',
    pickCategoryFirst: 'Pick a category in the previous step first',
    moreFields: 'More fields',
    healerBlock: 'Cursor Cloud Healer',
    trainBlock: 'Germany training budget',
    usdCap: 'Monthly USD cap',
    reconcileHint: 'Align OpenRouter bill with the training ledger.',
    importHint: 'Import this month usage from OpenRouter activity.',
    doneBanner: 'Audit walkthrough finished; reopen overview anytime.',
    prev: 'Back',
    next: 'Next',
    finish: 'Done',
    finishOk: 'Spend audit wizard completed',
    chartsTitle: 'Chart analytics',
    chartsLead: 'Trends by day / month / year / weekday / hour; category compare, group mix, budget usage.',
    granDay: 'Day',
    granMonth: 'Month',
    granYear: 'Year',
    granWeekday: 'Weekday',
    granHour: 'Hour',
    chartTrend: 'Spend trend compare',
    chartCategory: 'Category compare',
    chartGroup: 'Group share',
    chartBudget: 'Budget vs spent',
    chartTrainSplit: 'Training split (T9 / OpenRouter)',
    chartModels: 'OpenRouter model ranking',
    chartEmpty: 'No chart data yet (empty ledger shows category cards only)',
    seriesTraining: 'Germany training',
    seriesHealer: 'Cloud healer',
    seriesEcs: 'Germany ECS (est.)',
    seriesCombined: 'Combined',
    seriesBudget: 'Budget',
    seriesSpent: 'Spent',
  },
  leoChat: {
    chat_1475da: "Enterprise Login",
    chat_16f606: "Integer; unit depends on device/agreement",
    chat_17dfdc: "My Preferences",
    chat_22f4eb: "Usage & Billing",
    chat_27e8b6: "Tag (from memory preference)",
    chat_29f404: "Blender Recipe",
    chat_30_can_4ab820: "Last 30 Days CAN Decoded Frames",
    chat_30_can_8fe750: "Last 30 Days CAN Total Metering",
    chat_30_e47539: "Last 30 Days Charged Deductions",
    chat_30_token_16fa23: "Last 30 Days AI Points",
    chat_33613d: "Chat",
    chat_40d6e4: "Continue as Guest (Product & Public Inquiry)",
    chat_43631f: "Stop Listening",
    chat_4845c6: "Processing…",
    chat_553891: "Fill and Align Device",
    chat_5cd727: "Return to Chat",
    chat_62e9d1: "Select Mode",
    chat_6888c5: "Save",
    chat_6adada: "Console",
    chat_6d1197: "Privacy Policy, Terms of Service and Disclaimer",
    chat_7106a7: "Machine Product",
    chat_71c576: "Please enter password",
    chat_755be2: "Product Filing",
    chat_7847b8: "Send",
    chat_7e76c4: "No billing account created yet; after saving, metering will start with the selected mode.",
    chat_805f8b: "Use This Content",
    chat_85406a: "Skip Reading",
    chat_965a50: "Store Manager",
    chat_9b2c38: "Enter message",
    chat_9cbbd1: "Last Recognition",
    chat_a84cf9: "Leave empty = global preference; specify for device-specific preference",
    chat_ab185d: "Fill Input",
    chat_abd535: "Register Member",
    chat_api_a76f41: "(Subscription plans should be created via operations or API)",
    chat_app_c884f6: "If other apps have copied a link or key, paste it directly.",
    chat_b347b6: "Current Billing Settings",
    chat_b6d41c: "Copy Command",
    chat_cta_title_7535dd: "cta.title",
    chat_curve_soft_7e9ea0: "e.g., curve_soft",
    chat_d2de5e: "Registration complete, please log in again as a member to continue.",
    chat_d5e285: "I have read and agree to the",
    chat_d5edfc: "Copy Full Text",
    chat_da4d71: "Member Login",
    chat_docs_leo_brain_ident_64cb16: "docs/leo_brain/IDENTITY_PROTOCOL.md",
    chat_docs_leo_brain_leo_p_6f7d10: "docs/leo_brain/LEO_PERSONALIZATION_SCENARIO.md",
    chat_e31e3a: "Full Backend Login Page",
    chat_e6a549: "Close",
    chat_ea544c: "Please enter account",
    chat_ef5cb: "Reload",
    chat_email_leo_fda298: "Email + password; after logging in, return to Leo chat and follow the steps to complete activation.",
    chat_eur_394b9b: "EUR",
    chat_f98d0d: "Save Settings",
    chat_fe497b: "Please log in with your member account; store managers please use the 'Enterprise Backend' tab. After logging in, follow the prompts to complete home or commercial settings.",
    chat_hintauth_a22705: "hintAuth",
    chat_https_localhost_qr_e4c72c: "Camera permission required; HTTPS or localhost recommended. Aim at QR/barcode on device or product.",
    chat_leo_323396: "Leo Usage & Billing",
    chat_leo_99743: "Leo Guide",
    chat_leo_ac1503: "Member Login and Enter Leo",
    chat_leo_e3ca11: "Leo Activation Steps",
    chat_leo_e7dd0: "Leo",
    chat_leo_e9f6cd: "Enterprise Login and Enter Leo",
    chat_loaderror_108d9d: "loadError",
    chat_name_example_com_cb4900: "name@example.com",
    chat_night_owl_b82e53: "e.g., night_owl",
    chat_png_d92bec: "Download PNG",
    chat_qr_25f92d: "Scan & Product QR",
    chat_qr_40dfbd: "Generate QR",
    chat_qr_a9ae66: "Select album screenshot or photo for offline QR/barcode recognition.",
    chat_session_inputplaceho_bbe0d1: "session.inputPlaceholderZh ||",
    chat_sku_qr_png_c9b88c: "Convert store recipe keywords, URLs, or SKUs into QR codes, downloadable as PNG for printing labels.",
    chat_token_7959d6: "Total AI Points (All Time)",
    chat_token_can_dbc_28957f: "View Token & vehicle CAN/DBC usage, wallet/ledger deduction records (please log in as a member, or the backend account has completed commercial binding).",
    chat_user_ace2e8: "Backend User account; those with menu permissions can operate devices and data center.",
    chat_voicemictitle_650ed3: "voiceMicTitle",
    chat_voicesiriarialabel_76d873: "voiceSiriAriaLabel",
    chat_wsstatustitle_f6c66f: "wsStatusTitle",
  },
  leoNl: {
      busy: "…",
      close: "Close",
      enable: "Enable Leo NL",
      later: "Later",
      no: "No",
      subProgress: "Generation in progress…",
      subPrompt: "Uses AI to understand voice commands in %1$s",
      titleProgress: "Preparing Leo NL language understanding…",
      titlePrompt: "Enable Leo NL for this language?",
      titleReady: "Leo NL language pack is ready",
      yes: "Yes",
  },

  dineTable: {
    title: 'Table QR',
    desc: 'One code per table. Guests can place one order on the web and still see the Leo download. The same page can be embedded on Facebook or other social.',
    brand: 'Brand',
    retailer: 'Retailer',
    store: 'Store',
    payMode: 'When to pay',
    payFirst: 'Pay then make',
    payLater: 'Order then pay',
    saveMode: 'Save',
    tableNo: 'Table',
    create: 'Add table',
    refresh: 'Refresh',
    colNo: 'Table',
    colUrl: 'Sticker link',
    qr: 'Sticker',
    stickerPreview: 'Sticker preview',
    downloadJpg: 'Download JPG',
    downloadAllJpg: 'Download all stickers',
    downloadOk: 'Sticker JPG downloaded',
    downloadAllOk: 'All stickers ZIP downloaded',
    downloadFail: 'Sticker download failed',
    scanHint: 'Scan to order',
    poweredBy: 'Leo · Table order',
    empty: 'No tables yet',
    webLink: 'Social order link',
    webHint: 'Embed on Facebook or other social so guests order on the web',
    close: 'Clear table',
    ordersTitle: 'Table orders / payments',
    orderCount: 'Orders',
    paidCount: 'Paid',
    unpaidCount: 'Unpaid',
    amount: 'Amount',
    paid: 'Payment',
    paidYes: 'Paid',
    paidNo: 'Unpaid',
    pickup: 'Pickup #',
    createdAt: 'Time',
    ordersEmpty: 'No table orders yet',
    ordersLoadFail: 'Failed to load table orders — refresh or sign in again',
  },

  brandStorePayment: {
    title: 'Brand Pay',
    desc: 'Pick region → one PSP → enter merchant ID → trial → LIVE. Funds settle to the store merchant account.',
    hintOneVendor: 'One active PSP per store; changing vendor requires a new trial.',
    store: 'Store',
    storePh: 'Select store',
    region: 'Region',
    vendor: 'Payment',
    track: 'Onboarding',
    trackByo: 'Bring your own MID',
    trackReferral: 'Referral via XRROSS',
    merchantRef: 'Merchant ID',
    merchantRefPh: 'Public MID / Account — no secrets',
    currency: 'Currency',
    secretWarn: 'Do not enter API secrets or private keys — public merchant ID only.',
    save: 'Save binding',
    trial: 'Mark trial passed',
    live: 'Mark LIVE',
    status: 'Status',
    needStore: 'Select a store first',
    needMid: 'Enter merchant ID',
    saveOk: 'Bound',
    trialOk: 'Trial marked passed',
    liveOk: 'Marked LIVE'
  },

  hkPspOpenAccount: {
    title: 'Open Account',
    desc: 'HK Referral cases: AI review, vendor pack, inbox follow-up; ops read-only plus exceptions.',
    hint: 'Referral only; BYO binds are not queued here.',
    refresh: 'Refresh',
    status: 'Status',
    vendor: 'Vendor',
    caseId: 'Case ID',
    store: 'Store',
    mid: 'Merchant ID',
    sla: 'SLA',
    updated: 'Updated',
    note: 'Note',
    runAi: 'Re-run AI',
    forceReject: 'Force reject',
    markHandled: 'Mark handled',
    ok: 'Done'
  },

  brandOpenPack: {
    title: 'Auto open',
    desc: 'One level at a time. The system fills what it can read. The only choice is whether to buy a machine now.',
    goPay: 'Take payment',
    level: 'Level {n} / {total}',
    photoTitle: 'Photo your license',
    photoHint: 'One photo of the business license. The system fills the form.',
    photoNext: 'Photo done, next',
    machineTitle: 'Buy a machine now?',
    machineHint: 'You can open without one and buy later.',
    buyNow: 'Buy now and learn to make',
    buyLater: 'Buy later',
    productTitle: 'Product photos & copy',
    productHint: 'Say a few words, drop photos, or leave blank. AI fills in; you review and confirm.',
    productHintPh: 'e.g. iced americano, a bit bitter',
    productAi: 'AI fill',
    productSkip: 'Skip — use template',
    productConfirm: 'Confirm products',
    productName: 'Name',
    productDesc: 'Description',
    productPrice: 'Price',
    productNeedAi: 'Run AI fill first, or skip.',
    productSkipped: 'Using template signature item. Continue.',
    menuTitle: 'Menu and payment are ready',
    menuHint: 'No machine. Next is taking payment.',
    teachTitle: 'Make the first cup',
    teachHint: 'After the machine is linked, follow the screen for the first cup.',
    next: 'Level clear',
    back: 'Back one level',
    stay: 'This level is not clear yet.',
    doneTitle: 'Store is open',
    doneMenu: 'You can take payment and sell the menu.',
    doneMachine: 'Next level is learning to make a drink.',
    colStep: 'Step',
    colDetail: 'What this region needs'
  },

  productShelf: {
    title: 'List products',
    desc: 'Fill name and price. Description and photo can be typed or generated by AI for real. Auto-make products must finish the eight SOC pages — no fake recipe on the phone.',
    storePh: 'Store id',
    load: 'Load',
    manual: 'Ordinary',
    auto: 'Auto make',
    name: 'Name',
    price: 'Price',
    description: 'Description',
    imageUrl: 'Product photo URL',
    kind: 'Kind',
    state: 'Status',
    save: 'Save product',
    ai: 'Ask AI to fill',
    publish: 'List it',
    listed: 'Listed',
    ready: 'Ready for AI',
    waiting: 'Basics missing',
    needStore: 'Enter a store id',
    noEquipment: 'No machine in this store yet. Formula and scan stay off.',
    materialPh: 'Material for this product',
    saveMaterial: 'Save this material step',
    confirmStep: 'Finish this step',
    now: 'Now',
    coachNow: 'Now do step {n}',
    coachHint: 'Open the real SOC page for this step, then come back and refresh. Do not skip. Do not fake a recipe on the phone.',
    finishCurrent: 'Finish the current step first',
    needProduct: 'Save this product name and price first',
    openSoc: 'Open this SOC page',
    refreshStep: 'I finished — refresh',
    fail: 'Try again'
  },

  produceGuide: {
    title: 'Auto equipment',
    desc: 'Pick tea, coffee, or drinks. We show one machine from the store and one sentence on how it works. Buy it if it has a price, or leave a request.',
    storePh: 'Store id',
    tea: 'Tea',
    coffee: 'Coffee',
    drink: 'Drinks',
    look: 'See the pick',
    combo: 'Also sold as a set: ',
    demo: 'See how it works',
    receiver: 'Receiver',
    phone: 'Phone',
    address: 'Address',
    buy: 'Buy now',
    demand: 'Leave a request',
    empty: 'No matching machine in the store yet',
    done: 'Saved',
    fail: 'Try again'
  },

  brandAppListing: {
    title: 'App listing',
    desc: 'One-click: AI drafts name, icon and store copy; confirm then queue Android/iOS draft upload (XRROSS-managed accounts).',
    hint: 'Customer need not handle build or store consoles; LIVE payment binding required for collecting money.',
    store: 'Store',
    storePh: 'Select store',
    displayName: 'App name',
    storeTitle: 'Store title',
    shortDesc: 'Short description',
    fullDesc: 'Full description',
    icon: 'Icon',
    iconEmpty: 'No icon yet',
    status: 'Status',
    btnAi: 'Generate for me',
    btnConfirm: 'Confirm assets',
    btnPublish: 'One-click publish',
    btnPipeline: 'Start standard pipeline',
    coachDo: 'Do this step',
    aiOk: 'Generated (you can edit)',
    confirmOk: 'Assets confirmed',
    publishOk: 'Publish queued'
  },

  route: {
    // XRROSS_I18N_UNION_FILL_20260916 en
    add: 'Add',
    batchDelete: 'Batch Delete',
    batchImport: 'Batch Import',
    bindMachine: 'Bind Device',
    bindStore: 'Bind Store',
    codeRule: 'Code Rules',
    delete: 'Delete',
    detail: 'Detail',
    edit: 'Edit',
    export: 'Export',
    log: 'Log',
    machineList: 'Device List',
    merchantsData: 'Merchant Stats',
    oneClickCopy: 'One-Click Copy',
    reset: 'Reset',
    resetPwd: 'Reset Password',
    search: 'Search',
    storeMaterialPhysicalMerge: 'SKU Merge Suggestions',
    homePage:'Homepage',
    dataDisplay:'Data display',
    atlas:'Map',
    journal:'Log',
    details:'Details',
    systemSetting: "System Settings",
    aiTrusteeAdmin: 'AI Trustee Admin',
    agentPermissionSteward: 'Agent Permission Steward',
    socNotificationCenter: 'Notification Center',
    loginAccount: 'Account Management',
    merchants: 'Merchant Management',
    devices: "Device Management",
    material: "Material Management",
    deviceConfig: "Device Configuration",
    channelConfiguration: "Channel configuration",
    configProfileLibrary: "Profile library",
    coffeeMachineChannelSlots: "X600H Recipe Center",
    configBindDispatch: "Bind & dispatch",
    leoKnowledgeGroup: 'Smart.Leo',
    leoKnowledgeModelFields: 'Model knowledge fields',
    leoKnowledgeEquipmentTypeTypeKey: 'Equipment type type_key',
    leoKnowledgeUpload: 'Knowledge upload',
    leoKnowledgeIngestBatch: 'Ingest batch (auto)',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT pipeline',
    leoKnowledgeCapabilityMatrix: 'Capability matrix',
    leoKnowledgeOnboarding: 'Smart model onboarding',
    leoKnowledgeTesterConsole: 'Tester console',
    leoKnowledgePipelineHub: 'Pipeline hub',
    leoKnowledgeFeatureSurface: 'Feature → API map',
    leoKnowledgeProtocolDoc: 'Protocol doc index',
    leoKnowledgeRemoteTools: 'Remote tool catalog',
    leoKnowledgeLearning: 'Learning loop',
    leoKnowledgeExternalIngest: 'External knowledge ingest',
    leoKnowledgePortalHub: 'Leo chat & ops',
    leoKnowledgePortalHubDesc: 'Open Leo chat (primary) and Biz ops; Console/Portal are internal-only.',
    leoKnowledgePortalHubHint: 'Console uses the bubble chat layout; portal is the lightweight entry. Add portalToken / ceoBearer in the URL after opening if needed.',
    leoKnowledgeUiSurfaceSample: 'Admin UI samples',
    leoKnowledgeUiSurfaceSample2: 'Admin UI sample · 2',
    leoKnowledgeUiSurfaceSample3: 'Admin UI sample · 3',
    uiSurfaceSampleMergedLead: 'Three admin UI samples on one page — switch tabs to compare.',
    uiSurfaceSampleTab1: 'Sample 1 · Ant Pro',
    uiSurfaceSampleTab2: 'Sample 2 · Stripe',
    uiSurfaceSampleTab3: 'Sample 3 · Compact',
    uiSurfaceSampleLead: 'Sample 1 (chosen pilot): Ant Design Pro medium density. Global tokens landed; merchant & device lists use the skeleton.',
    uiSurfaceSampleLead2: 'Sample 2 · Stripe/SaaS: indigo accent, larger radius, airier spacing, soft shadow.',
    uiSurfaceSampleLead3: 'Sample 3 · Compact ops: teal accent, tight radius, mini controls, higher density.',
    uiSurfaceSampleAlert: 'Visual mock only — dummy data, no backend; compare samples 1/2/3 before global rollout.',
    uiSurfaceSampleTokenTitle: 'Design tokens (candidate)',
    uiSurfaceSampleDensity: 'Density: medium (8px grid)',
    uiSurfaceSampleDensity2: 'Density: medium-airy (Stripe)',
    uiSurfaceSampleDensity3: 'Density: compact (ops desk)',
    uiSurfaceSampleBtnTitle: 'Button hierarchy',
    uiSurfaceSampleBtnPrimary: 'Primary',
    uiSurfaceSampleBtnSecondary: 'Secondary',
    uiSurfaceSampleBtnText: 'Text',
    uiSurfaceSampleBtnDanger: 'Danger',
    uiSurfaceSampleBtnMore: 'More',
    uiSurfaceSampleBtnCreate: 'Create',
    uiSurfaceSampleListSkeleton: 'List skeleton: filters | table | footer',
    uiSurfaceSampleFormTitle: 'Form density (medium)',
    uiSurfaceSampleFormRemark: 'Remark',
    uiSurfaceSamplePipelineTitle: 'Pipeline rail + coach golden (SocProcessRail + SocStepCoach)',
    uiSurfaceSamplePipelineMeta: 'Top strip = rail + blue coach buttons; shared with to-go / page; no alternate styles',
    uiSurfaceSampleCoachTitle: 'Do this now: step 2 (demo)',
    uiSurfaceSampleCoachHint: 'Blue box = current step. Tap the big button—do not hunt the whole page.',
    uiSurfaceSampleCoachPrimary: 'Go to this step',
    uiSurfaceSampleCoachSecondary: 'Start / check guide',
    uiSurfaceSamplePipelineStep1: 'Step 1',
    uiSurfaceSamplePipelineStep2: 'Step 2',
    uiSurfaceSamplePipelineStep3: 'Step 3',
    uiSurfaceSamplePipelineStep4: 'Step 4',
    uiSurfaceSampleColActions: 'Actions',
    uiSurfaceSampleActEdit: 'Edit',
    uiSurfaceSampleActExport: 'Export',
    uiSurfaceSampleTableFootHint: 'Footer: hint left | pagination right',
    uiSurfaceSampleKpi_orders: 'Orders today (mock)',
    uiSurfaceSampleKpi_online: 'Devices online',
    uiSurfaceSampleKpi_alerts: 'Open alerts',
    uiSurfaceSampleKpiSub: 'Sample figures',
    uiSurfaceSampleFilterTitle: 'Filters',
    uiSurfaceSampleKeyword: 'Keyword',
    uiSurfaceSampleKeywordPh: 'Name or code',
    uiSurfaceSampleStatus: 'Status',
    uiSurfaceSampleStAll: 'All',
    uiSurfaceSampleStOn: 'On',
    uiSurfaceSampleStOff: 'Off',
    uiSurfaceSampleReset: 'Reset',
    uiSurfaceSampleSelectPh: 'Select',
    uiSurfaceSampleTableTitle: 'List mock',
    uiSurfaceSampleColName: 'Name',
    uiSurfaceSampleColRegion: 'Region',
    uiSurfaceSampleColStatus: 'Status',
    uiSurfaceSampleColUpdated: 'Updated',
    uiSurfaceSampleCompareTitle: 'Contrast: flat white vs layered gray',
    uiSurfaceSampleCompareOld: 'Old feel: large white slab',
    uiSurfaceSampleCompareOldDesc: 'When content and background are both bright white, edges blur and long reads feel harsher.',
    uiSurfaceSampleCompareNew: 'Proposed: white cards on gray',
    uiSurfaceSampleCompareNewDesc: 'Primary content stays on white for contrast; the page uses a soft gray field so the eye can rest.',
    leoPortalHubSovereign: 'Console (fullscreen)',
    leoPortalHubPortal: 'Portal',
    leoPortalHubDeviceIntegrationSection: 'Device integration',
    leoPortalHubDeviceIntegrationLink: 'Public docs & tools (new tab)',
    leoPortalHubRuntimeModuleLink: 'Device cloud runtime AAR (new tab)',
    leoPortalHubSdkLabSection: 'XRROSS SDK (engineering)',
    leoPortalHubSdkEngineerLabOpen: 'Full test bench (track 1 + 2, new tab)',
    leoPortalHubSdkPublicTrack1: 'Track 1 public page',
    leoPortalHubSdkPublicTrack2: 'Track 2 public page',
    leoPortalHubChatSection: 'Chat entry',
    leoPortalHubPreferences: 'My preferences',
    leoPortalHubLogin: 'Sign in',
    leoPortalHubSectionOps: 'Operations console',
    leoPortalHubSectionOpsDesc: 'Live chat stream and CEO / portal sovereign view—best on a large display.',
    leoPortalHubSectionPortal: 'Mobile portal',
    leoPortalHubSectionPortalDesc: 'Lightweight entry for phones or demos.',
    leoPortalHubSectionChat: 'Conversational AI',
    leoPortalHubSectionChatDesc: 'Leo conversational AI. Preferences and sign-in below.',
    leoPortalHubSectionDeviceDesc: 'Public docs, runtime module, and integration material (all open in a new tab).',
    leoPortalHubSectionSdkDesc: 'Engineering bench for dual-track wiring, regression, and debugging.',
    leoPortalHubCardSovereignDesc: 'Bubble chat, Markdown, and SOP step cards.',
    leoPortalHubCardPortalDesc: 'Compact Leo portal; add portalToken / ceoBearer in the URL when needed.',
    leoPortalHubCardLeoDesc: 'Default Leo chat—operations, knowledge Q&A, and device ops (one global account).',
    leoPortalHubCardPrefDesc: 'Persona, locale, and personalization.',
    leoPortalHubCardLoginDesc: 'Sign in with a staff account before using write or sensitive actions.',
    leoPortalHubCardDeviceIntegrationDesc: 'Public narrative, Track 1 tools, and integration checklist.',
    leoPortalHubCardRuntimeDesc: 'Device cloud runtime / AAR and Track 2 entry point.',
    leoPortalHubCardSdkLabDesc: 'Integrated lab to exercise Track 1 and Track 2 together.',
    leoPortalHubSdkFeaturedTag: 'Engineering',
    leoPortalHubOpenNewTab: 'Open in new tab',
    leoPortalHubSdkCrossRefHint: 'For Track 1 / Track 2 public pages, use the two cards under Device integration above.',
    leoFloatDockTitle: 'Leo chat',
    leoFloatDockMinimize: 'Minimize',
    leoFloatDockClose: 'Close',
    leoFloatDockResizeHint: 'Drag the bottom-right corner to resize',
    leoFloatDockSwitchLabel: 'Leo chat',
    socAssistantTabManual: 'Manual',
    socAssistantTabGuide: 'Smart guide',
    socSmartGuideLead: 'Say who you are and what you need. The system opens a pipeline and follows it to the result unless you delete it, then starts the next one.',
    socSmartGuideStart: 'Start process',
    socSmartGuideMyProcesses: 'My processes',
    socSmartGuideCatalog: 'Or pick from the process catalog',
    socSmartGuideNetStats: 'Units {units} · processes {processes} · links {edges}',
    socSmartGuideIntentPlaceholder: 'e.g. I am a new brand owner; take me from signing to selling',
    socSmartGuideEntry: 'Entry',
    socSmartGuideExit: 'Exit',
    socSmartGuideDemand: 'Need',
    socSmartGuideResult: 'Result',
    socSmartGuideHandoff: 'This process is done; starting the next one',
    socSmartGuideRolePreview: 'Role preview',
    socSmartGuideRoleCurrent: 'This account',
    socSmartGuideProxyStore: 'Proxy clerk line: store ID',
    socSmartGuidePaused: 'Paused',
    socSmartGuideInProgress: 'In progress',
    socSmartGuideNotices: 'Reminders',
    socSmartGuideNoticeNotDone: 'Not done',
    socSmartGuideNoticeWrong: 'Done wrong',
    socSmartGuideNoticeDue: 'Due',
    socSmartGuideAck: 'Got it',
    socSmartGuideContinue: 'Continue',
    socSmartGuideDelete: 'Delete pipeline',
    socSmartGuideDeleteConfirm: 'The system will stop following this pipeline. Delete it?',
    socSmartGuideDeleted: 'Pipeline deleted',
    socSmartGuideDeleteFail: 'Could not delete',
    socSmartGuideOpenPage: 'Open',
    socProcessNetTogoTitle: 'Process to-go',
    socProcessNetTogoRemain: '{n} steps left',
    socProcessNetTogoAllDone: 'This line is complete',
    socProcessNetTogoHint: 'Checks come from system status. Tap a stuck step to open the real page, or talk to Leo on the same ticket.',
    socProcessNetTogoVoice: 'Talk to Leo',
    socProcessNetTogoClose: 'Close',
    socProcessNetTogoLoadFail: 'Could not load to-go',
    socProcessNetTogoNow: 'Now',
    socSmartGuideSlotsHint: 'Answer the missing fields first (chat fills the same ticket)',
    socSmartGuideSlotSubmit: 'Save',
    socAssistantTabChat: 'Leo chat',
    xrrossIntroNavButton: 'About XRROSS',
    xrrossIntroHub: 'About XRROSS',
    xrrossIntroLeo: 'Leo',
    xrrossIntroSoc: 'SOC',
    xrrossIntroTrinity: 'Trinity',
    xrrossIntroXhm: 'XHM',
    leoSmartIntro: 'About Leo Smart',
    leoFloatDockSwitchHint: 'Opens Leo SOC assistant on the Chat tab (same drawer as Manual / Smart Guide). Standalone Leo pages still use full-page chat.',
    layoutThemeUseDark: 'Switch to dark theme',
    layoutThemeUseLight: 'Switch to light theme',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo: console, portal, and Leo chat moved under Leo Knowledge →',
    leoProfileWorkbenchLeoMovedSuffix: '.',
    equipmentCategory: 'Equipment category',
    equipmentCategoryEdit: 'Equipment category — edit',
    equipmentCategoryDel: 'Equipment category — delete',
    equipmentTypePermAdd: 'Equipment type — list/add',
    equipmentTypePermEdit: 'Equipment type — edit',
    deviceSimulatorConsole: 'Simulator console',
    leoDeviceOpsRolePolicy: 'Command permission matrix',
    leoDeviceOpsSemanticTraining: 'Semantic training workbench',
    leoTurnRoutingTrainingHub: 'T0 turn routing training',
    leoKnowledgePortalOpsInventory: 'Portal ops API inventory',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS workbench',
    leoDeviceOpsReviewInbox: 'B-line review inbox',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS inventory console',
    leoDeviceOpsBLineDailyHub: 'B-line daily hub',
    simulatorGroup: 'Simulator',
    x600hGateway: 'X600H',
    xt90c2Simulator: 'XT90C2',
    blenderSimulator: 'Blender',
    maestroSimulator: 'Maestro',
    storefrontSimulator: 'Order Kiosk',
    productCenter: "Product Management",
    productCenterFolderOther: 'Other Products',
    dataCenter: "Data Center",
    maintenance: "Operations management",
    filesCenter: 'File Management',
    menuSetting: 'Menu Settings',
    organization: 'User organization',
    loginAccount: 'Account List',
    authorization: 'Role Management',
    merchants: 'Merchant List',
    deviceList: 'Device List',
    deviceAutoServiceGroup: 'Service Maintenance',
    supportTicketGroup: 'Support Tickets',
    supportTicketCreate: 'Submit Ticket',
    supportTicketMine: 'My Tickets',
    supportTicketWorkbench: 'Support Workbench',
    supportPlaybook: 'Standard Q&A',
    deviceServiceWorkbench: 'Service Workbench',
    deviceServiceMyAssignments: 'My Assignments',
    deviceServiceAssignees: 'Field Assignees',
    deviceServiceMaintenance: 'Maintenance Plans',
    deviceServiceFaultPolicy: 'Fault Policies',
    deviceServiceEnterprisePolicy: 'Enterprise Policy',
    deviceServiceMobile: 'Mobile Tasks',
    deviceServiceBills: 'Service Bills',
    deviceServiceAnalytics: 'Fault Analytics',
    storeMaterialStock: 'Stock Overview',
    storeMaterialOrders: 'Purchase Orders',
    storeMaterialConsumable: 'Consumable BOM',
    storeMaterialMq: 'MQ Config',
    storeMaterialInvoice: 'Invoices',
    storeMaterialBarcodeAlias: 'Barcode Mapping',
    storeMaterialCount: 'Stock Count',
    storeMaterialBomWizard: 'BOM Wizard',
    storeMaterialAnalytics: 'Material Usage Report',
    channelCategory: 'Channel type',
    productCategory: 'Product Type',
    optionCategory: 'Specification Type',
    optionList: 'Specification List',
    storeAccount: 'Store Account',
    stores: 'Store Management',
    modelName: 'Device Name/Model',
    category: 'Material Type',
    configDistribute: 'Channel distribution',
    devicesChannels: 'Device Channels',
    productsList5: 'Product List 5',
    produceFivePos: 'Product 5 Store POS',
    posCenter: 'POS Center',
    menuDistribute: 'Menu distribution',
    storeMenu: 'Store Menu',
    merchantData: 'Merchant Statistics Data',
    devicsData: 'Device Statistics Data',
    productionData: 'Equipment Production Data',
    maintanenceData: 'Equipment after-sales data',
    devicesWorkingData: 'Device Usage Data',
    afterSalesReminder: 'After sales Reminder',
    maintenanceTips: 'Maintenance Tips',
    fileUpgrade: 'File Upgrade',
    dataDowloan: 'Data Download',
    materialList: 'Material List',
    accessoriesCategory: 'Snack Types',
    accessoriesList: 'Snack List',
    businessCenter: 'Business Center',
    afterSalesServiceGroup: 'After-Sales Service',
    storeMaterialGroup: 'Inventory Management',
    appsBanner: 'App Banner Display',
    advertisement: 'Advertisement List',
    advertBind: 'Advertisement Binding',
    advertDistribute: 'Advertising distribution',
    membersCenter: 'Membership List',
    orderCenter: 'Order List',
    packBag: 'Packaging bag',
    appsCenter: 'app management',
    productsList2: 'Product List 2',
    XTSeriesData: 'Batching Machine Data',
    calibrationData: 'Calibration Data',
    fullPipeData: 'Full Pipe Data',
    productionData: 'Production Data',
    materialDate: 'Material Data',
    qualityData: 'Single cup data',
    alertsLog: 'Fault Log',
    cleaningLog: 'Cleaning Record',
    coffeeData: 'Coffee Machine Data',
    coffeeMachineProductionData: 'X600H Production Data',
    coffeeMachineSingleCupData: 'X600H Single-Cup Data',
    coffeeSumData: 'Quality Data',
    taxCenter: 'Tax Center',
    taxManagement: 'Tax Management',
    taxAllocation: 'Tax Allocation',
    dataOfTeaExtractorMachine: 'Tea Extraction Machine Data',
    teaMachineMaterial: 'Material loss',
    teaEarlyBrewWork: 'Multi-machine interconnect',
    dispenserPrecision: 'Precision',
    dispenserMaterialLoss: 'Material loss',
    dispenserMultiMachine: 'Multi-machine interconnect',
    ecosystemMallGroup: 'Ecosystem Mall',
    ecosystemMallTopology: 'Store topology',
    ecosystemMallFeaturedBuyEyebrow: 'Featured · Home buy',
    ecosystemMallFeaturedBuyTitle: 'Xrross X600H · $499',
    ecosystemMallFeaturedBuyDesc: 'Home smart coffee machine — one click to checkout.',
    ecosystemMallFeaturedBuyCta: 'Buy X600H now',
    ecosystemMallFeaturedBuyBrowse: 'Browse catalog',
    ecosystemMallCapGridTitle: 'What you can do here',
    ecosystemMallCapGridDesc: 'Every capability stays visible. Hover a tile for a short explanation and how it links to store / home / other devices. Blue badge = suggested next step.',
    ecosystemMallCapHoverHint: 'Hover for details',
    ecosystemMallTipBuyX600h: 'Open home checkout and buy X600H with Stripe or PayPal (Stripe is the overseas default).',
    ecosystemMallTipOrientPipeline: 'Guided tour: capability grid → home / store → pick a store → open a capability.',
    ecosystemMallTipGapFillPipeline: 'After picking a store, fill gaps: topology → suggestions → simulate or lead → ready to order.',
    ecosystemMallTipColorScheme: 'Canvas colors only — does not change features.',
    ecosystemMallTipBrowseCatalog: 'Browse catalog and topology first; no rush to checkout.',
    ecosystemMallTipHomePipeline: 'Home checkout pipeline: pick SKU → address → pay → done.',
    ecosystemMallTipBackTopology: 'Back to mall home (topology / capability grid).',
    ecosystemMallTipReload: 'Reload this page’s data.',
    ecosystemMallTipPayStripe: 'Pay securely with Stripe (overseas default).',
    ecosystemMallTipPayPaypal: 'Pay with PayPal (optional).',
    ecosystemMallTipTrialPipeline: 'Trial-then-buy: start trial → review → buy or leave intent.',
    ecosystemMallTipEntryContinue: 'Take the next step from the briefing.',
    ecosystemMallTipEntrySwitch: 'Switch between home and commercial focus (no features hidden).',
    ecosystemMallTipEntryAdvanced: 'Show or hide advanced charts / expert details.',
    ecosystemMallTipTrackHome: 'Home focus: direct buy and home devices.',
    ecosystemMallTipTrackCommercial: 'Commercial focus: store ops, lines, and gaps.',
    ecosystemMallTipAppDlPipeline: 'Guided download of official apps for this region (same ledger as OTA).',
    ecosystemMallTipAppDlReload: 'Refresh the download list.',
    ecosystemMallCapBadgeSuggest: 'Suggested',
    ecosystemMallCapBadgeCurrent: 'Here',
    ecosystemMallCapBadgeNeedStore: 'Pick a store',
    ecosystemMallCapC1Title: 'Store topology',
    ecosystemMallCapC1Blurb: 'Topology map of what you have / still need',
    ecosystemMallCapC1Link: 'Linked: tap a device to see how machines work together',
    ecosystemMallCapC2Title: 'Search and recommend',
    ecosystemMallCapC2Blurb: 'Find the next machine by keyword',
    ecosystemMallCapC2Link: 'Linked: recommendations from your store gaps',
    ecosystemMallCapC3Title: 'Line-up packages',
    ecosystemMallCapC3Blurb: 'What a store type needs',
    ecosystemMallCapC3Link: 'Linked: a full service line assembled together',
    ecosystemMallCapC4Title: 'Try in simulation',
    ecosystemMallCapC4Blurb: 'Cloud trial before you buy',
    ecosystemMallCapC4Link: 'Linked: after trial, fill gaps or buy',
    ecosystemMallCapC5Title: 'Combo demo',
    ecosystemMallCapC5Blurb: 'See the whole store flow',
    ecosystemMallCapC5Link: 'Linked: multi-machine store story',
    ecosystemMallCapC6Title: 'Home buy / orders',
    ecosystemMallCapC6Blurb: 'Buy hardware, pay, track orders',
    ecosystemMallCapC6Link: 'Linked: after purchase, same Leo / topology ecosystem',
    ecosystemMallCapC7Title: 'Business plans',
    ecosystemMallCapC7Blurb: 'Buy or upgrade plans',
    ecosystemMallCapC7Link: 'Linked: plan features hang back on store and devices',
    ecosystemMallCapC8Title: 'Purchase intent',
    ecosystemMallCapC8Blurb: 'Say I want this / install',
    ecosystemMallCapC8Link: 'Linked: intent to fulfillment to topology node',
    ecosystemMallCapC9Title: 'Pre-sales Q&A',
    ecosystemMallCapC9Blurb: 'Ask about linkage / buy / trial',
    ecosystemMallCapC9Link: 'Linked: then jump to sim or intent',
    ecosystemMallCapC10Title: 'App downloads',
    ecosystemMallCapC10Blurb: 'Official apps for this region',
    ecosystemMallCapC10Link: 'Linked: phone and device share one ledger',
    ecosystemMallCapC11Title: 'Virtual store / home',
    ecosystemMallCapC11Blurb: 'Layout and placement tips',
    ecosystemMallCapC11Link: 'Linked: virtual layout maps to real gaps',
    ecosystemMallCapC12Title: 'Product display',
    ecosystemMallCapC12Blurb: 'Browse products one card at a time',
    ecosystemMallCapC12Link: 'Linked: open checkout, trial, or topology from a card',
    ecosystemMallProductDisplayDesc: 'Grid view of every product (alongside topology and line packages). Tap a card to learn, then buy or try.',
    ecosystemMallProductDisplayToolbar: 'Product grid',
    ecosystemMallProductDisplayCount: '{n} items',
    ecosystemMallProductDisplaySearchPh: 'Search name / code',
    ecosystemMallProductDisplayDefaultPitch: 'Cloud-ready · linked',
    ecosystemMallProductDisplayAlreadyHere: 'You are already on product display',
    ecosystemMallProductDisplaySeeTopology: 'See links on topology',
    ecosystemMallProductDisplayScopeLabel: 'Device scope',
    ecosystemMallProductDisplayScopeAll: 'All devices',
    ecosystemMallProductDisplayScopeStore: 'This store',
    ecosystemMallProductDisplayNeedStore: 'Pick a store for store scope',
    ecosystemMallProductDisplayNoStore: 'No store selected',
    ecosystemMallProductDisplayStoreAlert: 'This store: pick a store above to list owned / suggested products.',
    ecosystemMallProductDisplayCatalogAlert: 'All devices: full mall catalog; picking a store marks what you already have.',
    ecosystemMallProductDisplayEmpty: 'No products to show. Switch to All devices, change store, or confirm ACTIVE catalog items exist.',
    ecosystemMallProductDisplaySideEmpty: 'Tap a product card to open the same detail panel as the topology store.',
    ecosystemMallProductDisplaySideEmptyHint: 'Cover/video, overview, specs, and feature chapters; buy, trial, or open topology links.',
    ecosystemMallDetailCapacity: 'Capacity lift',
    ecosystemMallDetailLabor: 'Labor drop',
    ecosystemMallDetailMedia: 'Product detail & media gallery',
    ecosystemMallDetailMediaPending: 'Image pending',
    ecosystemMallDetailMediaPreview: 'Product preview',
    ecosystemMallDetailVideo: 'Product video',
    ecosystemMallDetailCover: 'Mall cover',
    ecosystemMallDetailAvatar: 'Topology avatar',
    ecosystemMallDetailModelImg: 'Model image',
    ecosystemMallDetailScene: 'Scene',
    ecosystemMallDetailTabOverview: 'Overview',
    ecosystemMallDetailTabSpecs: 'Specs',
    ecosystemMallDetailTabFeatures: 'Features',
    ecosystemMallDetailKeySpecs: 'Key specs',
    ecosystemMallDetailSeeAll: 'See all',
    ecosystemMallDetailSpecsLoading: 'Loading specs…',
    ecosystemMallDetailSpecsEmpty: 'No adopted specs yet.',
    ecosystemMallDetailSpecsFail: 'Failed to load specs',
    ecosystemMallDetailSpecSearchPh: 'Search specs…',
    ecosystemMallDetailGuide: 'Guided tour',
    ecosystemMallDetailAllChapters: 'All chapters',
    ecosystemMallDetailPrev: 'Prev',
    ecosystemMallDetailNext: 'Next',
    ecosystemMallDetailProof: 'Capability proof hooks',
    ecosystemMallDetailOpen: 'Open',
    ecosystemMallDetailNoChapters: 'No feature chapters for this model.',
    ecosystemMallDetailBackChapters: 'Back to chapters',
    ecosystemMallDetailChapter: 'Chapter',
    ecosystemMallDetailChapterHint: 'Tap for step details',
    ecosystemMallDetailModel: 'Model',
    ecosystemMallDetailFamily: 'Family',
    ecosystemMallDetailRole: 'Store role',
    ecosystemMallDetailOverlayOwned: 'Owned · cloud linked',
    ecosystemMallDetailOverlayMissing: 'Cloud ready · missing in store',
    ecosystemMallDetailOverlayAvailable: 'Available in catalog · cloud ready',
    ecosystemMallOrientRailTitle: 'Get to know the ecosystem mall',
    ecosystemMallGapFillPipeline: 'Help me fill store gaps',
    ecosystemMallGapFillRailTitle: 'Fill this store’s gaps',
    ecosystemMallHomeCheckoutPipeline: 'Home checkout pipeline',
    ecosystemMallTrialThenBuyTitle: 'Try before you buy',
    ecosystemMallTrialThenBuyDesc: 'Trial first, then buy or leave intent. Trials are isolated from real devices—no features removed.',
    ecosystemMallTrialThenBuyPipeline: 'Guide me try then buy',
    ecosystemMallTrialThenBuyRailTitle: 'Trial → buy',
    ecosystemMallTrialThenBuyListTitle: 'My trial simulators',
    ecosystemMallTrialThenBuyAllStatus: 'All statuses',
    ecosystemMallTrialThenBuyCleanup: 'Expire cleanup',
    ecosystemMallTrialThenBuyEmpty: 'No trial simulators yet',
    ecosystemMallTrialThenBuyStatus: 'Status',
    ecosystemMallTrialThenBuyExpires: 'Expires',
    ecosystemMallTrialCoachPick: 'Pick a product to try',
    ecosystemMallTrialCoachOpen: 'Open / refresh your trial',
    ecosystemMallTrialCoachResult: 'After results, buy or leave intent',
    ecosystemMallTrialHintPick: 'Pick a device on topology, then open sim; this page lists provisioned trials.',
    ecosystemMallTrialHintOpen: 'Refresh to see your trial SN (isolated from live devices).',
    ecosystemMallTrialHintResult: 'Buy and intent stay visible—nothing hidden.',
    ecosystemMallSideBuyNow: 'Buy this device',
    ecosystemMallSideSimOpen: 'Try simulation first',
    ecosystemMallSideSimClose: 'Close simulation',
    ecosystemMallSideIntentNeedStore: 'Pick a store first, then leave intent',
    ecosystemMallSideIntentPotential: 'I want this (leave intent)',
    ecosystemMallSideIntentOwned: 'Already in this store',
    ecosystemMallAppDownloads: 'App download',
    ecosystemMallAppDownloadsDesc: 'Leo product page. iPhone: App Store. Android overseas: Google Play. Mainland China: this region’s node APK (same as OTA).',
    ecosystemMallAppDlReload: 'Reload',
    ecosystemMallAppDlChannels: 'Channels',
    ecosystemMallAppDlAndroid: 'Android APK',
    ecosystemMallAppDlInstallNow: 'Download & install',
    ecosystemMallAppDlNoApk: 'No APK in this region yet',
    ecosystemMallAppDlAndroidReady: 'Android detected. Tap to download the published Leo phone build for this region.',
    ecosystemMallAppDlAndroidWait: 'No customer APK is published here yet. Use the store listing when review finishes.',
    ecosystemMallAppDlVersion: 'Version',
    ecosystemMallAppDlUnknownSrc: 'If the phone blocks unknown sources, allow installs for this app.',
    ecosystemMallAppDlPlayReview: 'Google Play is not open yet.',
    ecosystemMallAppDlIosReview: 'App Store listing is coming.',
    ecosystemMallAppDlReviewing: 'In review',
    ecosystemMallAppDlComing: 'Coming soon',
    ecosystemMallAppDlDesktopHint: 'iPhone: App Store. Android overseas: Google Play. Mainland China: this region’s node install. You can also copy the link.',
    ecosystemMallAppDlCopyLink: 'Copy page link',
    ecosystemMallAppDlOpenSoc: 'Open SOC',
    ecosystemMallAppDlCopySoc: 'Copy SOC link',
    ecosystemMallAppDlSocHint: 'SOC is the web hub. Open it in a browser — you are already here.',
    ecosystemMallAppDlCopied: 'Copied',
    ecosystemMallAppDlSmartAndroid: 'Android phone: you can install Leo now.',
    ecosystemMallAppDlSmartAndroidPlay: 'Android phone (overseas): install Leo from Google Play.',
    ecosystemMallAppDlSmartAndroidNode: 'Android phone (mainland China): install from this region’s node — same package as OTA.',
    ecosystemMallAppDlSmartAndroidNoApk: 'Android phone, but this region has no sideload package yet. Overseas: use Google Play.',
    ecosystemMallAppDlSmartIos: 'iPhone: install Leo.Smart from the App Store.',
    ecosystemMallAppDlSmartDesktop: 'Desktop: open this page on Android, or copy the link.',
    ecosystemMallAppDlRoleLeo: 'Phone brain',
    ecosystemMallAppDlRoleSoc: 'You are here',
    ecosystemMallAppDlRoleXhm: 'In-store machines · next',
    ecosystemMallAppDlTopo: 'Mall topology · trinity',
    ecosystemMallAppDlEdgeLeoSoc: 'Phone → SOC',
    ecosystemMallAppDlEdgeSocXhm: 'SOC → machines',
    ecosystemMallAppDlCapLeo: 'Leo is how people talk to machines; Android can sideload first.',
    ecosystemMallAppDlCapSoc: 'SOC is the hub for accounts, stores, and remote ops.',
    ecosystemMallAppDlCapXhm: 'Device apps come next round. Install phone Leo first.',
    ecosystemMallAppDlStartPipeline: 'Start standard pipeline',
    ecosystemMallAppDlPipelineStarted: 'Standard pipeline started',
    ecosystemMallAppDlDeveloper: 'XRROSS',
    ecosystemMallAppDlCategory: 'Life · Human-machine · Store',
    ecosystemMallAppDlPlayBtn: 'Google Play',
    ecosystemMallAppDlIosBtn: 'App Store',
    ecosystemMallAppDlQrTitle: 'Scan to download',
    ecosystemMallAppDlQrHint: 'Scan opens the download page. iPhone → App Store. Android: overseas → Google Play; mainland China → this region’s node install.',
    ecosystemMallAppDlQrSave: 'Download QR',
    ecosystemMallAppDlQrOpen: 'Open download page',
    ecosystemMallAppDlShots: 'Preview',
    ecosystemMallAppDlShotVoice: 'Speak to brew',
    ecosystemMallAppDlShotTopo: 'Leo → SOC → machines',
    ecosystemMallAppDlShotLife: 'Human-machine in life',
    ecosystemMallAppDlShotWork: 'Work in the shop',
    ecosystemMallAppDlAbout: 'About',
    ecosystemMallAppDlAboutBody: 'Leo is the phone door into a human-machine lifestyle: you speak, in-store machines act. The phone talks to SOC; SOC talks to tea, coffee, and cup lines. Not a chatbot list — one topology for life, work, and business.',
    ecosystemMallAppDlFeatTalk: 'Speak to brew, check status, and talk to machines',
    ecosystemMallAppDlFeatTopo: 'Trinity: phone Leo → SOC hub → in-store machines',
    ecosystemMallAppDlFeatLife: 'Ordering, staff work, and owner ops all keep the machine in the room',
    ecosystemMallAppDlFeatOta: 'The APK is the same published OTA book; a release updates this page',
    ecosystemMallAppDlWhatsNew: 'What\'s new',
    ecosystemMallAppDlWhatsNewBody: 'This region published {ver}, the same package as the in-app update check.',
    ecosystemMallAppDlWhatsNewEmpty: 'No customer APK is published in this region yet.',
    ecosystemMallAppDlInfo: 'Information',
    ecosystemMallAppDlInfoDev: 'Developer',
    ecosystemMallAppDlInfoPkg: 'Package name',
    ecosystemMallAppDlInfoAge: 'Age rating',
    ecosystemMallAppDlAgeVal: '4+',
    ecosystemMallSocOps: 'Ops store',
    ecosystemMallPortraits: 'Customer portraits',
    ecosystemMallPortraitsDesc: 'Classify enterprises as equipment vendors or operators with scale, ops, and lifecycle for precise promo.',
    ecosystemMallPortraitsStatsTitle: 'Portrait stats',
    ecosystemMallPortraitsStatEntTotal: 'Enterprise portraits',
    ecosystemMallPortraitsStatUserTotal: 'User portraits',
    ecosystemMallPortraitsChartType: 'Enterprise · type mix',
    ecosystemMallPortraitsChartBrand: 'Enterprise · brand-tree context',
    ecosystemMallPortraitsChartHabit: 'Enterprise · habit domain hits',
    ecosystemMallPortraitsChartLifecycle: 'Enterprise · lifecycle segments',
    ecosystemMallPortraitsKpiOverrideRate: 'Override rate I-1',
    ecosystemMallPortraitsColHabit: 'Habit top',
    ecosystemMallPortraitsColCommercial: 'Commercial class',
    ecosystemMallPortraitsColScale: 'Scale (eq/store/active)',
    ecosystemMallPortraitsColLifecycle: 'Lifecycle',
    ecosystemMallPortraitsCommercialFilter: 'Commercial portrait',
    ecosystemMallPortraitsLifecycleFilter: 'Lifecycle',
    ecosystemMallPortraitsCommercialVendor: 'Equipment vendor',
    ecosystemMallPortraitsCommercialChain: 'Chain operator',
    ecosystemMallPortraitsLifecycleChampion: 'Champion',
    ecosystemMallPortraitsLifecycleGrowing: 'Growing',
    ecosystemMallPortraitsLifecycleStable: 'Stable',
    ecosystemMallPortraitsLifecycleAtRisk: 'At risk',
    ecosystemMallPortraitsLifecycleDormant: 'Dormant',
    ecosystemMallPortraitsScaleSummary: 'Eq {eq} / stores {kids} / active {days}d',
    ecosystemMallPortraitsExplainTitle: 'Why this type / segment',
    ecosystemMallPortraitsHabitProduce: 'Produce/recipe',
    ecosystemMallPortraitsHabitMaterial: 'Material/BOM',
    ecosystemMallPortraitsHabitDevice: 'Device fleet',
    ecosystemMallPortraitsHabitAfterSales: 'After-sales',
    ecosystemMallPortraitsHabitData: 'Analytics',
    ecosystemMallPortraitsHabitStore: 'Store ops',
    ecosystemMallPortraitsHabitHq: 'HQ/org',
    ecosystemMallPortraitsHabitMonetization: 'Monetization',
    ecosystemMallPortraitsHabitOther: 'Other',
    ecosystemMallPortraitsTabEnterprise: 'Enterprise',
    ecosystemMallPortraitsTabUser: 'Users',
    ecosystemMallPortraitsTypeFilter: 'Portrait type',
    ecosystemMallPortraitsStatusFilter: 'SOC tenant status',
    ecosystemMallPortraitsBrandCtxFilter: 'Brand tree context',
    ecosystemMallPortraitsColBrandCtx: 'Brand tree',
    ecosystemMallPortraitsStatusOemSelf: 'OEM self',
    ecosystemMallPortraitsStatusDistSelf: 'Distributor self',
    ecosystemMallPortraitsStatusSocBrand: 'Independent SOC brand',
    ecosystemMallPortraitsStatusDeviceCust: 'Customer under OEM',
    ecosystemMallPortraitsStatusUnknown: 'Unknown',
    ecosystemMallPortraitsBrandCtxRoot: 'Root / independent',
    ecosystemMallPortraitsBrandCtxPhysical: 'Under physical brand',
    ecosystemMallPortraitsBrandCtxOem: 'Under OEM',
    ecosystemMallPortraitsTypeOem: 'Equipment OEM',
    ecosystemMallPortraitsLeoXidInstalled: 'Leo App · X-IDs installed',
    ecosystemMallPortraitsLeoXidActive30d: 'Leo App · X-IDs active (30d)',
    ecosystemMallPortraitsColLeoApp: 'Leo App',
    ecosystemMallPortraitsLeoStatusActive: 'Active (30d)',
    ecosystemMallPortraitsLeoStatusInstalled: 'Installed',
    ecosystemMallPortraitsLeoStatusNotInstalled: 'Not installed',
    ecosystemMallPortraitsLeoEntSummary: 'Installed {installed} · Active {active}',
    ecosystemMallPortraitsLeoAppFilter: 'Leo App status',
    ecosystemMallPortraitsLeoPushBannerTitle: 'Round 1: promote Leo mobile smart assistant',
    ecosystemMallPortraitsLeoPushBannerDesc: 'Some customers have not installed Leo App yet. Share from App Downloads with the same free Xrross account.',
    ecosystemMallPortraitsLeoPushCta: 'App downloads',
    ecosystemMallAppDlSmartTitle: 'Leo mobile smart assistant',
    ecosystemMallAppDlShareColleague: 'Share with colleagues',
    ecosystemMallAppDlShareOk: 'Share card ready',
    ecosystemMallAppDlShareFail: 'Share failed — try again',
    ecosystemMallPortraitsTypeDistributor: 'Distributor',
    ecosystemMallPortraitsTypePhysical: 'Chain operator',
    ecosystemMallPortraitsReload: 'Reload',
    ecosystemMallPortraitsRecompute: 'Recompute',
    ecosystemMallPortraitsRecomputeOk: 'Recompute done',
    ecosystemMallPortraitsRecomputeFail: 'Recompute failed',
    ecosystemMallPortraitsLoadFail: 'Load failed',
    ecosystemMallPortraitsColName: 'Name',
    ecosystemMallPortraitsColAccount: 'Account',
    ecosystemMallPortraitsColEnterpriseId: 'Enterprise ID',
    ecosystemMallPortraitsColType: 'Type',
    ecosystemMallPortraitsColStatus: 'SOC tenant status',
    ecosystemMallPortraitsColConfidence: 'Confidence',
    ecosystemMallPortraitsColComputed: 'Computed at',
    ecosystemMallPortraitsColActions: 'Actions',
    ecosystemMallPortraitsSignals: 'Signals',
    ecosystemMallPortraitsOverride: 'Override',
    ecosystemMallPortraitsOverrideOk: 'Override locked',
    ecosystemMallPortraitsOverrideOkDetail: 'Locked as "{type}" (check Type column; OEM/Distributor both show as Equipment Vendor in Commercial)',
    ecosystemMallPortraitsOverrideFail: 'Override failed',
    ecosystemMallPortraitsLocked: 'Locked',
    ecosystemMallPortraitsUnlock: 'Unlock',
    ecosystemMallPortraitsUnlockConfirm: 'Unlock and recompute from org baseline?',
    ecosystemMallPortraitsUnlockOk: 'Unlocked and recomputed',
    ecosystemMallPortraitsUnlockFail: 'Unlock failed',
    ecosystemMallPortraitsColDeviceMode: 'Fleet usage',
    ecosystemMallPortraitsDeviceModeFilter: 'Fleet usage',
    ecosystemMallPortraitsDeviceNoFleet: 'No fleet',
    ecosystemMallPortraitsDeviceIdle: 'Idle fleet',
    ecosystemMallPortraitsDeviceOffline: 'Mostly offline',
    ecosystemMallPortraitsDeviceLowOut: 'Online, low output',
    ecosystemMallPortraitsDeviceHigh: 'High throughput',
    ecosystemMallPortraitsDeviceOps: 'Ops-heavy',
    ecosystemMallPortraitsDeviceFault: 'Fault watch',
    ecosystemMallPortraitsDeviceBalanced: 'Balanced',
    ecosystemMallPortraitsAdvice: 'Advice',
    ecosystemMallPortraitsAdviceTitle: 'Fleet advice (actionable)',
    ecosystemMallPortraitsAdviceNext: 'Next:',
    ecosystemMallPortraitsKpiAdviceP1: 'Priority advice',
    ecosystemMallPortraitsDeviceUsageSummary: 'Online {online}/{eq} · Cups {cups} · Ops {ops} · Idle {idle}',
    ecosystemMallImmersivePromo: 'Immersive promo',
    ecosystemMallAdOrchestrate: 'Ad orchestrate',
    ecosystemMallChannelCommand: 'Channel console',
    ecosystemMallBEndCrm: 'B-end CRM',
    ecosystemMallPromoContent: 'Promo content',
    ecosystemMallCompanyPay: 'Company Pay',
    ecosystemMallCompanyPayDesc: 'Overseas: Stripe primary, PayPal secondary; domestic WeChat separate. App/web sales land in company accounts. Stub is not real money.',
    ecosystemMallCompanyPayReload: 'Reload',
    ecosystemMallCompanyPayChannel: 'Source',
    ecosystemMallCompanyPayOrderNo: 'Order',
    ecosystemMallCompanyPaySku: 'SKU',
    ecosystemMallCompanyPayName: 'Name',
    ecosystemMallCompanyPayAmount: 'Amount',
    ecosystemMallCompanyPayStatus: 'Status',
    ecosystemMallCompanyPayEmail: 'Email',
    ecosystemMallCompanyPayTracking: 'Tracking',
    ecosystemMallCompanyPayAction: 'Action',
    ecosystemMallCompanyPayShip: 'Ship',
    ecosystemMallCompanyPayLedger: 'PayPal ledger',
    ecosystemMallCompanyPayIntent: 'Intent',
    ecosystemMallCompanyPaySurface: 'Surface',
    ecosystemMallCompanyPayRef: 'Local ref',
    ecosystemMallCompanyPayTime: 'Time',
    ecosystemMallCompanyPayCarrier: 'Carrier',
    ecosystemMallCompanyPayCancel: 'Cancel',
    ecosystemMallCompanyPayShipOk: 'Confirm ship',
    ecosystemMallHomeCheckoutTitle: 'Home checkout',
    ecosystemMallHomeCheckoutDesc: 'Choose a product, enter shipping details, then pay securely with PayPal. You will get an order confirmation by email.',
    ecosystemMallHomeCheckoutBackTopology: 'Back to topology',
    ecosystemMallHomeCheckoutReload: 'Reload',
    ecosystemMallHomeCheckoutNextAddress: 'Next: shipping address',
    ecosystemMallHomeCheckoutBackSku: 'Back to products',
    ecosystemMallHomeCheckoutPlaceOrder: 'Place order',
    ecosystemMallHomeCheckoutPayStripe: 'Pay with Stripe',
    ecosystemMallHomeCheckoutPayPaypal: 'Pay with PayPal',
    ecosystemMallHomeCheckoutCapture: 'Confirm paid (test)',
    ecosystemMallHomeCheckoutCaptureLive: 'I finished PayPal payment',
    ecosystemMallHomeCheckoutBuyPanel: 'Buy now',
    ecosystemMallHomeCheckoutEmptyCatalog: 'No products available for purchase yet',
    ecosystemMallHomeCheckoutSku: 'Product',
    ecosystemMallHomeCheckoutQty: 'Qty',
    ecosystemMallHomeCheckoutName: 'Receiver',
    ecosystemMallHomeCheckoutPhone: 'Phone',
    ecosystemMallHomeCheckoutEmail: 'Email',
    ecosystemMallHomeCheckoutAddress: 'Address',
    ecosystemMallHomeCheckoutCity: 'City',
    ecosystemMallHomeCheckoutPostal: 'Postal',
    ecosystemMallHomeCheckoutCountry: 'Country',
    ecosystemMallHomeCheckoutPayChannel: 'Pay method',
    ecosystemMallHomeCheckoutOrderLine: 'Order {no} · {status} · {amount}',
    ecosystemMallHomeCheckoutStubNote: 'Test mode (admin only): Confirm paid finishes acceptance — not live capture.',
    ecosystemMallHomeCheckoutStripeDefaultHint: 'Overseas default is Stripe (PayPal still available)',
    ecosystemMallHomeCheckoutStripeTabHint: 'Complete payment in the Stripe window; then check your order / email receipt.',
    ecosystemMallHomeCheckoutStripeOpened: 'Stripe opened — finish payment there',
    ecosystemMallHomeCheckoutPaypalTabHint: 'Complete payment in the PayPal window, then tap “I finished PayPal payment”.',
    ecosystemMallHomeCheckoutBuyAgain: 'Buy another',
    ecosystemMallHomeCheckoutHqOrders: 'Order ledger (HQ fulfillment)',
    ecosystemMallHomeCheckoutNoOrders: 'No orders',
    ecosystemMallHomeCheckoutWechat: 'WeChat Pay',
    ecosystemMallHomeCheckoutStepSku: 'Product',
    ecosystemMallHomeCheckoutStepAddress: 'Address',
    ecosystemMallHomeCheckoutStepPay: 'Pay',
    ecosystemMallHomeCheckoutStepDone: 'Done',
    ecosystemMallHomeCheckoutCoachSku: 'Choose a product',
    ecosystemMallHomeCheckoutCoachAddress: 'Enter shipping details',
    ecosystemMallHomeCheckoutCoachPay: 'Complete payment',
    ecosystemMallHomeCheckoutCoachDone: 'Paid',
    ecosystemMallHomeCheckoutHintSku: 'Select a product card to continue.',
    ecosystemMallHomeCheckoutHintAddress: 'We use your email for order confirmation and PayPal.',
    ecosystemMallHomeCheckoutHintPay: 'Pay with PayPal, then confirm when the payment window is done.',
    ecosystemMallHomeCheckoutNeedSku: 'Please select a product first',
    ecosystemMallHomeCheckoutCatalogFail: 'Could not load products. Please try again.',
    ecosystemMallHomeCheckoutSkuNoPrice: 'This product has no list price yet. Leave an intent to discuss, or pick another SKU.',
    ecosystemMallHomeCheckoutHqFail: 'Ledger load failed (non-admin OK to ignore)',
    ecosystemMallHomeCheckoutNeedName: 'Receiver name required',
    ecosystemMallHomeCheckoutNeedPhone: 'Phone required',
    ecosystemMallHomeCheckoutNeedEmail: 'Please enter a valid email',
    ecosystemMallHomeCheckoutNeedAddress: 'Address required',
    ecosystemMallHomeCheckoutNeedCity: 'City required',
    ecosystemMallHomeCheckoutNeedCountry: 'Country required',
    ecosystemMallHomeCheckoutNeedLogin: 'Please sign in to continue checkout',
    ecosystemMallHomeCheckoutOrderCreated: 'Order created — continue to payment',
    ecosystemMallHomeCheckoutOrderFail: 'Could not create the order. Please check your details and try again.',
    ecosystemMallHomeCheckoutNeedOrder: 'Create an order first',
    ecosystemMallHomeCheckoutPaypalStub: 'Test PayPal ready — confirm paid (admin)',
    ecosystemMallHomeCheckoutPaypalOpened: 'PayPal opened — finish payment there',
    ecosystemMallHomeCheckoutPaid: 'Payment received — thank you!',
    ecosystemMallHomeCheckoutPaidThanks: 'Order {no} is paid. We emailed {email}. Shipping updates will follow.',
    ecosystemMallHomeCheckoutStatusPaid: 'Paid',
    ecosystemMallHomeCheckoutStatusPending: 'Awaiting payment',
    ecosystemMallHomeCheckoutStatusShipped: 'Shipped',
    ecosystemMallHomeCheckoutCaptureFail: 'Could not confirm payment yet. If you paid on PayPal, wait a moment and try again.',
    ecosystemMallHomeCheckoutPayFail: 'Payment could not start. Please try again.',
    ecosystemMallHomeCheckoutWechatFail: 'WeChat Pay unavailable',
    ecosystemMallHomeCheckoutNeedTracking: 'Tracking number required',
    ecosystemMallHomeCheckoutShipFail: 'Ship failed',
    ecosystemMallCompanyPayLive: 'PayPal credentials configured (sandbox/live)',
    ecosystemMallCompanyPayLiveMode: 'PayPal Live — real money',
    ecosystemMallCompanyPaySandboxMode: 'PayPal Sandbox — test only',
    ecosystemMallCompanyPayStub: 'Stub mode — not real money',
    ecosystemMallCompanyPayLoadFail: 'Load failed (admin required)',
    ecosystemMallCompanyPayNeedTracking: 'Tracking number required',
    ecosystemMallCompanyPayShipped: 'Marked shipped',
    ecosystemMallCompanyPayShipFail: 'Ship failed',
    ecosystemMallCompanyPayEmptyOrders: 'No sales orders',
    ecosystemMallCompanyPayEmptyLedger: 'No pay ledger rows',
    ecosystemMallCompanyPayStubCol: 'Stub?',
    ecosystemMallCompanyPayStubYes: 'Yes (stub)',
    ecosystemMallCompanyPayKindHome: 'Home App',
    ecosystemMallCompanyPayKindWebsite: 'Website',
    ecosystemMallCompanyPayStatusPending: 'Pending pay',
    ecosystemMallCompanyPayStatusPaid: 'Paid',
    ecosystemMallCompanyPayStatusShipped: 'Shipped',
    ecosystemMallCompanyPayStatusDelivered: 'Delivered',
    ecosystemMallCompanyPayStatusBound: 'Bound',
    ecosystemMallCompanyPayStatusCancelled: 'Cancelled',
    ecosystemMallCompanyPayIntentCreated: 'Created',
    ecosystemMallCompanyPayIntentApproved: 'Approved',
    ecosystemMallCompanyPayIntentCaptured: 'Captured',
    ecosystemMallCompanyPayIntentCapturedStub: 'Stub captured',
    ecosystemMallCompanyPayIntentFailed: 'Failed',
    ecosystemMallCompanyPaySurfaceHome: 'Home checkout',
    ecosystemMallCompanyPaySurfaceWebsite: 'Web checkout',
    ecosystemMallCompanyPaySurfaceAddon: 'SOC add-on',
    ecosystemMallCompanyPaySurfacePlan: 'Business plan',
    ecosystemMallCompanyPaySurfaceContract: 'Brand contract',
    ecosystemMallPriceBook: 'Price Book',
    ecosystemMallBillingPromo: 'Billing promotions',
    ecosystemMallBillingPromoDesc: 'Define brand billing promotions and issue coupons to selected brands. List prices remain in the Price Book; coupons apply only at checkout.',
    ecosystemMallBillingPromoHqOnly: 'Billing promotions are HQ-only. Brand users: open Service Contract for agreements and payment.',
    ecosystemMallBillingPromoReload: 'Reload',
    ecosystemMallBillingPromoNewCampaign: 'New promotion',
    ecosystemMallBillingPromoNlCompose: 'Describe in words',
    ecosystemMallBillingPromoNlComposeTitle: 'Natural-language promo',
    ecosystemMallBillingPromoNlComposeHint: 'Example: brand 1119 addon Track B save CNY 1000, valid 30 days after issue. Review the form before saving.',
    ecosystemMallBillingPromoNlComposePh: 'Describe offer, audience, redeem target, validity…',
    ecosystemMallBillingPromoNlComposeParse: 'Parse preview',
    ecosystemMallBillingPromoNlComposeApply: 'Fill form',
    ecosystemMallBillingPromoNlComposeSummary: 'Summary',
    ecosystemMallBillingPromoNlComposeConfidence: 'Confidence',
    ecosystemMallBillingPromoNlComposeWarnings: 'Review',
    ecosystemMallBillingPromoEditCampaign: 'Edit promotion',
    ecosystemMallBillingPromoTabCampaigns: 'Promotions',
    ecosystemMallBillingPromoTabCoupons: 'Issued coupons',
    ecosystemMallBillingPromoColName: 'Promotion name',
    ecosystemMallBillingPromoColKind: 'Promotion type',
    ecosystemMallBillingPromoColOffer: 'Discount type',
    ecosystemMallBillingPromoColAudience: 'Eligible brands',
    ecosystemMallBillingPromoColStatus: 'Status',
    ecosystemMallBillingPromoColCouponCode: 'Coupon number',
    ecosystemMallBillingPromoColCampaign: 'Promotion',
    ecosystemMallBillingPromoColIssued: 'Issued at',
    ecosystemMallBillingPromoActivate: 'Activate',
    ecosystemMallBillingPromoPause: 'Pause',
    ecosystemMallBillingPromoIssue: 'Issue coupon',
    ecosystemMallBillingPromoRevoke: 'Revoke',
    ecosystemMallBillingPromoManualIssue: 'Manual issue',
    ecosystemMallBillingPromoBrandId: 'Brand',
    ecosystemMallBillingPromoBrandIdPh: 'Enter brand ID',
    ecosystemMallBillingPromoBrandIds: 'Selected brands',
    ecosystemMallBillingPromoBrandIdsHint: 'Separate multiple IDs with commas',
    ecosystemMallBillingPromoFilterCampaign: 'Filter by promotion',
    ecosystemMallBillingPromoFilterStatus: 'Filter by status',
    ecosystemMallBillingPromoSearch: 'Search',
    ecosystemMallBillingPromoOfferPct: 'Discount rate (%)',
    ecosystemMallBillingPromoCampaignValidity: 'Promotion period',
    ecosystemMallBillingPromoCouponValidity: 'Coupon validity',
    ecosystemMallBillingPromoRelativeDays: 'Valid days after issue',
    ecosystemMallBillingPromoNamePh: 'e.g. New customer 20% off',
    ecosystemMallBillingPromoNameRequired: 'Promotion name is required',
    ecosystemMallBillingPromoEmpty: 'No data',
    ecosystemMallBillingPromoSaved: 'Promotion saved',
    ecosystemMallBillingPromoIssued: 'Coupon issued',
    ecosystemMallBillingPromoRevoked: 'Coupon revoked',
    ecosystemMallBillingPromoStatusUpdated: 'Promotion status updated',
    ecosystemMallBillingPromoEnum_status_ALL: 'All',
    ecosystemMallBillingPromoEnum_status_DRAFT: 'Draft',
    ecosystemMallBillingPromoEnum_status_ACTIVE: 'Active',
    ecosystemMallBillingPromoEnum_status_PAUSED: 'Paused',
    ecosystemMallBillingPromoEnum_status_ARCHIVED: 'Archived',
    ecosystemMallBillingPromoEnum_status_EXPIRED: 'Expired',
    ecosystemMallBillingPromoEnum_couponStatus_ALL: 'All',
    ecosystemMallBillingPromoEnum_couponStatus_ISSUED: 'Issued',
    ecosystemMallBillingPromoEnum_couponStatus_REDEEMED: 'Redeemed',
    ecosystemMallBillingPromoEnum_couponStatus_EXPIRED: 'Expired',
    ecosystemMallBillingPromoEnum_couponStatus_REVOKED: 'Revoked',
    ecosystemMallBillingPromoEnum_kind_STANDARD_PACK: 'Standard package',
    ecosystemMallBillingPromoEnum_kind_SEASONAL: 'Seasonal sale',
    ecosystemMallBillingPromoEnum_kind_TARGETED: 'Targeted account',
    ecosystemMallBillingPromoEnum_kind_AI_ORCHESTRATED: 'Smart promotion',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_PCT: 'Percentage off',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_FIXED: 'Fixed amount off',
    ecosystemMallBillingPromoEnum_offer_BUNDLE_PRICE_CAP: 'Bundle price cap',
    ecosystemMallBillingPromoEnum_offer_FREE_TRIAL_EXTEND: 'Extended trial',
    ecosystemMallBillingPromoEnum_offer_CROSS_GRANT: 'Cross-sell coupon',
    ecosystemMallBillingPromoEnum_offer_AI_POINTS_BONUS: 'Bonus AI points',
    ecosystemMallBillingPromoEnum_audience_ALL_ELIGIBLE_BRANDS: 'All eligible brands',
    ecosystemMallBillingPromoEnum_audience_BRAND_ALLOWLIST: 'Allowlisted brands',
    ecosystemMallBillingPromoEnum_audience_BRAND_DENYLIST: 'Denylist excluded',
    ecosystemMallBillingPromoEnum_audience_PORTRAIT_QUERY: 'By customer portrait',
    ecosystemMallBillingPromoEnum_audience_AI_AGENT: 'Smart selection',
    ecosystemMallBillingPromoEnum_audience_HYBRID: 'Rules + smart mix',
    ecosystemMallBillingPromoEnum_campaignValidity_PERMANENT: 'Permanent',
    ecosystemMallBillingPromoEnum_campaignValidity_FIXED_WINDOW: 'Fixed date range',
    ecosystemMallBillingPromoEnum_couponValidity_PERMANENT_UNTIL_REDEEMED: 'Until redeemed',
    ecosystemMallBillingPromoEnum_couponValidity_RELATIVE_FROM_ISSUE: 'N days after issue',
    ecosystemMallBillingPromoEnum_couponValidity_INHERIT_CAMPAIGN: 'Same as promotion',
    ecosystemMallBillingPromoSectionOffer: 'Offer details',
    ecosystemMallBillingPromoSectionAudience: 'Target audience',
    ecosystemMallBillingPromoSectionCrossSell: 'Cross-sell',
    ecosystemMallBillingPromoRedeemTarget: 'Redeem at',
    ecosystemMallBillingPromoGrantScope: 'Coupon binding',
    ecosystemMallBillingPromoTriggerEvent: 'Auto trigger',
    ecosystemMallBillingPromoAutoIssue: 'Auto-issue when condition met',
    ecosystemMallBillingPromoTracksMissing: 'Missing product line (cross-sell)',
    ecosystemMallBillingPromoUserIds: 'Target user accounts',
    ecosystemMallBillingPromoUserIdsHint: 'Comma-separated user IDs for 1:1 personalized coupons',
    ecosystemMallBillingPromoColGrantScope: 'Binding scope',
    ecosystemMallBillingPromoColUser: 'User account',
    ecosystemMallBillingPromoColRedeemTarget: 'Redeem at',
    ecosystemMallBillingPromoUserIdPh: 'User ID (optional)',
    ecosystemMallBillingPromoOfferFixed: 'Fixed discount amount',
    ecosystemMallBillingPromoTrialDays: 'Trial extension (days)',
    ecosystemMallBillingPromoBonusPoints: 'Bonus AI points',
    ecosystemMallBillingPromoBundleCap: 'Bundle price cap',
    ecosystemMallBillingPromoBundleSkus: 'Bundle SKUs',
    ecosystemMallBillingPromoCrossGrantSku: 'Cross-grant SKU',
    ecosystemMallBillingPromoCrossGrantHint: 'e.g. Track B active → issue device or Leo add-on coupon',
    ecosystemMallBillingPromoEnum_audience_USER_ALLOWLIST: 'User allowlist',
    ecosystemMallBillingPromoEnum_redeemTarget_ANY_BILLING_CHECKOUT: 'Unified checkout',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_A_CONTRACT: 'Track A device data contract',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_B_ADDON: 'Track B SOC / Leo add-on',
    ecosystemMallBillingPromoEnum_redeemTarget_HARDWARE_ORDER: 'Hardware order',
    ecosystemMallBillingPromoEnum_grantScope_BRAND: 'Brand-wide pool',
    ecosystemMallBillingPromoEnum_grantScope_ENTERPRISE_NODE: 'Org node',
    ecosystemMallBillingPromoEnum_grantScope_STORE: 'Single store',
    ecosystemMallBillingPromoEnum_grantScope_USER: 'Single user account',
    ecosystemMallBillingPromoEnum_grantScope_PORTRAIT_COHORT: 'Portrait cohort',
    ecosystemMallBillingPromoEnum_trigger_MANUAL_HQ: 'HQ manual',
    ecosystemMallBillingPromoEnum_trigger_TRACK_A_ACTIVE: 'Track A contract active',
    ecosystemMallBillingPromoEnum_trigger_TRACK_B_ACTIVE: 'Track B add-on active',
    ecosystemMallBillingPromoEnum_trigger_HARDWARE_PAID: 'Hardware paid',
    ecosystemMallBillingPromoEnum_trigger_AI_ISSUE: 'Smart promo issue',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_A: 'Track A not active',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_B: 'Track B not active',
    mySubscriptionPlan: 'My Plan',
    mySubscriptionPlanDesc: 'Signed tier summary and A/B lines; contracts and payment on the desk—pricing and promos in Ecosystem Mall.',
    mySubscriptionPlanGoContract: 'Open contract desk',
    mySubscriptionPlanGoMall: 'View pricing in mall',
    mySubscriptionPlanGoPriceBook: 'HQ price book',
    mySubscriptionPlanTiersTitle: 'Four monthly tiers (USD)',
    mySubscriptionPlanTierCol: 'Tier',
    mySubscriptionPlanSceneCol: 'Scenario',
    mySubscriptionPlanPriceCol: 'Monthly',
    mySubscriptionPlanTrackCol: 'Track',
    mySubscriptionPlanTier1Scene: 'SOC only, no auto production devices',
    mySubscriptionPlanTier2Scene: 'Store bundle (SOC + all auto devices, unlimited units)',
    mySubscriptionPlanTier3Scene: 'Device data only, no SOC store ops',
    mySubscriptionPlanTier3Price: 'Per device / mo (tea/coffee/drink $10, PT5 $5)',
    mySubscriptionPlanTier4Scene: 'SOC + devices (not $199 bundle)',
    mySubscriptionPlanHint: 'Tiers ② and ④ are mutually exclusive per store; contract desk is source of truth for signing; mall is source for list prices and promos.',
    subscriptionBillingFolder: 'Subscription & Billing',
    deviceEndpointDataFolder: 'Device endpoint data',
    mallPricingCollectFolder: 'Pricing & collect',
    ecosystemMallPriceBookDesc: 'List-price source of truth. Only Tokyo HQ can edit ex-tax prices and tax regions; edge nodes are read-only mirrors. PayPal uses USD; WeChat uses CNY.',
    ecosystemMallPriceBookEdgeBanner: 'List prices are unified at Tokyo HQ. This node is a read-only mirror; if Tokyo is down, selling uses the last fan-out. Do not add or edit prices here.',
    ecosystemMallPriceBookTokyoBanner: 'This node is the global write center. Saving ex-tax prices or tax regions fans out to 111 and enrolled regions.',
    ecosystemMallPriceBookReload: 'Reload',
    ecosystemMallPriceBookRefreshFx: 'Refresh FX',
    ecosystemMallPriceBookFxNote: 'FX {asOf} · {src} (1 USD)',
    ecosystemMallPriceBookFxTaxPanel: 'FX & tax · {fx} · {taxCount} regions',
    ecosystemMallPriceBookFxSection: 'USD rates',
    ecosystemMallPriceBookStale: 'FX older than 48h — refresh or wait for the daily pull',
    ecosystemMallPriceBookCoverageGap: '{count} feature(s) or device type(s) are not priced in the price book (OFF/missing). Contracts and add-ons will be blocked until HQ enables pricing.',
    ecosystemMallPriceBookCcy: 'CCY',
    ecosystemMallPriceBookRatePerUsd: 'Per 1 USD',
    ecosystemMallPriceBookSkus: 'SKU list prices',
    ecosystemMallPriceBookKind: 'Kind',
    ecosystemMallPriceBookSku: 'SKU',
    ecosystemMallPriceBookName: 'Name',
    ecosystemMallPriceBookList: 'List',
    ecosystemMallPriceBookListExTax: 'List (ex-tax)',
    ecosystemMallPriceBookExTaxBanner: 'One global ex-tax list price; node tax rates live in Tax regions and are added at quote time.',
    ecosystemMallPriceBookTaxRegions: 'Tax regions (local add-on)',
    ecosystemMallPriceBookTaxRegionsHint: 'Price book is ex-tax. CN=software 6%, CN_HW=hardware 13%; pick a region on the contract desk to add tax.',
    ecosystemMallPriceBookTaxRegionCode: 'Region',
    ecosystemMallPriceBookTaxRegionName: 'Name',
    ecosystemMallPriceBookTaxName: 'Tax type',
    ecosystemMallPriceBookTaxRate: 'Rate',
    ecosystemMallPriceBookTaxNotes: 'Notes',
    ecosystemMallPriceBookTaxEditTitle: 'Edit tax region',
    ecosystemMallPriceBookLoadFail: 'Load failed (admin required)',
    ecosystemMallPriceBookRefreshOk: 'FX updated',
    ecosystemMallPriceBookRefreshFail: 'FX refresh failed',
    ecosystemMallPriceBookAdd: 'Add',
    ecosystemMallPriceBookEdit: 'Edit',
    ecosystemMallPriceBookSave: 'Save',
    ecosystemMallPriceBookSaveOk: 'Saved',
    ecosystemMallPriceBookSaveFail: 'Save failed',
    ecosystemMallPriceBookKindAddon: 'Addon',
    ecosystemMallPriceBookKindHome: 'Home hardware',
    ecosystemMallPriceBookKindCommercial: 'Commercial hardware',
    ecosystemMallPriceBookListCcy: 'List CCY',
    ecosystemMallPriceBookListedHkd: 'Catalog HKD',
    ecosystemMallPriceBookColumnPricing: 'Pricing',
    ecosystemMallPriceBookPricingSection: 'Pricing model',
    ecosystemMallPriceBookPaymentSection: 'Payment templates',
    ecosystemMallPriceBookProductClass: 'Product class',
    ecosystemMallPriceBookProductSoc: 'SOC software',
    ecosystemMallPriceBookProductDeviceData: 'Device data / backend',
    ecosystemMallPriceBookProductHardware: 'Hardware',
    ecosystemMallPriceBookProductAiPoints: 'AI points',
    ecosystemMallPriceBookBillingCycle: 'Billing cycle',
    ecosystemMallPriceBookUnitPrice: 'Unit price',
    ecosystemMallPriceBookMinContractMonths: 'Min contract months',
    ecosystemMallPriceBookDayCountHint: 'Daily pay-as-you-go',
    ecosystemMallPriceBookDayCountHintBody: 'Enter days on the contract; price book stores the daily unit price only.',
    ecosystemMallPriceBookTiers: 'Tier prices',
    ecosystemMallPriceBookDeviceCountTiers: 'Device-count tier discounts',
    ecosystemMallPriceBookDeviceCountTiersHint: 'Base unit price is this row list price; tier factors apply to that base. Missing unit price = 0.',
    ecosystemMallPriceBookDeviceCountTierBand: 'Band',
    ecosystemMallPriceBookDeviceCountTierMin: 'Min devices',
    ecosystemMallPriceBookDeviceCountTierMax: 'Max devices',
    ecosystemMallPriceBookDeviceCountTierDiscount: 'Discount factor',
    ecosystemMallPriceBookDeviceCountTierNegotiated: 'HQ negotiated',
    ecosystemMallPriceBookDeviceCountTierReset: 'Reset to standard 5 bands',
    ecosystemMallPriceBookStoreCountTiers: 'Store-count tier discount',
    ecosystemMallPriceBookStoreCountTiersHint: 'Per-store base = this row list price; discounts apply to that base. 0 stores = $0.',
    ecosystemMallPriceBookStoreCountTierBand: 'Band',
    ecosystemMallPriceBookStoreCountTierMin: 'Min stores',
    ecosystemMallPriceBookStoreCountTierMax: 'Max stores',
    ecosystemMallPriceBookStoreCountTierDiscount: 'Discount factor',
    ecosystemMallPriceBookStoreCountTierNegotiated: 'HQ negotiated',
    ecosystemMallPriceBookStoreCountTierReset: 'Reset to standard 5 bands',
    ecosystemMallPriceBookAddTier: 'Add tier',
    ecosystemMallPriceBookRemoveTier: 'Remove',
    ecosystemMallPriceBookTrialDays: 'Trial days',
    ecosystemMallPriceBookCancelAnytime: 'Cancel anytime',
    ecosystemMallPriceBookDefaultPayment: 'Default payment',
    ecosystemMallPriceBookPayNet: 'Net terms',
    ecosystemMallPriceBookPayPrepaid: 'Prepaid',
    ecosystemMallPriceBookPayDeposit: 'Deposit + balance',
    ecosystemMallPriceBookPayInstallment: 'Installment',
    ecosystemMallPriceBookDepositPct: 'Deposit %',
    ecosystemMallPriceBookStatus: 'Status',
    ecosystemMallPriceBookStatusActive: 'Active',
    ecosystemMallPriceBookStatusOff: 'Off',
    ecosystemMallPriceBookNameZh: 'Name (CN)',
    ecosystemMallPriceBookNameTw: 'Name (TW)',
    ecosystemMallPriceBookNameEn: 'Name (EN)',
    ecosystemMallPriceBookNameJa: 'Name (JA)',
    ecosystemMallPriceBookCancel: 'Cancel',
    ecosystemMallPriceBookFilterPreset: 'Quick filters',
    ecosystemMallPriceBookPresentationTab: 'Customer blocks L0–L6',
    ecosystemMallPriceBookPresentationTabAll: 'All',
    ecosystemMallPriceBookBlock_FREE_INCLUDED: 'L0 · Included with hardware',
    ecosystemMallPriceBookBlock_BUNDLE_TIER: 'L1 · Monthly bundles',
    ecosystemMallPriceBookBlock_TRACK_A: 'L2 · Device data',
    ecosystemMallPriceBookBlock_TRACK_B: 'L3 · Store ops',
    ecosystemMallPriceBookBlock_BUNDLE_DISCOUNT: 'L4 · Bundle rules',
    ecosystemMallPriceBookBlock_HARDWARE: 'L5 · Hardware',
    ecosystemMallPriceBookBlock_AI_POINTS: 'L6 · AI points',
    ecosystemMallPriceBookBlockDesc_FREE_INCLUDED: 'Already included with machine/store: Leo basics and base store ops visibility at no extra monthly fee.',
    ecosystemMallPriceBookBlockDesc_BUNDLE_TIER: 'Four monthly bundle tiers: customer picks a plan, then see linked SKU list prices below.',
    ecosystemMallPriceBookBlockDesc_TRACK_A: 'Track A · per-device cloud/data monthly fees (tea, coffee, etc.).',
    ecosystemMallPriceBookBlockDesc_TRACK_B: 'Track B · per-store SOC add-ons (store ops plus, HQ, integrations, analytics).',
    ecosystemMallPriceBookBlockDesc_BUNDLE_DISCOUNT: 'Mutual exclusion and upgrade rules: tier ② full-store vs ④ SOC+per-device — one per store per term.',
    ecosystemMallPriceBookBlockDesc_HARDWARE: 'One-time hardware list prices (not monthly).',
    ecosystemMallPriceBookBlockDesc_AI_POINTS: 'Usage-based AI point packs.',
    ecosystemMallPriceBookBundleColTier: 'Tier',
    ecosystemMallPriceBookBundleColPlan: 'Plan',
    ecosystemMallPriceBookBundleColScenario: 'Scenario',
    ecosystemMallPriceBookBundleColIncludes: 'Includes',
    ecosystemMallPriceBookBundleT1Title: '① SOC only $49/store/mo',
    ecosystemMallPriceBookBundleT1Desc: 'SOC/store ops without automated production equipment',
    ecosystemMallPriceBookBundleT1Includes: 'Standard SOC ops modules; no Track A device data',
    ecosystemMallPriceBookBundleT2Title: '② Full store $199/store/mo',
    ecosystemMallPriceBookBundleT2Desc: 'Store with automated beverage production; unlimited devices in store',
    ecosystemMallPriceBookBundleT2Includes: 'SOC + all automated production device data fees in that store',
    ecosystemMallPriceBookBundleT3Title: '③ Devices only per unit',
    ecosystemMallPriceBookBundleT3Desc: 'Cloud connectivity only, no SOC store bundle',
    ecosystemMallPriceBookBundleT3Includes: 'Track A device data monthly fees only; no SOC',
    ecosystemMallPriceBookBundleT3PriceHint: 'Per-device monthly (see SKUs)',
    ecosystemMallPriceBookBundleT4Title: '④ SOC $99 + per device',
    ecosystemMallPriceBookBundleT4Desc: 'Both SOC and devices, not using $199 full-store bundle',
    ecosystemMallPriceBookBundleT4Includes: '$99/store/mo SOC base + per-device data fees',
    ecosystemMallPriceBookBundleRuleT2T4Title: '② vs ④ — one per store',
    ecosystemMallPriceBookBundleRuleT2T4Body: 'Same store, same billing period: either $199 all-in OR $99 base + per-device fees — not both.',
    ecosystemMallPriceBookBundleRuleUpgradeTitle: 'Upgrade paths',
    ecosystemMallPriceBookBundleRuleUpgradeBody: '① SOC-only later adds production devices → upgrade to ④ or ②; ③ devices-only adds SOC → move to ④ or ② if eligible.',
    ecosystemMallPriceBookBundleRulePromoTitle: '① Promotional price',
    ecosystemMallPriceBookBundleRulePromoBody: '$49 is promotional; standard price may apply after campaign (listed separately in HQ price book).',
    ecosystemMallPriceBookBundleRuleDeviceScopeTitle: 'What counts for ② $199',
    ecosystemMallPriceBookBundleRuleDeviceScopeBody: 'Included: tea/coffee/dispenser/blender/Maestro automated production; excluded: kiosk, signage, cashier, queue, IVI, etc.; Cloud Iris B-line add-ons priced separately.',
    ecosystemMallPriceBookQuoteSectionTab: 'Quote blocks',
    ecosystemMallPriceBookQuoteTabAll: 'All',
    ecosystemMallPriceBookQuoteTabA: 'Block A · Device data',
    ecosystemMallPriceBookQuoteTabB: 'Block B · Store ops',
    ecosystemMallPriceBookQuoteTabC: 'Block C · Bundles',
    ecosystemMallPriceBookQuoteTabOther: 'Hardware / points',
    ecosystemMallPriceBookQuoteSectionCol: 'Quote section',
    ecosystemMallPriceBookQuoteSection_TRACK_A_DEVICE_DATA: 'A · Device data',
    ecosystemMallPriceBookQuoteSection_TRACK_B_STORE_OPS: 'B · Store ops',
    ecosystemMallPriceBookQuoteSection_TRACK_B_HQ: 'B · HQ',
    ecosystemMallPriceBookQuoteSection_TRACK_B_ANALYTICS: 'B · Analytics',
    ecosystemMallPriceBookQuoteSection_TRACK_B_INTEGRATION: 'B · Integration',
    ecosystemMallPriceBookQuoteSection_TRACK_B_DEVICE_ADDON: 'B · Device add-on',
    ecosystemMallPriceBookQuoteSection_BUNDLE_FULL_STACK: 'C · Full-store bundle',
    ecosystemMallPriceBookQuoteSection_HARDWARE: 'Hardware',
    ecosystemMallPriceBookQuoteSection_AI_POINTS: 'AI points',
    ecosystemMallPriceBookQuoteSection_FREE_INCLUDED: 'Included with device',
    ecosystemMallPriceBookFilterSearch: 'Search',
    ecosystemMallPriceBookFilterSearchPh: 'SKU, name, keyword',
    ecosystemMallPriceBookFilterSegment: 'Segment',
    ecosystemMallPriceBookFilterSegmentAll: 'All segments',
    ecosystemMallPriceBookSegmentHome: 'Home',
    ecosystemMallPriceBookSegmentCommercial: 'Commercial',
    ecosystemMallPriceBookSegmentAll: 'Universal',
    ecosystemMallPriceBookFilterCategory: 'Product family',
    ecosystemMallPriceBookFilterCategoryAll: 'All families',
    ecosystemMallPriceBookCatHomeHardware: 'Home hardware',
    ecosystemMallPriceBookCatHomeAddon: 'Home add-ons',
    ecosystemMallPriceBookCatCommercialHardware: 'Commercial hardware',
    ecosystemMallPriceBookCatCommercialStoreOps: 'Store ops modules',
    ecosystemMallPriceBookCatCommercialHq: 'HQ multi-store',
    ecosystemMallPriceBookCatCommercialIntegration: 'Payments integration',
    ecosystemMallPriceBookCatCommercialAiData: 'AI / analytics',
    ecosystemMallPriceBookCatCommercialOther: 'Other commercial',
    ecosystemMallPriceBookCatAiPoints: 'AI points packs',
    ecosystemMallPriceBookCatUniversal: 'Universal add-ons',
    ecosystemMallPriceBookCatOther: 'Other',
    ecosystemMallPriceBookFilterStatusAll: 'All statuses',
    ecosystemMallPriceBookFilterKindAll: 'All kinds',
    ecosystemMallPriceBookFilterCurrencyAll: 'All currencies',
    ecosystemMallPriceBookFilterPricing: 'Pricing model',
    ecosystemMallPriceBookFilterPricingAll: 'All pricing',
    ecosystemMallPriceBookFilterPriceBand: 'Price band',
    ecosystemMallPriceBookFilterPriceBandAll: 'All bands',
    ecosystemMallPriceBookPriceBandFree: 'Free (0 CNY)',
    ecosystemMallPriceBookPriceBandLow: 'Entry (<500 CNY)',
    ecosystemMallPriceBookPriceBandMid: 'Standard (500–3000)',
    ecosystemMallPriceBookPriceBandHigh: 'Premium (>3000)',
    ecosystemMallPriceBookFilterClear: 'Clear filters',
    ecosystemMallPriceBookFilterSelectAll: 'Select all',
    ecosystemMallPriceBookFilterClearAll: 'Clear',
    ecosystemMallPriceBookFilterMultiAll: 'All (multi)',
    ecosystemMallPriceBookFilterResult: 'Showing {shown} of {total}',
    ecosystemMallPriceBookPresetAll: 'All',
    ecosystemMallPriceBookPresetHomeHardware: 'Home hardware',
    ecosystemMallPriceBookPresetHomeAddon: 'Home add-ons',
    ecosystemMallPriceBookPresetCommercialHardware: 'Commercial hardware',
    ecosystemMallPriceBookPresetCommercialSoftware: 'Commercial software',
    ecosystemMallPriceBookPresetAiPoints: 'AI points',
    ecosystemMallPriceBookPresetActiveOnly: 'Active only',
    ecosystemMallPriceBookColumnSegment: 'Segment',
    ecosystemMallPriceBookColumnCategory: 'Family',
    ecosystemMallPriceBookPricingTrialThenPaid: 'Trial then paid',
    ecosystemMallPriceBookPricingAiPointsPack: 'AI points pack',
    ecosystemMallPriceBookPricingPerDeviceYear: 'Per device / year',
    ecosystemMallPriceBookPricingPerDeviceMonth: 'Per device / month',
    ecosystemMallPriceBookPricingPerDeviceDay: 'Per device / day (PAYG)',
    ecosystemMallPriceBookPricingPerDevicePeriod: 'Per device / period',
    ecosystemMallPriceBookPricingPerStoreMonth: 'Per store / month',
    ecosystemMallPriceBookPricingPerStoreDay: 'Per store / day (PAYG)',
    ecosystemMallPriceBookPricingTieredAnnualPool: 'Tiered annual pool',
    ecosystemMallPriceBookPricingSocStoreSubscription: 'SOC store subscription',
    ecosystemMallPriceBookDeviceScope: 'Billing scope',
    ecosystemMallPriceBookDeviceFamily: 'Device family',
    ecosystemMallPriceBookModelKey: 'Model key',
    ecosystemMallPriceBookModelKeyPh: 'e.g. PT5, X600H (family or model; model wins)',
    ecosystemMallPriceBookModelKeyShort: 'Model {key}',
    ecosystemMallPriceBookDeviceScopeHint: 'Device data fees must specify a device family or model key so contracts can count the right devices.',
    ecosystemMallPriceBookDeviceScopeRequired: 'Enter device family or model key',
    ecosystemMallPriceBookDeviceFamilyTeaMachine: 'Tea brewer',
    ecosystemMallPriceBookDeviceFamilyCoffeeMachine: 'Coffee machine',
    ecosystemMallPriceBookDeviceFamilyDispenser: 'Dispenser',
    ecosystemMallPriceBookDeviceFamilyKiosk: 'Kiosk',
    ecosystemMallPriceBookDeviceFamilySignage: 'Signage',
    ecosystemMallPriceBookPricingPerStoreYear: 'Per store / year',
    ecosystemMallPriceBookPricingPerHouseholdYear: 'Per household / year',
    ecosystemMallPriceBookPricingOneTimeSku: 'One-time',
    ecosystemMallPriceBookPricingModuleAddon: 'Module add-on',
    ecosystemMallPriceBookPricingCustomQuote: 'Custom quote',
    ecosystemMallCommerceMatrix: 'Commerce matrix',
    ecosystemMallCommerceMatrixDesc: 'SKU domain packs, menu classification, pricing and health; unassigned pages hidden from tenants.',
    ecosystemMallCommerceMatrixEdgeBanner: 'Domain packs and menu binding are unified at Tokyo HQ. This node is a read-only mirror; if Tokyo is down, use the last fan-out. Do not add here.',
    ecosystemMallCommerceMatrixTokyoBanner: 'This node is the global write center. Binding menus, audience, or new domain packs fans out to 111 and enrolled regions.',
    ecosystemMallCommerceMatrixReload: 'Reload',
    ecosystemMallCommerceMatrixOpenPriceBook: 'Price book',
    ecosystemMallCommerceMatrixBlockerHint: 'Unassigned or missing-price items remain; fix before go-live.',
    ecosystemMallCommerceMatrixPassHint: 'Commerce matrix health check passed.',
    ecosystemMallCommerceMatrixHealthSummary: 'Unassigned pages {unassigned} · Blockers {blockers} · Arch mismatch {archMismatch}',
    ecosystemMallCommerceMatrixArchMismatchHint: '{n} domain SKU(s) mismatch price-book product_class/quote_section — fix architecture on Price Book only.',
    ecosystemMallCommerceMatrixArchMismatchShort: 'arch mismatch',
    ecosystemMallCommerceMatrixArchCols: 'Architecture',
    ecosystemMallCommerceMatrixArchWriteNote: 'Architecture fields (product_class/quote_section) are editable only on Price Book; this page binds menus, creates domains, and edits list price only.',
    ecosystemMallCommerceMatrixSkuSection: 'SKU domain packs',
    ecosystemMallCommerceMatrixTreeSection: 'Menu / permission tree · commerce matrix (sidebar-aligned)',
    ecosystemMallCommerceMatrixOrphanSkuSection: 'SKUs not bound to any menu page',
    ecosystemMallCommerceMatrixMenuSection: 'Menu classification (pages)',
    ecosystemMallCommerceMatrixTier: 'Tier',
    ecosystemMallCommerceMatrixMenuCount: 'Menus',
    ecosystemMallCommerceMatrixMenuNames: 'Included menus',
    ecosystemMallCommerceMatrixTrialDays: 'Trial days',
    ecosystemMallCommerceMatrixHealth: 'Health',
    ecosystemMallCommerceMatrixAudience: 'Audience',
    ecosystemMallCommerceMatrixMenuName: 'Name',
    ecosystemMallCommerceMatrixActions: 'Actions',
    ecosystemMallCommerceMatrixFilterAll: 'All',
    ecosystemMallCommerceMatrixFilterBlocker: 'Blockers',
    ecosystemMallCommerceMatrixFilterUnassigned: 'Unassigned',
    ecosystemMallCommerceMatrixFilterInternal: 'Internal',
    ecosystemMallCommerceMatrixLoadFail: 'Load failed (platform admin required)',
    ecosystemMallCommerceMatrixFilterKeyword: 'Keyword',
    ecosystemMallCommerceMatrixFilterKeywordPh: 'SKU / name / domain',
    ecosystemMallCommerceMatrixFilterReset: 'Reset',
    ecosystemMallCommerceMatrixFilterResultCount: 'Showing {shown} / {total}',
    ecosystemMallCommerceMatrixFilterHealth: 'Health',
    ecosystemMallCommerceMatrixFilterTier: 'Tier',
    ecosystemMallCommerceMatrixFilterSegment: 'Segment',
    ecosystemMallCommerceMatrixFilterPriceStatus: 'List price',
    ecosystemMallCommerceMatrixFilterPriceHas: 'Has price',
    ecosystemMallCommerceMatrixFilterPriceMissing: 'Missing price',
    ecosystemMallCommerceMatrixFilterCurrency: 'Currency',
    ecosystemMallCommerceMatrixFilterDomain: 'Domain pack',
    ecosystemMallCommerceMatrixFilterPillar: 'Pillar',
    ecosystemMallCommerceMatrixFilterAudience: 'Audience',
    ecosystemMallCommerceMatrixFilterSkuBinding: 'SKU binding',
    ecosystemMallCommerceMatrixFilterSkuHas: 'Has SKU',
    ecosystemMallCommerceMatrixFilterSkuNo: 'No SKU',
    ecosystemMallCommerceMatrixFilterHealthOk: 'OK',
    ecosystemMallCommerceMatrixFilterHealthWarn: 'Warning',
    ecosystemMallCommerceMatrixFilterHealthBlocker: 'Blocker',
    ecosystemMallCommerceMatrixFilterAudienceBrandOps: 'Brand ops',
    ecosystemMallCommerceMatrixFilterUnassigned: 'Unassigned',
    ecosystemMallCommerceMatrixPillarSystem: 'System settings',
    ecosystemMallCommerceMatrixPillarDevice: 'Device · XHM',
    ecosystemMallCommerceMatrixPillarSoc: 'SOC ops',
    ecosystemMallCommerceMatrixPillarLeo: 'Leo',
    ecosystemMallCommerceMatrixPillarMall: 'Ecosystem mall',
    ecosystemMallCommerceMatrixPillarOther: 'Other',
    ecosystemMallCommerceMatrixDomain: 'Domain pack',
    ecosystemMallCommerceMatrixSegment: 'Segment',
    ecosystemMallCommerceMatrixBindTarget: 'Assign to',
    ecosystemMallCommerceMatrixBindApply: 'Assign selected',
    ecosystemMallCommerceMatrixBindNeedSelect: 'Select pages and a pack first',
    ecosystemMallCommerceMatrixBindOk: 'Assigned',
    ecosystemMallCommerceMatrixBindPolicy: 'Effective policy',
    ecosystemMallCommerceMatrixBindPolicyNewOnly: 'New subscriptions only (recommended)',
    ecosystemMallCommerceMatrixBindPolicyGrandfather: 'Grandfather existing buyers',
    ecosystemMallCommerceMatrixBindPolicyImmediate: 'Immediate (high risk)',
    ecosystemMallCommerceMatrixCreateDomain: 'New domain pack',
    ecosystemMallStartUnifyPipeline: 'Start standard pipeline',
    ecosystemMallGovernanceGapJump: 'Governance gaps',
    ecosystemMallCommerceMatrixCreateDomainHint: 'Add is safe; rebinding defaults to new subscriptions only — existing buyers keep packing.',
    ecosystemMallCommerceMatrixCreateDomainEnName: 'Domain enName',
    ecosystemMallCommerceMatrixCreateDomainQuoteSection: 'Quote section',
    ecosystemMallCommerceMatrixCreateDomainProductClass: 'Product class',
    ecosystemMallCommerceMatrixCreateDomainNeed: 'Menus / enName / pillar required',
    ecosystemMallCommerceMatrixCreateDomainOk: 'Domain created',
    ecosystemMallCommerceMatrixCreateDomainOkSku: 'Domain created, SKU={sku}',
    ecosystemMallCommerceMatrixCreateDomainFail: 'Create domain failed',
    ecosystemMallCommerceMatrixWizardStepMenus: 'Menus',
    ecosystemMallCommerceMatrixWizardStepConfirmMenus: 'Confirm',
    ecosystemMallCommerceMatrixWizardStepName: 'Name',
    ecosystemMallCommerceMatrixWizardStepBilling: 'Cycles',
    ecosystemMallCommerceMatrixWizardStepPay: 'Payment',
    ecosystemMallCommerceMatrixWizardStepPrice: 'Price',
    ecosystemMallCommerceMatrixWizardStepDone: 'Review',
    ecosystemMallCommerceMatrixWizardPickMenusHint: 'Check menu pages like the permission tree (same pillar only).',
    ecosystemMallCommerceMatrixWizardSelectedCount: '{n} menu page(s) selected',
    ecosystemMallCommerceMatrixWizardPillar: 'Pillar: {pillar}',
    ecosystemMallCommerceMatrixWizardNameZh: 'Display name (optional)',
    ecosystemMallCommerceMatrixWizardAutoSkuHint: 'SKU is auto-generated from the name; uniqueness enforced on save.',
    ecosystemMallCommerceMatrixWizardBillingHint: 'Supported billing cycles (multi-select; primary prefers year > month > day).',
    ecosystemMallCommerceMatrixWizardCycleDay: 'Day',
    ecosystemMallCommerceMatrixWizardCycleMonth: 'Month',
    ecosystemMallCommerceMatrixWizardCycleYear: 'Year',
    ecosystemMallCommerceMatrixWizardPayHint: 'Supported payment terms (multi-select).',
    ecosystemMallCommerceMatrixWizardPayPrepaid: 'Prepaid',
    ecosystemMallCommerceMatrixWizardPrev: 'Back',
    ecosystemMallCommerceMatrixWizardNext: 'Next',
    ecosystemMallCommerceMatrixWizardFinish: 'Create',
    ecosystemMallCommerceMatrixWizardNeedMenus: 'Select at least one menu page',
    ecosystemMallCommerceMatrixWizardMultiPillar: 'Selected menus span multiple pillars — pick one pillar only',
    ecosystemMallCommerceMatrixWizardNeedBilling: 'Select at least one billing cycle',
    ecosystemMallCommerceMatrixWizardNeedPay: 'Select at least one payment term',
    ecosystemMallCommerceMatrixWizardNeedPrice: 'Enter a price greater than 0',
    ecosystemMallCommerceMatrixBindFail: 'Assign failed',
    ecosystemMallCommerceMatrixMakeFree: 'Make free',
    ecosystemMallCommerceMatrixMakeFreeConfirm: 'Move all pages in this paid pack to a free basic pack. Tenants will not need to buy it. Continue?',
    ecosystemMallCommerceMatrixMakeFreeOk: 'Now free',
    ecosystemMallCommerceMatrixFreeTier: 'Free',
    ecosystemMallCommerceMatrixPaidTier: 'Paid',
    ecosystemMallCommerceMatrixBindHint: 'Edit audience/domain inline (incl. mark internal); batch via selection.',
    ecosystemMallCommerceMatrixAudienceApply: 'Set audience',
    ecosystemMallCommerceMatrixAudienceNeedSelect: 'Select pages and an audience first',
    ecosystemMallCommerceMatrixAudienceOk: 'Audience updated',
    ecosystemMallCommerceMatrixAudienceFail: 'Audience update failed',
    ecosystemMallCommerceMatrixAudienceJsonBoundWarn: '{n} page(s) are JSON-seeded and cannot be set unassigned',
    ecosystemMallCommerceMatrixBatchSelected: '{n} page(s) selected',
    ecosystemMallCommerceMatrixClearSelection: 'Clear selection',
    ecosystemMallCommerceMatrixInlineDomainPh: 'Pick domain pack',
    ecosystemMallCommerceMatrixBindPillarMixed: 'Select pages from one pillar only for batch domain bind',
    ecosystemMallCommerceMatrixBindPillarOther: 'Page is not under a sidebar pillar — fix menu tree first',
    ecosystemMallCommerceMatrixBindPillarMismatch: '{n} page(s) skipped — domain pack pillar mismatch',
    ecosystemMallCommerceMatrixMenuId: 'Menu ID',
    ecosystemMallCommerceMatrixTierFreeBasic: 'Free basic pack',
    ecosystemMallCommerceMatrixTierAddon: 'Add-on pack',
    ecosystemMallCommerceMatrixTierNone: 'None',
    ecosystemMallCommerceMatrixAudienceInfraFolder: 'Infrastructure folder',
    ecosystemMallCommerceMatrixHealthOk: 'OK',
    ecosystemMallCommerceMatrixHealthWarn: 'Warning',
    ecosystemMallCommerceMatrixHealthBlocker: 'Blocker',
    ecosystemMallCommerceMatrixDomain_socMonDomainBasicOps: 'SOC ops basics',
    ecosystemMallCommerceMatrixDomain_socMonDomainStoreOpsPlus: 'Store ops add-on',
    ecosystemMallCommerceMatrixDomain_socMonDomainHqMulti: 'HQ multi-store add-on',
    ecosystemMallCommerceMatrixDomain_socMonDomainPayIntegrate: 'Payment integration add-on',
    ecosystemMallCommerceMatrixDomain_socMonDomainAnalytics: 'Analytics & AI add-on',
    ecosystemMallCommerceMatrixDomain_socMonDomainSmartGuidePlus: 'Smart guide add-on',
    ecosystemMallCommerceMatrixDomain_leoMonDomainBasic: 'Leo basics',
    ecosystemMallCommerceMatrixDomain_leoMonDomainHomeAddon: 'Leo home add-on',
    ecosystemMallCommerceMatrixDomain_leoMonDomainComAddon: 'Leo component add-on',
    ecosystemMallCommerceMatrixDomain_leoMonDomainAiPoints: 'Leo AI points',
    ecosystemMallCommerceMatrixDomain_ecMonDomainMallBrowse: 'Mall browse basics',
    ecosystemMallCommerceMatrixDomain_ecMonDomainBusinessPlan: 'Business plan add-on',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainBasicCenter: 'Device center basics',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainAfterSales: 'After-sales basics',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainInCar: 'In-car basics',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainHardwarePartner: 'Hardware partner basics',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainFamilySlot: 'Device family slot',
    ecosystemMallCommerceMatrixDomain_brandServiceModeA: 'Contract mode A (device data)',
    ecosystemMallCommerceMatrixDomain_brandServiceModeB: 'Contract mode B (SOC/Leo add-ons)',
    ecosystemMallCommerceMatrixDomain_subscriptionBillingFolder: 'Subscription billing',
    ecosystemMallCommerceMatrixDomain_deviceEndpointDataFolder: 'Device endpoint data',
    ecosystemMallSocOpsDesc: 'Standard experience packs (standard fee) or custom packs (extra fee). Custom confirms staff/devices/modules/perms before issuing a sim pack.',
    ecosystemMallSocOpsToDevices: 'Device star map',
    ecosystemMallSocOpsFullSim: 'Full-day simulation',
    ecosystemMallSocOpsPlayDay: 'Play a store day',
    ecosystemMallSocOpsDayPlaying: 'Playing…',
    ecosystemMallSocOpsDayLabel: 'How a day runs',
    ecosystemMallSocOpsRailCup: 'Cup',
    ecosystemMallSocOpsRailCupHint: 'Order → brew → pickup',
    ecosystemMallSocOpsRailStock: 'Stock',
    ecosystemMallSocOpsRailStockHint: 'Deduct per cup; suggest refill',
    ecosystemMallSocOpsRailPeople: 'People',
    ecosystemMallSocOpsRailPeopleHint: 'Guidance and HQ sync',
    ecosystemMallSocOpsRailCash: 'Cash',
    ecosystemMallSocOpsRailCashHint: 'Pay, analytics, intel',
    ecosystemMallSocOpsRailMore: 'More modules',
    ecosystemMallSocOpsMode: 'View',
    ecosystemMallSocOpsModeTopo: 'Topology',
    ecosystemMallSocOpsModeList: 'Modules',
    ecosystemMallSocOpsReload: 'Reload',
    ecosystemMallSocOpsGuideToggle: 'Experience pack',
    ecosystemMallSocOpsGuideHide: 'Hide pack',
    ecosystemMallSocOpsPickCard: 'Select a card to see what this domain does for the store.',
    ecosystemMallSocOpsPickNode: 'Select a node to see what this domain does for the store.',
    ecosystemMallSocOpsPickHint: 'Or tap Cup / Stock / People / Cash above to highlight the flow.',
    ecosystemMallSocOpsYear: 'year',
    ecosystemMallSocOpsInBasic: 'Included in basics',
    ecosystemMallSocOpsStartTrial: 'Start trial',
    ecosystemMallSocOpsTrySim: 'Domain demo',
    ecosystemMallSocOpsCombo: 'Combo demo',
    ecosystemMallSocOpsAddPack: 'Add to ops pack',
    ecosystemMallSocOpsRemovePack: 'Remove from pack',
    ecosystemMallSocOpsConfirmPay: 'Confirm pay / activate',
    ecosystemMallSocOpsPaying: 'Activating…',
    ecosystemMallSocOpsMakePlan: 'Create plan',
    ecosystemMallSocOpsPayOk: 'Activated',
    ecosystemMallSocOpsPayFail: 'Activation failed',
    ecosystemMallSocOpsPayNeedTrial: 'Start a trial before confirming pay',
    ecosystemMallSocOpsAutoHuman: 'Auto vs human',
    ecosystemMallSocOpsAuto: 'Auto: ',
    ecosystemMallSocOpsHuman: 'Human: ',
    ecosystemMallSocOpsCaps: 'What you get',
    ecosystemMallSocOpsRelations: 'Up / downstream',
    ecosystemMallSocOpsUpstream: 'Needs',
    ecosystemMallSocOpsDownstream: 'Drives',
    ecosystemMallSocOpsRelNone: 'None (cloud-linked)',
    ecosystemMallSocOpsDemoTitle: 'Domain auto-flow',
    ecosystemMallSocOpsDemoClose: 'Close',
    ecosystemMallSocOpsPackTitle: 'Ops pack · {n} domains',
    ecosystemMallSocOpsPackEst: 'Est. ¥{amount} / year',
    ecosystemMallSocOpsPackClear: 'Clear',
    ecosystemMallSocOpsPackTrial: 'Trial pack',
    ecosystemMallSocOpsPackTrialOk: 'Started trial on {n} domains',
    ecosystemMallExpGuideTitle: 'Choose an experience pack',
    ecosystemMallExpGuideSub: 'Standard packs are ready-made. Custom packs confirm staff/devices/modules/perms first, then issue a full sim pack.',
    ecosystemMallExpKindStandard: 'Standard experience pack',
    ecosystemMallExpKindStandardHint: 'Fixed bundles — trial or pay to activate',
    ecosystemMallExpKindCustom: 'Custom experience pack',
    ecosystemMallExpKindCustomHint: 'Confirm whole-store setup, then issue the sim pack',
    ecosystemMallExpFeeStandard: 'Standard fee',
    ecosystemMallExpFeeExtra: 'Extra fee',
    ecosystemMallExpFeeExtraHint: 'Custom setup & pack issuance billed separately',
    ecosystemMallExpStepPickStandard: '① Pick a standard pack',
    ecosystemMallExpStandardLineA: 'Trial the pack domains and open the sim store.',
    ecosystemMallExpStandardLineB: 'Pay to activate the pack domains for real.',
    ecosystemMallExpStaffTitle: 'Staff',
    ecosystemMallExpStaffHint: 'How many managers and staff for the sim store (config only — not claiming accounts exist).',
    ecosystemMallExpDevicesTitle: 'Devices',
    ecosystemMallExpDevicesHint: 'Pick devices to place into the sim store.',
    ecosystemMallExpModulesTitle: 'Modules',
    ecosystemMallExpModulesHint: 'Pick ops domains to trial.',
    ecosystemMallExpPermsTitle: 'Permissions',
    ecosystemMallExpPermsHint: 'Pick manager/staff permission presets.',
    ecosystemMallExpConfirmTitle: 'Confirm & issue',
    ecosystemMallExpConfirmHint: 'Review, then issue the custom sim pack and enter experience.',
    ecosystemMallExpManagerCount: 'Managers',
    ecosystemMallExpStaffCount: 'Staff',
    ecosystemMallExpPermsHonest: 'Presets are saved as config; if accounts are not provisioned yet, checklist shows Recorded — not Done.',
    ecosystemMallExpConfirmHonest: 'After issue, checklist shows real status for trial/store/devices/staff/perms.',
    ecosystemMallExpSumStaff: 'Staff: {m} managers, {s} clerks',
    ecosystemMallExpSumDevices: '{n} devices',
    ecosystemMallExpSumModules: '{n} modules',
    ecosystemMallExpSumPerms: '{n} permission presets',
    ecosystemMallExpPrev: 'Back',
    ecosystemMallExpNext: 'Next',
    ecosystemMallExpIssuePack: 'Confirm & issue sim pack',
    ecosystemMallExpIssuing: 'Issuing…',
    ecosystemMallExpIssueOk: 'Custom sim pack issued — opening experience',
    ecosystemMallExpIssueFail: 'Issue incomplete (see checklist; not claiming success)',
    ecosystemMallExpDraftInvalid: 'Finish staff/devices/modules/permissions first',
    ecosystemMallExpChecklistTitle: 'Issue result (honest status)',
    ecosystemMallExpCheckModules: 'Software module trial',
    ecosystemMallExpCheckStore: 'Sim store workspace',
    ecosystemMallExpCheckDevices: 'Devices placed in sim store',
    ecosystemMallExpCheckStaff: 'Manager/staff config',
    ecosystemMallExpCheckStaffHonest: 'Config recorded; account creation needs backend — FE will not fake it',
    ecosystemMallExpCheckPerms: 'Permission preset config',
    ecosystemMallExpCheckPermsHonest: 'Presets recorded; not the same as roles already granted',
    ecosystemMallExpStatusDone: 'Done',
    ecosystemMallExpStatusRecorded: 'Recorded (backend pending)',
    ecosystemMallExpStatusFailed: 'Failed',
    ecosystemMallExpStatusPending: 'Pending action',
    ecosystemMallExpStatusSkipped: 'Skipped',
    ecosystemMallExpModOrder: 'Order',
    ecosystemMallExpModProduce: 'Produce',
    ecosystemMallExpModPickup: 'Pickup',
    ecosystemMallExpModStock: 'Stock',
    ecosystemMallExpModPay: 'Pay',
    ecosystemMallExpModHq: 'HQ',
    ecosystemMallExpModGuide: 'Guide',
    ecosystemMallExpModAnalytics: 'Analytics',
    ecosystemMallExpModIntel: 'Intel',
    ecosystemMallExpDevKiosk: 'Order kiosk',
    ecosystemMallExpDevTea: 'Produce / tea',
    ecosystemMallExpDevQueue: 'Queue display',
    ecosystemMallExpDevPos: 'POS',
    ecosystemMallExpDevSignage: 'Signage',
    ecosystemMallExpPermManager: 'Manager: full store ops',
    ecosystemMallExpPermStaff: 'Staff: daily ops',
    ecosystemMallExpPermStaffPickup: 'Staff: pickup only',
    ecosystemMallSocOpsBridgeHwTitle: 'Suggested hardware',
    ecosystemMallSocOpsBridgeHonest: 'Without a device snapshot, only catalog suggestions are shown — never claim in-store stock.',
    ecosystemMallSocOpsBridgeGoHw: 'Open device map',
    ecosystemMallSocOpsBridgeFromHw: 'Context arrived from device map (software state comes from this page topology)',
    ecosystemMallSocOpsBridgeFromHwPay: 'Hardware side suggests purchase line: confirm pack then pay to activate',
    ecosystemMallSocOpsDualTitle: 'After the demo, two paths only',
    ecosystemMallSocOpsDualSub: 'Pick a standard entitlement pack. Experience: provision pack → create sim store → run. Purchase: pay and activate for real.',
    ecosystemMallSocOpsLineATag: 'Path A · Experience',
    ecosystemMallSocOpsLineATitle: 'Standard pack → sim store',
    ecosystemMallSocOpsLineADesc: 'We trial-enable the selected pack and create a simulated store so you can run it.',
    ecosystemMallSocOpsLineAStep1: 'Provision standard entitlement pack (trial)',
    ecosystemMallSocOpsLineAStep2: 'Create simulated store workspace',
    ecosystemMallSocOpsLineAStep3: 'Enter virtual store and run',
    ecosystemMallSocOpsLineACta: 'Provision pack & open sim store',
    ecosystemMallSocOpsLineACtaShort: 'Experience: sim store',
    ecosystemMallSocOpsLineARunning: 'Provisioning…',
    ecosystemMallSocOpsLineAOk: 'Trial enabled on {n} domains — opening sim store',
    ecosystemMallSocOpsLineBTag: 'Path B · Purchase',
    ecosystemMallSocOpsLineBTitle: 'Pay to activate',
    ecosystemMallSocOpsLineBDesc: 'Confirm payment on the current pack / selected domains for real entitlements — no sim store.',
    ecosystemMallSocOpsLineBStep1: 'Confirm pack or selected domains',
    ecosystemMallSocOpsLineBStep2: 'Pay to activate',
    ecosystemMallSocOpsLineBStep3: 'Live store domains turn on',
    ecosystemMallSocOpsLineBCta: 'Pay & activate',
    ecosystemMallSocOpsLineBCtaShort: 'Purchase: activate',
    ecosystemMallSocOpsLineBOk: 'Activated {n} ops domains',
    ecosystemMallSocOpsLineBEmpty: 'No add-on domains left to activate',
    ecosystemMallSocOpsPackDayTitle: 'Day-ops standard pack',
    ecosystemMallSocOpsPackDayDesc: 'Order·brew·pickup·stock·pay',
    ecosystemMallSocOpsPackHqTitle: 'HQ boost pack',
    ecosystemMallSocOpsPackHqDesc: 'Day-ops + HQ·guide·analytics',
    ecosystemMallSocOpsPackFullTitle: 'Full intel pack',
    ecosystemMallSocOpsPackFullDesc: 'HQ boost + intel',
    ecosystemMallSocOpsSimStoreName: 'Ops sim store · {pack}',
    ecosystemMallSocOpsSimStoreFallback: 'Sim-store API not fully ready; continuing into virtual workspace',
    ecosystemMallSocOpsActive: 'Active',
    ecosystemMallSocOpsTrial: 'Trial',
    ecosystemMallSocOpsPotential: 'Missing',
    ecosystemMallBadgeAll: 'All',
    ecosystemMallBadgeOwned: 'Owned',
    ecosystemMallBadgeIntent: 'Intent',
    ecosystemMallBadgeAvailable: 'Available',
    ecosystemMallSocOpsLoadFail: 'Load failed',
    ecosystemMallSocOpsTrialOk: 'Trial started',
    ecosystemMallSocOpsTrialFail: 'Trial failed',
    ecosystemMallSocOpsListCount: '{n} modules',
    ecosystemMallSocOpsBrand: 'XRROSS Ops Store',
    ecosystemMallSocOpsChip: 'Leo · SOC · XHM trinity',
    ecosystemMallSocOpsSub: 'Center = SOC store runtime; bright edges = how work flows. Pick domains, pack, trial.',
    ecosystemMallSocOpsScheme: 'Color scheme',
    ecosystemMallSocOpsSchemeLight: 'Light',
    ecosystemMallSocOpsSchemeMidnight: 'Midnight',
    ecosystemMallSocOpsSchemeSlate: 'Slate',
    ecosystemMallSocOpsSchemeBrand: 'Brand',
    ecosystemMallSocOpsEngine: 'Ops map',
    ecosystemMallSocOpsLegendTitle: 'How to read',
    ecosystemMallSocOpsLegendHub: 'Center = SOC store runtime (Leo guide / XHM write-back)',
    ecosystemMallSocOpsLegendActive: 'Bright = active / included with hardware',
    ecosystemMallSocOpsLegendPotential: 'Dim = missing (dashed + amber)',
    ecosystemMallSocOpsLegendTrial: 'Green = trial',
    ecosystemMallSocOpsLegendHint: 'Thick edges = day-loop links; click highlights up/downstream',
    ecosystemMallSocOpsLegendExpand: 'Click a domain to fan out features; click again to fold',
    ecosystemMallSocOpsLegendHover: 'Hover a ball to see its full name and functions',
    ecosystemMallSocOpsHoverBelong: 'Belongs to',
    ecosystemMallSocOpsZoomHint: 'Wheel zoom · drag empty space to pan',
    ecosystemMallSocOpsZoomReset: 'Reset',
    ecosystemMallSocOpsFs: 'Full screen',
    ecosystemMallSocOpsExitFs: 'Exit',
    ecosystemMallSocOpsFsLeft: 'Fullscreen left canvas',
    ecosystemMallSocOpsFsRight: 'Fullscreen right panel',
    ecosystemMallSocOpsSplitHint: 'Drag to resize panels',
    ecosystemMallSocOpsSku: 'Add-on SKU',
    ecosystemMallSocOpsReloading: 'Starting…',
    ecosystemMallSocOpsEmpty: 'No ops nodes yet',
    ecosystemMallSocOpsHubLabel: 'SOC store runtime',
    ecosystemMallSocOpsHubSub: 'Runtime',
    ecosystemMallSocOpsHubHint: 'Cup·stock·people·cash loop here',
    ecosystemMallSocOpsMetaBasicSolve: 'Install the store runtime base so other domains can attach.',
    ecosystemMallSocOpsMetaBasicAuto: 'Accounts, store profile, base menu, device handshake.',
    ecosystemMallSocOpsMetaBasicHuman: 'First-time setup and brand rules.',
    ecosystemMallSocOpsMetaBasicC1: 'Store & staff base records',
    ecosystemMallSocOpsMetaBasicC2: 'Menu / SKU foundation',
    ecosystemMallSocOpsMetaBasicC3: 'Handshake with device map',
    ecosystemMallSocOpsMetaBasicD1: 'Cloud creates store runtime',
    ecosystemMallSocOpsMetaBasicD2: 'Sync base menu & permissions',
    ecosystemMallSocOpsMetaBasicD3: 'Domains become attachable',
    ecosystemMallSocOpsMetaOrderSolve: 'Unify channel orders into one stream—fewer missed tickets.',
    ecosystemMallSocOpsMetaOrderAuto: 'Intake, validate, route to brew queue.',
    ecosystemMallSocOpsMetaOrderHuman: 'Exceptions, edits, complaint calls.',
    ecosystemMallSocOpsMetaOrderC1: 'Multi-channel intake',
    ecosystemMallSocOpsMetaOrderC2: 'Auto validate & dispatch',
    ecosystemMallSocOpsMetaOrderC3: 'Exception alerts',
    ecosystemMallSocOpsMetaOrderD1: 'Order lands in the cloud',
    ecosystemMallSocOpsMetaOrderD2: 'Rules validate into queue',
    ecosystemMallSocOpsMetaOrderD3: 'Hand off to brew domain',
    ecosystemMallSocOpsMetaProduceSolve: 'Drive each cup from recipe so brew is a tracked pipeline.',
    ecosystemMallSocOpsMetaProduceAuto: 'Advance BOM/recipe steps and write progress.',
    ecosystemMallSocOpsMetaProduceHuman: 'Device faults and recipe exceptions.',
    ecosystemMallSocOpsMetaProduceC1: 'Recipe-driven line',
    ecosystemMallSocOpsMetaProduceC2: 'Progress to pickup',
    ecosystemMallSocOpsMetaProduceC3: 'Suggest stock deduct',
    ecosystemMallSocOpsMetaProduceD1: 'Order spawns brew job',
    ecosystemMallSocOpsMetaProduceD2: 'Line/device executes steps',
    ecosystemMallSocOpsMetaProduceD3: 'Done signal → pickup & stock',
    ecosystemMallSocOpsMetaPickupSolve: 'Turn “ready” into dispute-free pickup via order code.',
    ecosystemMallSocOpsMetaPickupAuto: 'Queue, call, scan redeem.',
    ecosystemMallSocOpsMetaPickupHuman: 'Pickup disputes and special release.',
    ecosystemMallSocOpsMetaPickupC1: 'Queue / call',
    ecosystemMallSocOpsMetaPickupC2: 'Scan redeem',
    ecosystemMallSocOpsMetaPickupC3: 'Status to pay & analytics',
    ecosystemMallSocOpsMetaPickupD1: 'Brew done enters pickup',
    ecosystemMallSocOpsMetaPickupD2: 'Guest scans order code',
    ecosystemMallSocOpsMetaPickupD3: 'Close loop to pay & review',
    ecosystemMallSocOpsMetaStockSolve: 'Deduct per cup; suggest refill instead of gut feel.',
    ecosystemMallSocOpsMetaStockAuto: 'BOM deduct, threshold alerts, refill drafts.',
    ecosystemMallSocOpsMetaStockHuman: 'Confirm receive/ship and large buys.',
    ecosystemMallSocOpsMetaStockC1: 'BOM deduct',
    ecosystemMallSocOpsMetaStockC2: 'Low-stock alerts',
    ecosystemMallSocOpsMetaStockC3: 'Scan receive suggestions',
    ecosystemMallSocOpsMetaStockD1: 'Brew triggers deduct',
    ecosystemMallSocOpsMetaStockD2: 'Breach creates suggestion',
    ecosystemMallSocOpsMetaStockD3: 'Escalate to HQ when needed',
    ecosystemMallSocOpsMetaHqSolve: 'Centralize multi-store exceptions—routine stays quiet.',
    ecosystemMallSocOpsMetaHqAuto: 'Aggregate breaches and cross-store views.',
    ecosystemMallSocOpsMetaHqHuman: 'Strategy, pricing, major exceptions.',
    ecosystemMallSocOpsMetaHqC1: 'Multi-store dashboard',
    ecosystemMallSocOpsMetaHqC2: 'Breach escalation',
    ecosystemMallSocOpsMetaHqC3: 'Push policy to guidance',
    ecosystemMallSocOpsMetaHqD1: 'Domains report key metrics',
    ecosystemMallSocOpsMetaHqD2: 'Only breaches page humans',
    ecosystemMallSocOpsMetaHqD3: 'Decisions flow back to stores',
    ecosystemMallSocOpsMetaPaySolve: 'Accrue payables clearly; humans gate real payouts.',
    ecosystemMallSocOpsMetaPayAuto: 'Ledger, reconcile hints, pay status sync.',
    ecosystemMallSocOpsMetaPayHuman: 'Payout confirm and refunds.',
    ecosystemMallSocOpsMetaPayC1: 'Receive / AP ledger',
    ecosystemMallSocOpsMetaPayC2: 'Reconcile trails',
    ecosystemMallSocOpsMetaPayC3: 'Human gate before payout',
    ecosystemMallSocOpsMetaPayD1: 'Pickup fires ledger event',
    ecosystemMallSocOpsMetaPayD2: 'Auto collect open items',
    ecosystemMallSocOpsMetaPayD3: 'Ask confirm before payout',
    ecosystemMallSocOpsMetaAnalyticsSolve: 'Turn the day into numbers you can review—not weekend spreadsheet chaos.',
    ecosystemMallSocOpsMetaAnalyticsAuto: 'Roll up sales, waste, peaks.',
    ecosystemMallSocOpsMetaAnalyticsHuman: 'Interpret anomalies; change menu/shifts.',
    ecosystemMallSocOpsMetaAnalyticsC1: 'Day/week brief',
    ecosystemMallSocOpsMetaAnalyticsC2: 'Peak & waste hints',
    ecosystemMallSocOpsMetaAnalyticsC3: 'Feed intel & HQ',
    ecosystemMallSocOpsMetaAnalyticsD1: 'Pay & line events land',
    ecosystemMallSocOpsMetaAnalyticsD2: 'Build ops brief',
    ecosystemMallSocOpsMetaAnalyticsD3: 'Push anomalies to intel/HQ',
    ecosystemMallSocOpsMetaGuideSolve: 'Align staff actions with the system—not chat-group shouting.',
    ecosystemMallSocOpsMetaGuideAuto: 'Next-step prompts; outreach when short-staffed.',
    ecosystemMallSocOpsMetaGuideHuman: 'Shift confirm and floor exceptions.',
    ecosystemMallSocOpsMetaGuideC1: 'Role next-step guidance',
    ecosystemMallSocOpsMetaGuideC2: 'Shift / fill suggestions',
    ecosystemMallSocOpsMetaGuideC3: 'Land HQ policy into actions',
    ecosystemMallSocOpsMetaGuideD1: 'HQ policy drops',
    ecosystemMallSocOpsMetaGuideD2: 'Staff get next step',
    ecosystemMallSocOpsMetaGuideD3: 'Actions re-enter order flow',
    ecosystemMallSocOpsMetaIntelSolve: 'Turn signals into actionable intel—not report piles.',
    ecosystemMallSocOpsMetaIntelAuto: 'Spot trends/risks and draft briefs.',
    ecosystemMallSocOpsMetaIntelHuman: 'Decide combo / hardware / software add-ons.',
    ecosystemMallSocOpsMetaIntelC1: 'Trend & risk briefs',
    ecosystemMallSocOpsMetaIntelC2: 'Tie-in buy suggestions',
    ecosystemMallSocOpsMetaIntelC3: 'Loop back to HQ choices',
    ecosystemMallSocOpsMetaIntelD1: 'Analytics emits signals',
    ecosystemMallSocOpsMetaIntelD2: 'Craft actionable intel',
    ecosystemMallSocOpsMetaIntelD3: 'HQ makes the trade-off',
    ecosystemMallCatalog: 'Catalog & chapters',
    ecosystemMallWebsitePages: 'Website product pages',
    ecosystemMallSynergyEdges: 'Synergy edge gate',
    ecosystemMallIntents: 'Intent / consult tickets',
    ecosystemMallVendors: 'Vendors & staff',
    ecosystemMallMediaBilling: 'Media AI / billing',
    ecosystemMallProductSpecs: 'Product specs / gaps',
    ecosystemMallLines: 'Production lines',
    ecosystemMallSearch: 'Search & recommend',
    ecosystemMallEquipmentDemands: 'Equipment demand tickets',
    storeAssortmentOptimization: 'Store assortment optimization',
    storeAssortmentGroup: 'Store Assortment',
    storeAssortmentDesk: 'Assortment Optimize Desk',
    storeAssortmentView: 'View',
    storeAssortmentGate: 'Gate',
    teaSingleCupParams: 'Single cup params',
    teaE1Performance: 'Smart Precision',
    dispenserPrecision: 'Precision',
    dispenserMaterialLoss: 'Material loss',
    dispenserMultiMachine: 'Multi-machine interconnect',
    teaE1MatchScore: 'Precision score',
    teaE1OnTarget: 'On target',
    teaE1Wear: 'Wear index',
    dataOfBlendExtractorMachine:'Ice Sand Machine Data',
    dataOfMilkExtractorMachine:'Milk Frother Data',
    beverageOutputData: 'Production Data',
    singleCupData: 'Single cup data',
    faultLog: 'Fault Log',
    deliveryPlatform: 'Delivery Platform',
    uber:'Uber',
    otherProducts: 'Other products',
    listOfTeaExtractsProducts: 'Tea Extractor Products',
    machineDebug: 'Device Debugging',
    deviceRdGroup: 'Device R&D',
    presetCommand:'Preset Command',
    commandConfiguration:'Command Configuration',
    memberHqGroup: 'Member HQ',
    memberHqDashboard: 'HQ Dashboard',
    memberHqFinance: 'Finance Summary',
    financeAccountingReports: 'Accounting Statements',
    financeAccountingGroup: 'Financial Accounting',
    storeCostOptimizeGroup: 'Cost Efficiency',
    storeCostOptimizeDesk: 'Cost Optimize Desk',
    storeCostOptimizeView: 'View',
    storeCostOptimizeGate: 'Gate',
    storeOpsCeoDeskGroup: 'Ops Decision Desk',
    storeOpsCeoDecisionDesk: 'CEO Ops Desk',
    storeOpsCeoDecisionDeskView: 'View',
    storeOpsCeoDecisionDeskDecide: 'Decide',
    storeOpsCeoGovernanceGapTitle: 'Global governance gaps',
    storeOpsCeoGovernanceGapDesc: 'Master list lives here. Price book and model catalog only jump here. Confirming a plan does not change prices, approve models, or write Shenzhen.',
    storeOpsCeoGovernanceGapConfirm: 'Confirm plan',
    storeOpsCeoGovernanceGapStart: 'Start standard pipeline',
    storeOpsCeoGovernanceGapEmpty: 'No open gaps to confirm',
    storeOpsCeoGovernanceGapKind: 'Kind',
    storeOpsCeoGovernanceGapPlan: 'Plan',
    storeOpsCeoGovernanceGapHonesty: 'Cross-node price drift appears only after a verify ingest. This line never auto-fanouts.',
    storeOpsCeoGovernanceGapConfirmed: 'Confirmed',
    storeOpsCeoGovernanceStepOpen: 'Open list',
    storeOpsCeoGovernanceStepPick: 'Pick a gap',
    storeOpsCeoGovernanceStepConfirm: 'Confirm plan',
    storeOpsCeoGovernanceStepGates: 'Check write gates',
    storeOpsCeoGovernanceStepDone: 'Done',
    storeOpsCeoGovernanceCoachTitle: 'Confirm the plan now',
    storeOpsCeoGovernanceCoachHint: 'Read the steps, then confirm. Confirming does not write Shenzhen.',
    aiEngineeringControlGroup: 'AI Engineering Control',
    aiEngineeringControlDesk: 'Engineering Control Desk',
    aiEngineeringControlDeskView: 'View',
    storePnLGroup: 'Store P&L',
    storePnLDesk: 'P&L / Cash Desk',
    storePnLDeskView: 'View',
    storePnLDeskGate: 'Day-close / Entries',
    opsAnalyticsDesk: 'Ops Analytics',
    hkTaxFilingDesk: 'Store books',
    hkTaxFilingDeskView: 'View',
    hkTaxFilingDeskGate: 'Pack / Gate',
    hkTaxZeroDesc: 'Open a shop with no bookkeeping: sales book themselves, snap other slips, one tap to prepare the tax file. Not auto-filing with IRD.',
    hkTaxZeroHonesty: 'We prepare the books and the IRD pack. You still sign and upload on the tax portal.',
    hkTaxZeroSales: 'Sales',
    hkTaxZeroExpense: 'Spend',
    hkTaxZeroSurplus: 'This year',
    hkTaxZeroPrepare: 'Prepare tax file',
    hkTaxZeroSign: 'I checked it',
    hkTaxZeroUpload: 'Upload at IRD',
    hkTaxZeroDownload: 'Download file',
    hkTaxZeroAdvanced: 'Advanced (accountant)',
    hkTaxZeroYa: 'Year of assessment',
    hkTaxZeroCompany: 'Company name',
    hkTaxZeroTaxFile: 'Tax file no.',
    hkTaxZeroTwoTier: 'Two-tier',
    hkTaxZeroHasEmp: 'Has staff',
    hkTaxZeroSaveProfile: 'Save profile',
    hkTaxZeroRebuild: 'Rebuild ledger',
    hkTaxZeroAddAdj: 'Add adjustment',
    hkTaxZeroPartner: 'Push partner',
    hkTaxZeroAck: 'IRD acknowledgement',
    hkTaxZeroSaveAck: 'Save ack',
    hkTaxZeroEmpAdd: 'Add employee',
    hkTaxZeroEmpPack: 'Employer pack',
    storeReceiptInbox: 'Store receipts',
    storeReceiptInboxView: 'View',
    storeReceiptInboxGate: 'Upload / book',
    storeReceiptInboxDesc: 'Snap rent, utilities or outside purchases. We book them into HK tax drafts. Not auto-filing with IRD.',
    storeReceiptPickStore: 'Select store',
    storeReceiptReload: 'Refresh',
    storeReceiptHonesty: 'Sales already come from paid orders. This inbox is for other slips. Booking is not IRD filing.',
    storeReceiptTakePhoto: 'Photo / upload',
    storeReceiptMerchantHint: 'Merchant (optional)',
    storeReceiptList: 'Uploaded receipts',
    storeReceiptEmpty: 'None yet',
    storeReceiptDate: 'Date',
    storeReceiptMerchant: 'Merchant',
    storeReceiptAmount: 'Amount',
    storeReceiptKind: 'Category',
    storeReceiptStatus: 'Status',
    storeReceiptActions: 'Actions',
    storeReceiptConfirm: 'Confirm book',
    storeReceiptReject: 'Reject',
    storeReceiptPreview: 'Preview',
    storeReceiptBadType: 'JPG / PNG / WebP only',
    storeReceiptBadSize: 'Max 8MB each',
    storeReceiptUploadFail: 'Upload failed',
    storeReceiptIngestOk: 'Received',
    storeReceiptIngestFail: 'Ingest failed',
    storeReceiptBooked: 'Booked',
    storeReceiptBookFail: 'Book failed',
    storeReceiptRejected: 'Rejected',
    storeReceiptRejectFail: 'Reject failed',
    storeReceiptOpenAssist: 'Open assistant',
    storeReceiptIDidCheck: 'Done, check',
    storeReceiptStatusDone: 'Done',
    storeReceiptStatusCurrent: 'Current',
    storeReceiptStatusTodo: 'To do',
    xhmHardwarePartnerGroup: 'Factory / Hardware Partners',
    xhmHardwarePartnerDesk: 'Partner / Settlement Desk',
    xhmHardwarePartnerDeskView: 'View',
    xhmHardwarePartnerDeskGate: 'Settle / Assign',
    xhmFamilySlotGroup: 'XHM Family Slots',
    xhmFamilySlotDesk: 'Slot Desk',
    xhmFamilySlotDeskView: 'View',
    xhmFamilySlotDeskGate: 'Save Slots',
    leoBrandOnboardingGroup: 'Brand Agent',
    leoBrandOnboardingDesk: 'Brand Onboarding Desk',
    leoBrandOnboardingDeskView: 'View',
    leoBrandOnboardingDeskConfirm: 'Confirm Write',
    hkMarketChannelGroup: 'HK Market Channels',
    hkMarketChannelDesk: 'HK Pay / WhatsApp Desk',
    hkMarketChannelDeskView: 'View',
    hkMarketChannelDeskGate: 'Simulate / Config',
    hkMarketSignup: 'HK Store Signup',
    hkMarketSignupGate: 'Signup Submit',
    cnMarketChannelGroup: 'CN Market Channels',
    cnMarketChannelDesk: 'CN Pay / Social Desk',
    cnMarketChannelDeskView: 'View',
    cnMarketChannelDeskGate: 'Simulate / Config',
    cnMarketSignup: 'CN Store Signup',
    cnMarketSignupGate: 'Signup Submit',
    brandStorePaymentGroup: 'Brand Setup',
    brandOpenPack: 'Auto Open',
    productShelf: 'List products',
    produceGuide: 'Auto equipment',
    brandStorePaymentBind: 'Bind Pay',
    brandAppListing: 'App Listing',
    storeAutonomousMarketingGroup: 'Store Autonomous Marketing',
    storeAutonomousMarketingDesk: 'Marketing Desk',
    storeAutonomousMarketingView: 'View',
    storeAutonomousMarketingGate: 'Gate',
    workforceGroup: 'Workforce',
    workforceWeekSchedule: 'Weekly Schedule',
    workforceClock: 'Time Clock',
    workforceSummary: 'Attendance Summary',
    workforceSmartRoster: 'Smart Roster',
    workforceMySchedule: 'My Schedule',
    workforcePayroll: 'Payroll Close',
    memberHqOps: 'Operations Hub',
    distributorReportGroup: 'Channel Reports',
    distributorDashboard: 'Channel Overview',
    distributorMembers: 'My Members',
    distributorProfit: 'Profit Details',
    merchantTokenBillingPlatform: 'AI Points',
    merchantDataBillingPlatform: 'In-Vehicle Data Billing',
    linuxAutoOps: 'In-Vehicle Ops',
    linuxAutoEquipment: 'In-Vehicle Devices',
    linuxAutoRemoteOps: 'Remote Ops',
    linuxAutoProfileConfig: 'Profile Config',
    linuxAutoDataBilling: 'CAN Data Billing',
    linuxAutoModelRegistry: 'Model Registry',
    linuxAutoPartnerDelivery: 'Partner Delivery',
    linuxAutoFleetMonitor: 'Fleet Monitor',
    linuxAutoDbcEntitlement: 'DBC Entitlement',
    linuxAutoCabinFeatures: 'Cabin Features',
    linuxAutoCanAutoMatch: 'CAN Auto Match',
    operationAndMaintenanceServices:'Operation and maintenance services',
    productionList:'Production list',
    smallMaterial:'Small material list',
    takeoutProducts:'Takeout products',
    pointRule:'Points Rules',
    couponManagement:"Coupon Management",
    couponList:"Coupon List",
    additionalProducts:'Additional products',
    type:'Product Type',
    taxAllocation:'Tax Allocation',
    produce:'Product List',
    produceList4:'Product List 4',
    smoothieMakerProduct:'Produced By Ice Sand Machine',
    machineMenu:'Equipment Menu',
    systemLog:"System log",
    region:'Region'
  },
  acoount: {
    name: '名称',
    enterpriseName: 'Merchant name',
    account: 'Account',
    password: 'Password',
    confirmPassword: 'Confirm password',
    roleTitle:'Permission title',
    roleName:'Permission name',
    searchKeyword:'Account/phone/email/role',
    phone:'Cell Phone',
    email:'Email',
    idNumber:'ID No.',
    workAddress:'Work Address',
    status:'Status',
    onDuty:'Normal',
    leaveDuty:'Resign',
    takeVacationrm:'Vacation',
    disable:'Disable',
    profilePicture:'Avatar',
    confirmPasswordCannotBeEmpty:'Password cannot be empty',
    inconsistentPasswordInput:'Inconsistent password inputs',
    emailFormatError:'Email error',
    phoneNumberFormatError:'Cell phone number error',
    notes:'Remark',
    empower:'Authorize',
    contactInformation:'Contact information',
    leoEntityId:'X-ID',
    leoEntityIdFilter:'Filter by X-ID',
    leoPrimaryAnchor:'Leo primary anchor',
    leoPrimaryAnchorFilter:'Filter by primary anchor',
    leoPrimaryAnchored:'Complete',
    leoPrimaryNotAnchored:'Incomplete',
    leoIdentityLinks:'Sign-in links',
    leoIdentityLinkCountSuffix:' linked',
    leoIdentityLinksTitle:'X-ID sign-in correspondence',
    leoIdentityLinkLabel:'Method / account',
    leoIdentityLinkKind:'Type',
    leoIdentityLinkPrimary:'Primary',
    leoIdentityLinkRef:'Credential',
    leoIdentityLinksEmpty:'No sign-in methods linked to this X-ID yet',
    userOrganizationType:'Organization type',
    userOrganizationName:'Organization name',
    describe:'Description',
    available:'Available',
    deactivate:'Suspend',

  },
  merchant: {
    account: 'Login account',
    password: 'Password',
    store: 'Store',
    status:'Status',
    available:'Normal',
    deactivate:'Suspend',
    merchantName:'Merchant name',
    searchKeyword:'Name/leader/phone/address',
    sapPageDesc:'Gold sample: title | filters | table | footer; one primary CTA, row actions in More, medium density.',
    sapListTitle:'Merchant list',
    cooperationType:'Merchant type',
    selectCooperationTypeFirst:'Select merchant type first',
    noUserOrganizationForType:'No user organization for this type. Configure under User Organization.',
    enterpriseSegment:'Business segment',
    segmentDistributor:'Distributor',
    segmentShop:'Shop / merchant',
    segmentHome:'Home enterprise',
    businessLicense:'Business License',
    frontIDCard:'Legal person ID card front',
    backIDCard:'Legal person ID card back',
    head:'Principal',
    Telephone:'Contact number',
    userOrganization:'Organization',
    businessAddress:'Registration Address',
    trade:'Open',
    closeBusiness:'Closed',
    superior:'Superior',
    supervisorSubordinateRelation:'Organization chat',
    clickView:'Click to view',
    business:'Merchant',
    country:'Country',
    address:'Address',
    shopNames:'Store name',
    storeType:'Store type',
    selfService:'Self-service',
    askFor:'Pick up',
    SelfPickupTakeoutShop:'self-service+takeaway',
    selfServicePickUpTakeout:'self-service+takeaway+Delivery',
    businessHours:'Business hours',
    closingTime:'Closing time',
    operatingCycle:'Business cycle',
    Monday:'Monday',
    Tuesday:'Tuesday',
    Wednesday:'Wednesday',
    Thursday:'Thursday',
    Friday:'Friday',
    Saturday:'Saturday',
    Sunday:'Sunday',
    picture:'Photo',
    vatNumber:'VAT增值税号',
    kvtCompanyRegistrationNumber:'KVK公司注册号',
    invoiceUnifiedNumbering:'Invoice unified number',
    invoiceAccountNumber:'Invoice account number',   
    POSAPIKey:'POS API Key',
    POSAccount:'POS Account',
    APPAPIKey:'APP API Key',
    APPAccount:'APP Account',
    APPClientKey:'APP Client Key',
    region:'Region'

  },
  device:{
    // XRROSS_I18N_UNION_FILL_20260916 en
    appKeyword: 'App name',
    appPublishAhead: 'Ahead of published',
    appPublishBehind: 'Behind published',
    appPublishEqual: 'Equal published',
    appPublishRel: 'Vs published',
    appReportHas: 'Reported',
    appReportNone: 'Never reported',
    appReportStale: 'Report stale (7d)',
    appVersionFilter: 'On-device version',
    appVersionOp: 'Version compare',
    appVersionOpContains: 'Contains',
    appVersionOpEq: 'Equals',
    appVersionOpGt: 'Greater than',
    appVersionOpGte: 'Greater or equal',
    appVersionOpLt: 'Less than',
    appVersionOpLte: 'Less or equal',
    appVersionReportStatus: 'Version report',
    macFastRebindEnabled: 'MAC fast rebind',
    macFastRebindPending: 'Rebind pending',
    sapPageDesc:'Gold sample: title | KPI | filters | table | footer; one primary CTA, row actions in More, medium density.',
    sapKpiTitle:'Device overview',
    sapListTitle:'Device list',
    mapShowLocation:'Show on map',
    deviceType:'Device type',
    totalDevice:'All devices',
    offLineDevice:'Offline',
    materialShortageDevice:'Material Shortage',
    alertingDevice:'Alarm',
    lockDevice:'Locked',
    passConfigName:"Name",
    maintenanceDevice:'Needs Maintenance',
    businessInformation:'Business information',
    deviceId:'Name',
    deviceModel:'Model No.',
    modelCodeKey:'Model code',
    modelCodePlaceholder:'e.g. PT5 or XRROSS_PT5; must be unique',
    modelCodeRequired:'Please enter model code (Leo model_key)',
    dealer:"Retailer",
    deviceImie:'ID',
    appVersion:'App version',
    equipmentSerialNumber:'S/N',
    posNumber:'Credit card machine SN',
    store:'Store',
    location:'Device location',
    none:'None',
    log:"Log",
    fault:"Defective",
    normal:"Normal",
    offline:"Offline",
    onLine:"Online",
    isFault: "Defective",
    type:"Type",
    fullyAutomatic:"Fully automatic",
    semiAutomatic:"Semi-automatic",
    availableMerchants:"Available merchants",
    faultStatistics:"Defects Statistics",
    basicMaintenance:"Basic Maintenance",
    deepMaintenance:"Deep maintenance",
    onLineDevice:'Online device',
    equipmentOnlineStatus: "Equipment status:",
    moduleLinkStatus:"Module link:",
    hostProduceStatus:"Host ready:",
    hostReadyCanProduce:"Ready to produce",
    hostReadyNeedWake:"Needs wake",
    hostReadyUnknown:"Unknown",
    linkOffline:"Module offline",
    linkOnlineHostSleep:"Online · host sleep",
    brandName: "Brand name:",
    telephone: "Telephone:",
    equipmentModelName: "Equipment model/name:",
    dateOfManufacture: "Date of manufacture:",
    usageDate: "Date of use:",
    menu: "Menu",
    productName : "Product name",
    channelConfiguration : "Channel configuration",
    channelNumber : "Channel number",
    material : "Material",
    shelfLife : "Shelf life",
    alarmListForTheDay: "Alarm list (for the day)",
    content : "Content",
    time : "Time",
    key: "Key",
    frequency : "Number of times",
    remoteOperation : "Remote operation",
    cloudIris:'Cloud Iris',
    cloudIrisShort:'Iris',
    cloudIrisNeedImie:'Missing device code — cannot open Cloud Iris',
    cloudIrisVersionLow:'App version below Cloud Iris minimum (need {minVersion}, current {appVersion})',
    cloudIrisNoVersion:'No App version reported yet — Cloud Iris support unknown',
    cloudIrisNotReadyFamily:'Cloud Iris is not ready for this device family yet',
    cloudIrisNotLicensed:'Cloud Iris is not licensed for this device; select it in add-on checkout',
    cloudIrisNeedUpgradeShort:'Cloud Iris upgrade',
    cloudIrisOldVersionShort:'Old',
    cloudIrisEnd:'End Cloud Iris',
    cloudIrisWaiting:'Waiting for device stream…',
    cloudIrisLive:'Live — tap to control',
    cloudIrisFailed:'Cloud Iris not ready',
    cloudIrisUpgradeConfirmTitle:'Confirm Cloud Iris upgrade',
    cloudIrisUpgradeConfirm:'Push forced OTA to device {imie} (target ≥ {minVersion}, current {appVersion}).\n{detail}\nOnly this device is affected; other gray-list customers are unchanged.',
    cloudIrisUpgradeConfirmOk:'Agree and push',
    cloudIrisUpgradePushSent:'OTA check command sent ({imie})',
    cloudIrisUpgradePushOffline:'Added to gray whitelist; device offline or no ACK ({imie})',
    cloudIrisUpgradePushFailed:'Cloud Iris OTA push failed',
    identityAndLink:'Identity & link',
    storeAddress:'Store address',
    deviceGeo:'Device location',
    deviceGeoLoading:'Loading location…',
    deviceGeoNone:'No location',
    success : "Success",
    menuStatus: "Menu status",
    updated: "Updated",
    notUpdated: "Not updated",
    lock: "Lock",
    unlock: "Unlock",
    startup: "Startup",
    shutdown: "Shutdown",
    restart: "Restart",
    param: "Param",
    factoryParam: 'Factory Param',
    moduleParam: 'Module Param',
    paramBaselineOpen: 'Parameters',
    paramBaselineTitle: 'Parameter baseline (Leo / model)',
    paramBaselineHint: 'Use the same JSON path as device config (e.g. config.stirTime). Used by Leo to compare with live machine config.',
    paramBaselineAddRow: 'Add row',
    paramBaselineSave: 'Save',
    paramBaselineRefresh: 'Reload',
    paramKey: 'Param key',
    paramKeyPh: 'e.g. config.stirTime',
    paramDisplayName: 'Display name',
    standardValue: 'Standard value',
    lowerLimit: 'Lower',
    upperLimit: 'Upper',
    unit: 'Unit',
    paramRemark: 'Remark',
    paramBaselineNoProfile: 'No readable L1 profile (or no PUBLISHED version) for this model. Create/publish a profile bound to this model in Profile management first.',
    paramBaselineProfileSource: 'Default source: {name} · published #{version}',
    paramBaselineApplyPublished: 'Apply from latest published',
    paramBaselineApplyConfirm: 'Merge suggested keys/values from the latest published JSON (overwrite same keys). Continue?',
    paramBaselineApplyDone: 'Merged published suggestions (review and save)',
    paramBaselineTypeUnionTitle: 'Same equipment type · union of paths from latest published (reference)',
    paramBaselineTypeUnionMissing: 'Model IDs without profile',
  },
  produce: {
    // XRROSS_I18N_UNION_FILL_20260916 en
    Text19: 'Digits only',
    codeRule: 'Edit rules',
    codeRuleDescribe: 'This format matches the POS printed code format',
    countsInConsumption: 'Counts in consumption',
    isSales: 'Orderable',
    matterTypeKind: 'Material kind',
    matterTypeKindParameter: 'Parameter',
    matterTypeKindPhysical: 'Physical material',
    matterTypeParameterHint: 'Parameter type is excluded from material consumption stats (program, strength, water temp, etc.).',
    prefix: 'Prefix',
    review: 'Preview',
    suffix: 'Suffix',
    uberPrice: 'Uber unit price',
    name: 'Name',
    price: 'Price',
    matterType: 'Material type',
    materialRoleBean: 'Coffee beans',
    materialRoleMilk: 'Liquid milk',
    materialRolePowder: 'Powder',
    materialRoleWater: 'Water',
    materialRoleTeaLeaf: 'Tea leaves',
    materialRoleTeaBroth: 'Tea broth',
    materialRoleSyrup: 'Syrup',
    materialRoleLiquor: 'Spirits',
    materialRoleConsumable: 'Consumables',
    physicalMaterial: 'Physical SKU',
    physicalMaterialHint: 'V1: pick store physical SKU first; or check create-physical-and-map.',
    physicalMaterialRequired: 'Select a physical SKU, or enable create-physical-and-map',
    createPhysicalIfMissing: 'Create physical SKU by name and auto-map',
    normType: 'Option type',
    matter: 'Material',
    min: 'Minimum value',
    max:'Maximum value',
    shelfLife:'Expiry Time',
    unit:'Unit',
    hour:'Hour',
    step1:'Product information',
    step2:'Product material',
    step3:'Product recipe',
    step4:'Recipe combination',
    step5:'Product accessories',
    produceName:'Product name',
    produceCode:'Code',
    produceType:'Product type',
    showSnacks:'Show snacks',
    yes:'Yes',
    no:'No',
    describe:'Description',
    order:'Order',
    value:'Value',
    unit:'Unit',
    norm:'Options',
    select:'Select',
    step:'Step',
    matterSequence:'Material sequence',
    action:'Action',
    freeSnacks:'Free Options',
    feeBasedMaterials:'Charged Options',
    nextStep:'Next',
    back:'Back',
    save:'Save',
    saveUpdate:'Save update',
    productList:'Product list',
    selectProduct:'Select product',
    menuSort:'Sort',
    produceImport:'Export',
    bind:'Binding',
    bindMachien:'Bind Device',
    smallMatterType:'Accessories type',
    listing:'Listing',
    productDetail:'Product detail',
    produceEquipment:'Make flow',
    canMake:'Can produce',
    cannotMake:'This store has no matching model',
    noRecipe:'No recipe / brew params yet',
    noCombo:'No spec combo yet',
    noProduceEquipment:'No order / scan-to-make flow yet',
    consumableNoMachine:'Packaging (not a machine)',
    orderOnLeo:'No kiosk/cashier here — order on Leo phone',
    productListName:"Enter the name of the production menu",
    Text1: 'Enter the product name',
    Text2: 'Merchant',
    Text3:'Material',
    Text4:'Small material',
    Text5:'Drink',
    Text6:'Snacks',
    Text7:'New recipes',
    Text8:'Update',
    Text9:'This product code already exists',
    Text10:'Please complete the product information',
    Text11:'Tea',
    Text12:'First paragraph',
    Text13:'Second paragraph',
    Text14:'Third paragraph',
    Text15:'Out',
    Text16:'Not out',
    Text17:'Range:',
    Text18:'Amount of tea:',
    Text20:'Amount of ice:',
    Text21:'Stir time cannot exceed brew/extraction time in the same segment (max {max})',
    Text22:'Brew/extraction time cannot be less than current stir time ({min})',
    Text23:'Recipe "{name}": stir time exceeds brew/extraction limit ({max}). Adjust before saving.',
  },
  business: {
    // XRROSS_I18N_UNION_FILL_20260916 en
    otherPay: 'Other',
    thirdParty: 'Third party',
    name: 'Name',
    type: 'Type',
    homepage: 'Homepage',
    advertisingList: 'Advertising list',
    pictureOrVideo: 'Photo/video',
    addProductAdvertisements:'Add product advertisements',
    AddImagesOrvideos:'Add new photo/videos',
    userName: 'Username',
    email: 'Email',
    sex: 'Gender',
    birthday: 'Birthday',
    phone: 'Cell phone number',
    walletBalance: 'Wallet balance',
    integral: 'Member points',
    orderNo: 'Order number',
    pickupCode: 'Pickup code',
    orderSource: 'Source',
    orderSourceAll: 'All sources',
    orderSourceTable: 'Table QR',
    orderSourceNormal: 'Regular',
    tableNo: 'Table',
    store: 'Store',
    amount: 'Order amount',
    payAmount: 'Actual payment amount',
    receiptsPrice: 'Actual amount received',
    discount: 'Discount',
    orderStatus: 'Order status',
    toBePaid: 'Waiting Payment',
    paid: 'Paid',
    processing: 'Processing',
    completed: 'Completed',
    orderCancellation: 'Order Cancelled',
    orderRejection: 'Order rejected',
    paymentMethod: 'Payment type',
    wallet: 'Wallet',
    cash: 'Cash',
    pos: 'Card machine',
    produce: 'Produce',
    unitPrice: 'Unit price',
    number: 'Number',
    parameter: 'Parameter',
    totalTaxAmount:'Total tax amount',
    orderType: 'Order type',
    pack: 'Pack',
    dineIn: 'Dine-in',
    taxName:'Tax name',
    taxAmount:'Tax amount',
    taxRate:'Tax rate',
  
  },
  operation:{
    business_data:"Business dashboard",
    orderAmount:"Order amount",
    orderQuantity:"Order quantity",
    actualAmountReceived:"Actual amount received",
    top_10_beverage_rankings:"Top 10 Beverage Rankings",
    sales_revenue:"Sales revenue",
    order_quantity:"Order quantity",
    payment_method:"Payment method",
    real_time_orders_on_the_hour:"Real time orders on the hour",
  },
  dataCenter:{
    Text1: "Content",
    Text2: "Data",
    Text3: "Sales volume/cup",
    Text4: "Sales revenue/yuan",
    Text5: "Consumable materials/g",
    Text6: "Month",
    Text7: "Day",
    Text8: "Hour",
    Text9: "Chart",
    Text10: "Material consumption per cup",
    Text11: "Ranking",
    Text12: "Production Consumption Materials",
    Text13: "Equipment Consumption Materials",
    Text14: "Percentage",
    Text15: "Ranking",
    Text16: "Sales Volume",
    Text17: "Sales revenue",
    Text18: "Time/Cup",
    Text19: "Product sales volume",
    Text20: "Product sales revenue",
    Text21: "Device sales volume",
    Text22: "Equipment sales revenue",
    Text23: "Total cup volume",
    Text24: "Total formula amount/gram",
    Text25: "Actual total formula quantity/gram",
    Text26: "Bad cup quantity/cup",
    Text27: "Bad cup rate/%",
    Text28: "Error rate/%",
    Text29: "Product Name",
    Text30: "Production method",
    Text31: "Scan-Full pipe",
    Text32: "Product-Full pipe",
    fullPipeModeValue: 'Full pipe',
    fullPipeMode: 'Mode',
    calibComplete: 'Completed',
    calibIncomplete: 'Incomplete',
    calibValue: 'Value',
    calibModeChannel: 'Channel calibration',
    calibModeScale: 'Scale calibration',
    calibMode: 'Calibration mode',
    pipeActualText: 'Single-pipe actual (g)',
    Text32Single: 'Product-Single pipe',
    Text31Single: 'Scan-Single pipe',
    Text33: "Manual",
    Text34: "Order number",
    Text35: "Store",
    Text36: "Unit Price",
    Text37: "Total amount of formula (g)",
    Text38: "Actual cup output (g)",
    Text39: "Cup out time",
    Text40: "Error (%)",
    Text41: "Bad Cup",
    Text42: "Normal",
    Text43: "Production completed",
    Text44: "Production failed",
    Text45: "Completion time",
    Text46: "Mode",
    Text47: "Channel",
    Text48: "Status",
    Text49: "Incomplete",
    Text50: "Completed",
    Text51: "Product Name",
    Text52: "Number of Cups",
    Text53: "Total price",
    Text54: "Order Statistics",
    Text55: "Order List",
    Text56: "Order Amount",
    Text57: "Order quantity",
    Text58: "Actual amount received",
    Text59: "Product amount",
    Text60:"Tea quantity",
    Text61: "Water output",
    Text62: "Sales volume/barrel",
    Text63: "Bucket",   
    Text64: "Sour/Extraction too short",
    Text65: "Balanced/Extraction moderate",
    Text66: "Bitter/Extraction too much",
    Text67: "Bitter/Low concentration",
    Text68: "Moderate",
    Text69: "Strong/High concentration",
    Text70:"Extraction time",
    Text71:"Water-powder ratio",
    strongBalance:"Strong balance",
    weakBalance:"Weak balance",
    mediumAcid:"Medium acid",
    strongAcid:"Strong acid",
    goldenCup:"Golden cup",
    weakAcid:"Weak acid",
    bitter:"Bitter",
    strongBitter:"Strong bitter",
    weakBitter:"Weak bitter",  
    extractionTime:"Extraction time",    
    Text72:"Dynamic calibration",    
    },
    taxation:{
      Text1:"Tax name",   
      Text2:"Tax rate",   
      Text3:"Cardinal number", 
      Text4:"Remarks", 
      Text5:"Country", 
      Text6:"Type", 
      Text7:"Dine in",  
      Text8:"Packaging",   
      Text9:"Product Type",
      Text10:"Tax Type", 
      Text11:"Platform Takeaway",             
    },
  pass: {
    name: 'Name',
    pass: 'Channel',
    passNumber: 'Channel number',
    preDischargeTime: 'Channel filling time',
    addPass:'Add new channel',
    bindPass:'Channel binding',
    passConfigName:'Channel configuration name'
  
  },
  uber:{
    Text1: "Uber Store",
    Text2: "Platform Store",
    Text3: "Menu Status",
    Text4: "Store Status",
    Text5: "Already bound",
    Text6: "Unbound",
    Text7: "Synchronization"
    },
  login: {
    title: 'System login',
    logIn: 'Login',
    username: 'Account',
    password: 'Password',
    readAndAgree:'I have read and agree to the',
    pleaseCheckThePrivacyAgreement:'Please tick to agree to the Privacy Policy, Terms of Service and Disclaimer before signing in',
    termTip:'Privacy Policy, Terms of Service and Disclaimer',
     Text1:'请输入账号',
    Text2:'请输入密码',
    leoSmartComingSoon: 'Leo Smart professional site — coming soon'


  },
  navbar: {
    logOut: 'Log out',
    dashboard: 'Homepage',
    github: 'Project address',
    screenfull: 'Full screen',
    theme: 'Skin changing',
    size: 'Layout size',
    globalSearchTitle: 'Global search',
    globalSearchPlaceholder: 'Menus / stores / devices / materials / tickets (Ctrl+K)',
    globalSearchHotkeyHint: 'Open global search (Ctrl+K)',
    globalSearchRecent: 'Recent',
    globalSearchSaved: 'Saved views',
    globalSearchEmpty: 'No results',
    globalSearchSaveView: 'Save current view',
    globalSearchSaveViewPrompt: 'View name',
    globalSearchDefaultViewName: 'View',
    globalSearchSavedOk: 'View saved',
    globalSearchFooterHint: 'Enter opens first hit · Esc closes',
    globalSearchGroupMenus: 'Menus',
    globalSearchGroupStores: 'Stores',
    globalSearchGroupEquipment: 'Devices',
    globalSearchGroupMaterials: 'Materials',
    globalSearchGroupTickets: 'Tickets',
    globalSearchMissingRoute: 'No page to open'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close all'
  },
  common: {
    // XRROSS_I18N_UNION_FILL_20260916 en
    menuVersion: 'Menu version',
    tower: 'tower',
    yuan: '$',
    cup: 'Cup',
    place: 'Place',
    individual: 'Individual',
    language: 'Language',
    success: 'Successful',
    fail: 'Failed',
    createTime: 'Creation time',
    all: 'All',
    common:'All',
    sureDel: 'Confirm deletion',
    tip: 'Hint',
    status: 'Status',
    bing: 'Binding',
    pleaseSelectDevice: 'Please select a device',
    pleaseSelectMenu:'Please select a menu',
    pleaseSelectModel: 'Please select a model',
    pleaseSelect: 'Please select',
    code: 'Code',
    entering_the_platform:'Entering the platform',
    date:"Date",
    address_fail:"The address is incorrect",
    back:'Back',
    pleaseEnter:'Please enter',
    uploadImageBtn:'Click to upload an image',
    uploadImageBtnTip:'Only supports uploading JPG and PNG formats (limited to 10M)',
    uploadVideoBtn:'Click to upload a video',
    uploadVideoBtnTip:'Only supports uploading mp4 or MP4 files (limited to 50M)',
    videoPlayTip:' Your browser does not support video playback'

  },
  table: {
    search: 'Query',
    detail: 'Details',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'OK',
    add: 'Add',
    copy: 'Copy',
    produceCodeRule:'Coding Rules',
    batchDeletion: 'Batch deletion',
    batchImport: 'Batch Import',
    batchCopy:'Batch Copy',
    export: 'Data export',
    exportAll: 'Export all',
    import: 'Import',
    templateDownload: 'Template Download',
    dragAndDropUpload: 'Drag the file here, or click on upload',
    picture: 'Picture',
    resetPwd:'Reset Password',
    more: 'More',
    reset: 'Reset'
  },
  coffeeData:{
    Text1: "Immersion flow rate",
    Text2: "Soaking time",
    Text3: "Extraction flow rate",
    Text4: "Extraction pressure",
    Text5: "Extraction temperature",
    Text6: "Order Type",
    Text7: "Status",
    Text8: "Cup time",
    Text9: "Powder Quantity",
    Text10: "Device Encoding",
    Text11: "Product Name",
    Text12:"Coffee Liquid", 
    Text13: "Powder pressing force",
    Text14: "Powder cake thickness",
    Text15: "Extraction flow rate",
    Text16: "Extraction chamber position",  
    Text17: "Grinding degree 1",
    Text18: "Grinding degree 2",  
     
    },
  channelCmd: {
    desc: 'See at a glance which A-line social and B-line license channels are live, promoting, have no publish API, or wait on a human gate. No publish from this page.',
    reload: 'Reload',
    v1Note: 'Read-only v1. If a channel has an official publish API, humans connect once; AI posts after that. No official API means we do not post by hand. BD / trade shows stay human.',
    fLine: 'Line',
    fKind: 'Kind',
    fRegion: 'Region',
    fStatus: 'Status',
    fPromo: 'Promoting',
    fApi: 'Official API',
    fHuman: 'Human gate',
    fAi: 'AI ops',
    fSku: 'SKU',
    fLocale: 'Locale',
    fQ: 'Platform / note',
    reset: 'Clear filters',
    yes: 'Yes',
    no: 'No',
    lineA: 'A-line DTC',
    lineB: 'B-line license',
    lineBoth: 'Shared',
    aInUse: 'A in use',
    aPromo: 'A promoting',
    bInUse: 'B in use',
    noApi: 'No API',
    needsHuman: 'Human gate',
    hold: 'Hold',
    aiReady: 'AI live',
    afterConnect: 'AI after connect',
    humanOnly: 'Human only',
    total: 'Showing',
    colA: 'A-line · social DTC',
    colB: 'B-line · license / head buyer',
    cPlatform: 'Platform',
    cStatus: 'Status',
    cPromo: 'Promo',
    cApi: 'API',
    cKind: 'Kind',
    cRegion: 'Region',
    cNote: 'Note',
    cAi: 'Who runs it',
    cFollow: 'Human follow-up',
    cComms: 'Comms',
    comms: 'Comm history',
    chatEmpty: 'No messages yet. Log publishes, OAuth, and follow-ups here.',
    sideUs: 'Us',
    sideThem: 'Channel / them',
    logInbound: 'Log their reply',
    logOutbound: 'Log our follow-up',
    subject: 'Subject',
    chatPlaceholder: 'Message…',
    logSave: 'Save to history',
    openLink: 'Open link',
    openFollow: 'Open follow-up',
    noFollowUrl: 'No public link',
    step1: 'Open console',
    step2: 'Filter line and status',
    step3: 'Read live vs promoting',
    coachBadge: 'Do this now',
    coachHint: 'Matrix only — do not publish here. Click a row for comm history.',
    coachNext: 'Next',
    kind: { social: 'Social', commerce: 'Commerce', license: 'License', web: 'Website', email: 'Email' },
    region: { US: 'US', CN: 'China', HK: 'Hong Kong', JP: 'Japan', GLOBAL: 'Global' },
    status: {
      LIVE: 'Live',
      TOKEN_PRESENT: 'Token present',
      NEEDS_TOKEN: 'Needs token',
      NEEDS_OAUTH: 'Needs OAuth',
      NEEDS_REAUTH: 'Needs re-auth',
      NEEDS_HUMAN_GATE: 'Human gate',
      HOLD_NO_APP_AUDIT: 'App audit hold',
      HOLD_NO_COMPANY_PAGE: 'No company page',
      NO_API: 'No official API',
      PROBE: 'Probing'
    },
    ai: {
      ai_ready: 'AI can post now',
      after_connect: 'AI posts after connect',
      human_only: 'Human only (BD / terms)',
      no_api_skip: 'No API · skip'
    }
  },
  bCrm: {
    desc: 'B-end CRM: head buyers + dealers. Pipeline, product category/SKU filters, contacts, activities, unified outreach queue.',
    reload: 'Reload',
    applyFilter: 'Apply filters',
    v1Note: 'Filter by product category across lines. Unified send queues by default; live SMTP needs ops allow.',
    fType: 'Account type',
    fFunnel: 'Funnel',
    fStage: 'Stage',
    fRegion: 'Region',
    fOwner: 'Owner',
    fProdCat: 'Product category',
    fSku: 'Product SKU',
    fPromo: 'Promoting',
    fPriority: 'Priority',
    fHasEmail: 'Has email',
    fContactStatus: 'Contact completeness',
    fQ: 'Name / notes',
    reset: 'Clear filters',
    yes: 'Yes',
    no: 'No',
    campaign: 'Unified outreach',
    head: 'Head buyers',
    dealer: 'Dealers',
    promoting: 'Promoting',
    withEmail: 'Has email',
    total: 'Shown',
    queue: 'Queued campaigns',
    accounts: 'Accounts',
    detail: 'Account detail',
    contacts: 'Contacts',
    activities: 'Activities',
    notes: 'Notes',
    openLi: 'LinkedIn',
    cContact: 'Primary contact',
    cEmailAddr: 'Email',
    cLinkedin: 'LinkedIn',
    cContactStatus: 'Contact status',
    cRole: 'Role',
    contactStatus: {
      EMAIL_OK: 'BD email OK',
      LINKEDIN_ONLY: 'LinkedIn only',
      MISSING: 'Missing contact'
    },
    subject: 'Subject',
    body: 'Body',
    cancel: 'Cancel',
    sendQueue: 'Enqueue outreach',
    campaignHint: '{n} selected (email required to select)',
    queuedOk: 'Queued {n}, skipped {s}',
    coachBadge: 'Do now',
    coachHint: 'Filter by product category, then select and queue.',
    coachNext: 'Next',
    coach1: 'Open B-end CRM and read head/dealer totals',
    coach2: 'Filter by product category or SKU',
    coach3: 'Select accounts and enqueue outreach',
    railOpen: 'Open',
    railFilter: 'Product filter',
    railCampaign: 'Outreach',
    cName: 'Name',
    cType: 'Type',
    cFunnel: 'Funnel',
    cStage: 'Stage',
    cPri: 'Pri',
    cCats: 'Categories',
    cSkus: 'SKUs',
    cPromo: 'Promo',
    cOwner: 'Owner',
    cNext: 'Next action',
    cEmail: 'Email',
    cAction: 'Actions',
    interactions: 'Interaction log',
    chatEmpty: 'No messages yet',
    sideUs: 'Us',
    sideThem: 'Customer',
    logReply: 'Log customer reply',
    logOutbound: 'Log our send',
    chatPlaceholder: 'Paste email body or summary…',
    logSave: 'Save to log',
    logOk: 'Interaction saved',
    type: { head_buyer: 'Head buyer', dealer: 'Dealer' },
    funnel: { L: 'License', H: 'OEM / H', DEALER: 'Dealer', BOTH: 'Both' },
    stage: {
      lead: 'Lead',
      contacted: 'Contacted',
      replied: 'Replied',
      negotiating: 'Negotiating',
      won: 'Won',
      lost: 'Lost',
      hold: 'Hold'
    },
    cat: {
      HOME_OEM: 'Home OEM',
      COMMERCIAL_OEM: 'Commercial OEM',
      LICENSE: 'License / brain',
      CONSUMABLE: 'Beans / consumables',
      AFTERSALES: 'Aftersales parts',
      OTHER: 'Other'
    }
  },
  immersivePromo: {
    sampleTitle: 'Immersive promo sample',
    sampleDesc: 'Top = this page’s real nav entries (same tree as the sidebar). The ad rail stays pinned at the bottom; cards scroll in the middle.',
    navEmpty: 'No nav entries to show. Sign in and check menu permissions.',
    navChildren: 'Open submenu',
    sampleHint: 'The ad rail is not a second set of feature entries. Use the arrow for more ads.',
    adRailKicker: 'Recommended',
    adMore: 'More',
    adMoreTitle: 'More ads',
    navEnter: 'Open',
    helpFoot: 'Nav cards open features; the rail is ads. Arrow opens the full ad list.',
    surface: 'Surface',
    surfaceHome: 'Customer home',
    surfaceDataCenter: 'Data center',
    portrait: 'Portrait',
    portraitOem: 'Equipment OEM',
    portraitDist: 'Distributor',
    portraitChain: 'Physical chain operator',
    ownedSkusHint: 'Simulate owned SKUs (comma-separated)',
    leoInstalled: 'Leo installed',
    leoActive: 'Active 7d',
    strategyLabel: 'Strategy',
    ownedTitle: 'Available features',
    promoTitle: 'Unlockable capabilities',
    promoLead: 'Looks like a feature card; reads like an ad. Hover for details, then try.',
    zoneOwnedHint: 'Feature entry',
    zoneUnlockHint: 'Capability · ad copy',
    tagOwned: 'Available',
    tagPromo: 'Add-on',
    tagCapability: 'Unlockable',
    hoverHint: 'Hover for details',
    adDetailKicker: 'Why try this',
    adDetailClose: 'Close',
    leoQrHint: 'Scan to install Leo. iPhone: App Store. Android overseas: Google Play. Mainland China: this region’s node.',
    leoQrAlt: 'Leo download QR',
    trialBadge: 'Free trial',
    freeUpgradeBadge: 'Free upgrade',
    adPromoPriceLabel: 'Special offer',
    adPriceLabel: 'Price',
    adPriceFallback: 'Free trial · special offer pricing',
    ctaOpen: 'Open',
    ctaTrial: 'Try first',
    ctaFreeUpgrade: 'Free upgrade',
    ctaSign: 'Sign after trial',
    ctaSampleOnly: 'Sample CTA only; wire entitlement later',
    ctaTrialHint: 'Start a trial first. Sign only if it works. No charge now.',
    ctaPathMissing: 'This ad is not linked to a live page yet. Try again later.',
    ctaTrialFirst: 'Next step is trial. Sign later — we will not push the contract desk now.',
    ctaFreeUpgradeFirst: 'Next: upgrade the machine → install the phone app → open Cloud Iris. No AI jargon — follow the steps.',
    freeUpgradeStarted: 'Free-upgrade guide started: update the machine, then install the app.',
    noPromo: 'No unlockable capability cards for this portrait/surface',
    reload: 'Reload',
    goPortraits: 'Portraits',
    goOrchestrate: 'Ad orchestrate',
    loadFail: 'Failed to load promo surface',
    orchDesc: 'You pick the mode and frame; AI always decides schedule, audience order and copy.',
    orchMode: 'Mode',
    orchMode1: '1 · Human frame + AI',
    orchMode2: '2 · Full takeover',
    orchMode1Hint: 'Set audience / content / time (any subset). AI only orchestrates inside that frame.',
    orchMode2Hint: 'No human limits. AI pins the monthly theme, fills the rest by portrait — not dump the catalog.',
    orchAudience: 'Audience',
    orchContent: 'Content',
    orchTheme: 'Monthly theme',
    orchThemeHint: 'Empty = this month default (Leo + Cloud Iris). Theme stays on the rail; other SKUs follow portrait.',
    orchThemeSkus: 'Theme SKUs',
    orchSchedule: 'Schedule',
    orchSkus: 'SKU / packs',
    orchAny: 'Any (empty = no cap on this axis)',
    orchDates: 'Date range',
    orchHours: 'Daily hours',
    orchStart: 'Start',
    orchEnd: 'End',
    orchDailyStart: 'From',
    orchDailyEnd: 'To',
    orchSave: 'Save',
    orchSaveOk: 'Saved; AI will use this frame',
    orchSaveFail: 'Save failed',
    orchLoadFail: 'Failed to load campaign',
    orchGoSample: 'Immersive promo sample',
    orchHelpFoot: 'Output is the page-bottom ad rail, not a second nav. Timezone Asia/Shanghai.',
    contentDesc: 'Mall recs use one format: title, body, image, video. Copy must ship in Traditional Chinese, Simplified Chinese, English, and Japanese. Generate each slot or all at once. Edit or upload your own media.',
    contentList: 'Recommendations',
    contentTitleCol: 'Title',
    contentFmtTitle: 'Title',
    contentLangTw: 'ZH-TW',
    contentLangZh: 'ZH-CN',
    contentLangEn: 'EN',
    contentLangJa: 'JA',
    contentFmtBody: 'Body',
    contentFmtImage: 'Image',
    contentFmtVideo: 'Video',
    contentGenAll: 'Generate all',
    contentHint: 'Human hint',
    contentHintPh: 'e.g. stress saved travel, 7-day trial, benefits over specs (direction only, not pasted as copy)',
    contentGenPrompts: 'Generation prompts',
    contentGenPromptNote: 'Product/Cursor writes these prompts. AI generate sends them to Gemini. Edit then generate or save.',
    contentPreview: 'Ad preview',
    contentPreviewEmptyImg: 'No image yet. Generate or upload.',
    contentPreviewEmptyVideo: 'No clip yet. Generate a playable still-motion clip, or upload one.',
    contentPreviewStoryboard: 'Video storyboard preview',
    contentGenerate: 'AI generate',
    contentSave: 'Save live',
    contentHook: 'Card line',
    contentBlurb: 'Blurb',
    contentDetail: 'Detail',
    contentBenefits: 'Benefits (one per line)',
    contentBenefitsPh: 'One per line',
    contentSocial: 'Social post body',
    contentSource: 'Source',
    contentImagePromptPh: 'Image prompt (AI writes; you can edit)',
    contentVideoPromptPh: 'Storyboard (upload the finished clip)',
    contentNote: 'These are recommendations, not hard ads. AI can generate image and video; you can also upload your own.',
    contentSaveOk: 'Saved and live on the rail',
    contentSaveFail: 'Save failed',
    contentGenOk: 'AI copy is live',
    contentGenLlmSkip: 'Copy AI unreachable; kept catalog copy and did not paste your hint.',
    contentGenImageFail: 'Image AI unreachable; no placeholder text poster was published.',
    contentGenVideoSkip: 'Clip needs a real still; skipped this time.',
    contentGenFail: 'Generate failed',
    contentLoadFail: 'Failed to load content library',
    contentHelpFoot: 'Use Ad orchestrate for who/when. This page is the four mall slots. Preview shows image and video.'
  },
  addonDeviceScope: {
    title: 'Select devices',
    hint: 'Per-device add-ons (e.g. Cloud Iris): pick machines or stores; total = unit price × count.',
    confirm: 'Confirm selection',
    quoteLine: '{count} devices × {unit} = {total} {currency}'
  },
  commerceMatrixAlert: {
    title: 'Commerce matrix: {n} unassigned page(s); hidden from tenant nav',
    openMatrix: 'Open matrix'
  },
  capabilityAdoptionBanner: {
    title: 'Leo capabilities you have not tried yet',
    start: 'Start guide',
    dismiss: 'Not now'
  },
  billingAddonGuide: {
    panelTitle: 'My add-ons',
    sidebarPathHint: 'Pinned entry: Sidebar → Service contracts → Add-on contracts → Add-on hub',
    trialSection: 'Trials',
    paySection: 'Payment due',
    goPay: 'Pay now',
    goAddonHub: 'Open add-on hub',
    trialEnds: 'Trial until {date}',
    bannerTrial: 'You have add-on trials active — find them on Home “My add-ons” or sidebar “Add-on contracts”.',
    bannerPay: '“{sku}” trial ended — please pay to keep using it.',
    bannerPayBtn: 'Pay now',
    bannerDismiss: 'Remind later',
    sidebarBadgeTrial: 'Trial',
    sidebarBadgePay: 'Due',
    sidebarBadgeTitle: 'Add-on trial or payment due',
    promoTrialPathHint: 'Pending items appear in the top-right billing cart.'
  },
  trialFeature: {
    badgeTrial: 'Trial',
    summaryPill: '{n} trial feature(s)',
    tooltipActive: '{name}: on trial — {days} day(s) left',
    tooltipExpiring: '{name}: trial ending soon ({days} day(s) left) — please subscribe',
    tooltipExpired: '{name}: trial ended — please subscribe to continue',
    tooltipPaidActive: '{name}: paid and active',
    popoverKicker: 'Trial status',
    trialStartOk: 'Trial activated',
    trialStartFail: 'Could not start trial',
    trialAlreadyActive: 'Already on trial',
    endTrial: 'End trial',
    endTrialConfirm: 'Cloud Iris will be turned off and billing reminders stop. Base features included with your machine are unchanged. End trial?',
    endTrialHint: 'You can end the trial anytime; base machine features are not affected.',
    endTrialOk: 'Trial ended',
    endTrialFail: 'Could not end trial',
    addToCart: 'Add to cart',
    addToCartOk: 'Added to cart',
    addToCartFail: 'Could not add to cart'
  },
  trialReadiness: {
    title: 'Trial readiness',
    autoDetectIntro: 'These three checks run automatically—no manual settings lookup. Tap Refresh to re-run.',
    refresh: 'Refresh checks',
    scopeTitle: 'Device trial scope',
    scopeHint: 'Default: all models and devices. Filter by model, store, or SN/IMIE.',
    modelPlaceholder: 'Models (empty = all)',
    storePlaceholder: 'Stores (empty = all)',
    devicePlaceholder: 'Device SN (empty = all in scope)',
    deviceEmptyHint: 'No devices match the current filters. Clear model/store filters or bind devices under this brand.',
    applyScope: 'Apply scope',
    scopeSaved: 'Trial scope updated',
    scopeSaveFail: 'Could not update trial scope',
    guideTitle: 'Try Cloud Iris now',
    guideStep1: 'Cloud trial should show ✅ above.',
    guideStep2: 'Pick scope; at least one Cloud-Iris-capable device must be online.',
    guideStep3: 'Device list → row action → Cloud Iris.',
    guideStep4: 'Optional: install Leo App for phone viewing.',
    openEntry: 'Open device list',
    deviceOnline: 'Online',
    deviceOffline: 'Offline',
    samplesTitle: 'Devices in scope (snapshot)',
    sampleNoIris: 'Model not Cloud-Iris capable',
    leoAppLoggedIn: 'Leo App sign-in detected in last {days} days (brand: {brandLogins7d}).',
    leoAppNotSeen: 'No Leo App sign-in in {days} days; download it from the SOC app store (optional for SOC trial).',
    leoAppDetectHint: 'We check membership login audit—you do not need to verify settings yourself.',
    cloudReady: 'Cloud trial is active for SOC Cloud Iris.',
    cloudMissing: 'Cloud trial not active yet; refresh or restart trial.',
    cloudDetectHint: 'We check add-on entitlement trial status automatically.',
    cloudTrialBypassNote: 'During trial you can open Cloud Iris even without the Cloud Iris role flag.',
    deviceReady: '{ready}/{total} device(s) ready (Cloud-Iris capable and online).',
    deviceNone: 'No devices in scope; bind devices or widen filters.',
    deviceNoIrisSupport: '{total} device(s) in scope, none Cloud-Iris capable (tea/coffee families).',
    deviceNeedsOnline: '{irisCapable} capable but only {online} online—power on and connect.',
    deviceDetectHint: 'We check online status and whether the model supports Cloud Iris.',
    actionLeoApp: 'Download from SOC app store',
    actionDevices: 'Open device list',
    check: { leoApp: 'Leo App (phone)', cloud: 'Cloud access', device: 'Online + Cloud Iris support' }
  },
  billingCart: {
    title: 'Billing cart',
    empty: 'No pending payment or confirmation items',
    refresh: 'Refresh',
    trackAddon: 'Add-on',
    trackContract: 'Contract',
    statusConfirm: 'Confirm',
    statusPay: 'Pay',
    statusTrial: 'Trial checkout',
    statusRenew: 'Renew'
  },
  billingOrder: {
    documentTitle: 'XRROSS Service Order',
    documentSubtitle: 'Review the schedule of fees and totals before confirming or paying (commercial Order Form)',
    orderNo: 'Order no.',
    orderDate: 'Issue date',
    partyTitle: 'Parties',
    seller: 'Seller',
    buyer: 'Buyer (brand)',
    currency: 'Currency',
    billType: 'Order type',
    lineItems: 'Line items',
    salesOrderTitle: 'Sales order lines',
    scheduleOfFeesTitle: 'Schedule of Fees',
    stickyPayLabel: 'Amount due',
    stickyPayHint: 'Scheme: {scheme} · {devices} devices',
    deviceSummaryHint: 'Grouped by device category and unit price; same price shows device count.',
    feeSummaryTitle: 'Fee summary',
    listExTaxUsd: 'USD list (ex-tax)',
    fxRate: 'FX rate',
    subtotalExTax: 'Subtotal (ex-tax)',
    addonExtra: 'Add-ons (Cloud Iris etc.)',
    taxAmount: 'Tax',
    colLineNo: '#',
    colSku: 'SKU',
    colMachineCode: 'Machine code',
    colDeviceType: 'Device type',
    colModel: 'Model',
    colSite: 'Site / org',
    colService: 'Service',
    colServiceDefault: 'Device data · yearly',
    grandTotal: 'Total',
    colDescription: 'Description',
    colSegment: 'Segment',
    colQty: 'Qty',
    colUom: 'UOM',
    colUnitPrice: 'Unit price',
    colBillingFreq: 'Billing',
    colAmount: 'Line amount',
    freqYearly: 'Yearly',
    freqMonthly: 'Monthly',
    termsTitle: 'Terms & disclosures',
    termsHint: 'Expand and read before payment. Confirming or paying means you accept these terms.',
    paymentTermsTitle: 'Payment terms',
    paymentTermsSummary: 'Payment terms for this order: {term}.',
    paymentTermsSummaryDefault: 'Amount and currency on this order are final; payment is due within the stated period.',
    paymentTermsBody1: 'Late payment may suspend service. Paid amounts follow contract/add-on rules unless agreed otherwise in writing.',
    paymentTermsBody2: 'Channel fees and FX differences are borne by the payer. Payment is complete when received in XRROSS company accounts.',
    usageTermsTitle: 'Usage terms',
    usageTermsSummaryContract: 'SOC portal, device data, or store subscription features are licensed only to the authorized brand and its stores/devices.',
    usageTermsSummaryAddon: 'Add-on “{sku}” is enabled only within paid/trial entitlement; features downgrade or stop if not renewed.',
    usageTermsBody1: 'You represent that you may bind the enterprise. Account and remote device actions are your responsibility.',
    usageTermsCancelAnytime: 'This add-on may be cancelled anytime; no further charges after the current period; no refund for elapsed paid time.',
    serviceTermsTitle: 'Service terms & disclaimer',
    serviceTermsBody1: 'XRROSS SOC is provided under our Privacy Policy, Terms of Service, and Disclaimer.',
    serviceTermsBody2: 'Electronic confirmation, payment timestamps, and account logs may serve as evidence of acceptance.',
    viewPlatformTerms: 'View full platform terms',
    totalDue: 'Total due',
    promoTitle: 'Coupons',
    promoSelectHint: 'Select one or more coupons; amounts update after apply (once per order).',
    promoApplyBtn: 'Apply coupons',
    promoAppliedTitle: 'Promo applied',
    promoDiscount: 'Discount',
    promoSubtotalBefore: 'Subtotal before promo',
    promoEmpty: 'No eligible coupons',
    trialEndsAt: 'Trial ends',
    paymentTermNet7: 'Net 7 days',
    paymentTermNet15: 'Net 15 days',
    paymentTermNet30: 'Net 30 days',
    paymentTermNet45: 'Net 45 days',
    paymentTermNet60: 'Net 60 days',
    paymentTermPrepaid: 'Prepaid',
    paymentTermDueOnReceipt: 'Due on receipt'
  },
  brandServiceContract: {
    title: 'Service contract',
    pageDesc: 'Brand billing terms with email / e-sign confirm before activate; terms_json is the price source.',
    helpTitle: 'How to use (expand)',
    help1: 'Create: pick brand, pricing, payment and confirm channel; save as draft.',
    help2: 'Send confirm email, portal ack or mark e-sign, then activate.',
    help3: 'Data-service ACTIVE contracts still apply; Leo basic is free with hardware; add-ons are trial-then-pay, cancel anytime.',
    create: 'New contract',
    tabContracts: 'Contracts',
    tabEntitlementTree: 'Entitlement tree',
    treeNeedBrand: 'Select a brand to view purchased vs pending on the same sidebar tree.',
    treePickContract: 'Contract',
    treeInContract: 'In contract',
    treeLockedPrice: 'Locked price',
    treeQty: 'Qty',
    treePayable: 'Payable',
    treeLineStatus: 'Status',
    treeStatusInScope: 'Purchased',
    treeStatusNotPurchased: 'Pending',
    treeFilterInContract: 'Purchase filter',
    treeFilterAll: 'All',
    treeFilterPurchased: 'Purchased only',
    treeFilterNotPurchased: 'Pending only',
    treeFilterKeyword: 'Search menu / SKU',
    createTitle: 'New brand service contract',
    bundleTier: 'Bundle tier',
    bundleTierT1: '① SOC only $49/store/mo',
    bundleTierT2: '② Full store $199/store/mo',
    bundleTierT3: '③ Devices only per unit',
    bundleTierT4: '④ SOC $99 + per device',
    bundleTierPaperLock: 'Paper lock (do not re-quote)',
    priceBookSku: 'Price book template',
    priceBookSkuPh: 'Pick contract pricing from HQ price book',
    needPriceBookSku: 'Select a price book SKU first — amount cannot be calculated without it',
    brand: 'Brand',
    brandId: 'Brand ID',
    status: 'Status',
    statusDraft: 'Draft',
    statusPendingHqApproval: 'Pending HQ approval',
    statusApproved: 'Approved',
    statusPendingTenantConfirm: 'Pending tenant confirm',
    statusPendingPay: 'Pending payment',
    statusActive: 'Active',
    statusSuspended: 'Suspended',
    statusExpired: 'Expired',
    statusCancelled: 'Cancelled',
    contractNo: 'Contract No.',
    pricingMethod: 'Pricing',
    pricingTiered: 'Tiered annual pool',
    pricingPerDevice: 'Per-device period fee',
    pricingPerStoreMonth: 'Per store / month (min months)',
    pricingPerDeviceMonth: 'Per device / month (min months)',
    pricingPerStoreDay: 'Per store / day PAYG',
    pricingPerDeviceDay: 'Per device / day PAYG',
    minContractMonths: 'Min contract months',
    periodMonths: 'Contract months',
    dayCount: 'Days of use',
    pricingSocStore: 'SOC store subscription (recommended)',
    addonPricingOneTime: 'One-time add-on',
    addonPricingPerDeviceYear: 'Per device / year',
    addonPricingPerStoreYear: 'Per store / year',
    addonPricingPerHouseholdYear: 'Per household / year',
    addonPricingTrialThenPaid: 'Trial then paid',
    addonPricingAiPoints: 'AI points pack',
    addonPricingModule: 'Module add-on',
    addonPricingCustomQuote: 'Custom quote',
    paymentTerm: 'Payment term',
    currency: 'Currency',
    tierCode: 'Tier',
    period: 'Billing cycle',
    unitPrice: 'Unit price',
    tiers: 'Tiers',
    addTier: 'Add tier',
    legacyOral: 'Legacy oral',
    confirmSection: 'Confirmation',
    confirmChannel: 'Confirm channel',
    confirmStatus: 'Confirm status',
    confirmNone: 'Not confirmed',
    confirmPendingEmail: 'Pending email',
    confirmPendingEsign: 'Pending e-sign',
    confirmEmailOk: 'Email confirmed',
    confirmSigned: 'E-signed',
    confirmPortalOk: 'Portal confirmed',
    confirmRejected: 'Rejected',
    confirmExpired: 'Confirm expired',
    confirmPendingTenant: 'Pending tenant',
    cycleYearly: 'Yearly',
    cycleQuarterly: 'Quarterly',
    cycleMonthly: 'Monthly',
    cycleDaily: 'Daily',
    paymentTermDepositBalance: 'Deposit + balance',
    paymentTermInstallment: 'Installment',
    chEmail: 'Email confirm',
    chEsign: 'E-sign',
    chPortal: 'Portal ack',
    chManual: 'Offline / oral',
    confirmEmail: 'Confirm email',
    signerRole: 'Signer role',
    signerName: 'Signer name',
    mailLocale: 'Mail locale',
    requireConfirm: 'Require confirm before activate',
    addonTitle: 'SOC/Leo add-ons (trial, cancel anytime)',
    addonHint: 'Hardware includes Leo basic free; this list is add-ons only. Home vs commercial filtered.',
    addonHome: 'Home',
    addonCommercial: 'Commercial',
    addonName: 'Name',
    addonTrialDays: 'Trial days',
    addonUsdPrice: 'USD price',
    addonBillingCycle: 'Billing cycle',
    addonBillingYearly: 'Yearly',
    addonBillingMonthly: 'Monthly',
    addonCancel: 'Cancel OK',
    addonStartTrial: 'Start trial',
    addonWxPay: 'WeChat Pay',
    addonPaypal: 'PayPal',
    addonPaypalOpen: 'Opened PayPal (USD overseas)',
    addonPaypalStub: 'Stub activated — not real money',
    addonPaypalNoUrl: 'No PayPal approve URL',
    addonWxTitle: 'XRROSS company WeChat Pay',
    addonWxHonesty: 'Scan to pay XRROSS (SOC / hardware). Not store GMV. Stub QR if company keys are empty.',
    addonWxSim: 'Simulate paid',
    addonWxPaid: 'Marked paid (stub ≠ live unless WX_COMPANY_* is set)',
    addonWxQrFail: 'Cannot render QR',
    addonWxNoEntitlement: 'No trial entitlement; start trial first',
    addonNeedBrand: 'Select a brand filter first',
    addonTrialOk: 'Trial started',
    quoteLine: 'Estimate {amount} {currency} (devices {devices} / stores {stores}, {period})',
    quoteTrackA: 'A subtotal (device data)',
    quoteTrackB: 'B subtotal (store ops)',
    quoteBundle: 'Bundle price',
    quotePayable: 'Amount due',
    quoteExTax: 'Ex-tax subtotal',
    quoteExTaxShort: 'ex-tax',
    quoteTax: 'Tax',
    quoteTaxInclusive: 'Tax-inclusive total',
    taxRegion: 'Tax region',
    quoteExportPdf: 'Export quote',
    quotePrintTitle: 'Official quote',
    needBrandPricing: 'Select brand and pricing method',
    needEmail: 'Email confirm requires an address',
    sendEmail: 'Send email',
    portalAck: 'Portal ack',
    markEsign: 'Mark signed',
    esignUrlHint: 'E-sign file URL (optional)',
    activate: 'Activate',
    suspend: 'Suspend',
    suspendReason: 'Suspend reason (optional)',
    actions: 'Actions',
    mailSent: 'Confirm email sent',
    mailStub: 'Mail failed; token generated for manual confirm',
    summaryTitle: 'Contract summary',
    summaryPageDesc: 'See what each brand must confirm, pay, or has already activated. Open detail for line items.',
    summarySimpleIntro: 'Three kinds of charges appear here: ① platform service fee ② extra features ③ hardware orders. Each row is one item—not duplicate data.',
    summaryGoDesk: 'New contract',
    startPipeline: 'Start standard pipeline',
    pipelineTitle: 'Contract standard pipeline',
    pipelineDesc: 'Draft → HQ approve → tenant confirm → pay → active. Click a node to jump and open the guide.',
    pipelineNow: 'Now',
    flowNode_bsc_draft: 'Draft',
    flowNode_bsc_hq_approve: 'HQ approve',
    flowNode_bsc_tenant_confirm: 'Confirm',
    flowNode_bsc_pay: 'Pay',
    flowNode_bsc_active: 'Active',
    addonStartPipeline: 'Start addon pipeline',
    addonPipelineTitle: 'Addon standard pipeline',
    addonPipelineDesc: 'Trial / buy → pay → active (standard SKUs skip HQ).',
    flowNode_sla_start: 'Trial / buy',
    flowNode_sla_pay: 'Pay',
    flowNode_sla_active: 'Active',
    quickAll: 'All',
    quickActionAdmin: 'Needs my approval',
    quickActionTenant: 'Needs my confirm',
    quickPay: 'To pay',
    quickOverdue: 'Overdue',
    quickActive: 'Active',
    statPendingPay: 'To pay',
    statOverdue: 'Overdue',
    statActive: 'Active',
    filterBrandPh: 'Search brand',
    filterTypePh: 'Charge type',
    showAdvanced: 'More filters',
    hideAdvanced: 'Hide filters',
    colBrand: 'Brand',
    colItem: 'What',
    colSituation: 'Status now',
    colAmount: 'Due',
    colDueDate: 'Next due',
    trackShortContractA: 'Platform service',
    trackShortAddonB: 'Extra feature',
    trackShortHardware: 'Hardware',
    situationPendingHq: 'Awaiting HQ approval',
    situationPendingConfirm: 'Awaiting your confirm',
    situationPendingPay: 'To pay',
    situationOverdue: 'Overdue',
    situationActive: 'Active',
    situationSuspended: 'Suspended',
    situationDraft: 'Draft',
    situationHardware: 'Hardware payment',
    situationOther: 'Other',
    actionApprove: 'Approve',
    actionConfirm: 'Confirm',
    actionReject: 'Reject',
    goDesk: 'Contract desk',
    paymentStatus: 'Payment status',
    payUnpaid: 'Unpaid',
    payPaid: 'Paid',
    payPartial: 'Partial',
    payOverdue: 'Overdue',
    amountDue: 'Amount due',
    amountPaid: 'Amount paid',
    nextDueAt: 'Next due',
    expiredOnly: 'Expired / overdue only',
    editPayment: 'Edit payment',
    editPaymentTitle: 'Edit payment',
    totalContracts: 'Contracts',
    totalActive: 'Active',
    totalUnpaid: 'Unpaid / partial',
    totalOverdue: 'Payment overdue',
    totalDue: 'Due total',
    totalOutstanding: 'Outstanding',
    viewDetail: 'Detail',
    detailTitle: 'Contract detail',
    detailPageDesc: 'Commercial Order Form (model / qty / unit / totals) plus charge history; same sheet as confirm.',
    backSummary: 'Back to summary',
    goConfirmOrder: 'Open confirm / sign-back',
    detailPayWaitHq: 'Waiting for HQ approval before you can confirm or pay.',
    detailPayWaitConfirm: 'Complete portal sign-back first; pay appears when status is pending payment.',
    detailPayNoAction: 'Cannot pay in this status. Use “Open confirm” or “Pay now” (when pending payment) top-right.',
    detailMerchant: 'Merchant',
    detailScope: 'Product / service scope',
    detailPricing: 'Pricing',
    detailDates: 'Effective & expiry',
    detailChargeHistory: 'Charge history',
    chargeTime: 'Time',
    chargeEvent: 'Event',
    chargeNote: 'Note',
    amountDelta: 'Paid delta',
    effectiveFrom: 'Effective from',
    effectiveTo: 'Effective to / expiry',
    devicesStores: 'Billable devices / stores',
    detailLoadFail: 'Failed to load detail',
    track: 'Track',
    trackContractA: 'Service contract',
    trackAddonB: 'Add-on',
    trackHardware: 'Hardware PO',
    deskPhase: 'Desk phase',
    phasePendingHq: 'Pending HQ',
    phasePendingConfirm: 'Pending confirm',
    phasePendingPay: 'Pending pay',
    phaseOverdue: 'Overdue',
    phaseSuspended: 'Suspended',
    hqApprove: 'HQ approve',
    hqReject: 'HQ reject',
    hqApproveOk: 'Approved; tenant notified',
    hqRejectOk: 'Rejected',
    submitApproval: 'Submit for approval',
    batchSelected: '{n} selected',
    batchSubmit: 'Batch submit',
    batchHqApprove: 'Batch HQ approve',
    batchHqReject: 'Batch HQ reject',
    batchSendEmail: 'Batch send confirm email',
    batchActivate: 'Batch activate',
    batchSuspend: 'Batch suspend',
    batchClear: 'Clear selection',
    batchAllOk: 'All {n} succeeded',
    batchPartial: '{ok} ok, {fail} failed ({err})',
    batchConfirmSubmit: 'Submit {n} contract(s) for HQ approval?',
    batchConfirmActivate: 'Activate {n} contract(s)?',
    contractLineItem: 'Service line',
    priceLockedHint: 'Unit prices are locked from the price book and will be written to the contract on confirm',
    discountPct: 'Discount %',
    discountPctPh: '0 = no discount',
    discountReasonPh: 'Discount reason (optional)',
    hqRejectReasonPh: 'Rejection reason',
    billingConfirmTitle: 'Billing confirm',
    schemePickTitle: 'Choose pricing scheme',
    addonTrackBTitle: 'Add-ons on this order (Track B)',
    addonTrackBHint: 'Cloud Iris and other add-ons are listed with the Track A contract; entitlement billing stays separate and appears on the summary desk.',
    cloudIrisPickHint: 'Before signing back, pick which machines get Cloud Iris; amount recalculates by device count.',
    cloudIrisPickBtn: 'Select devices',
    cloudIrisPickOk: 'Cloud Iris device scope updated',
    schemePickHint: 'Pick a scheme; totals and lines update on select. Hover a scheme for explanation and unit-price breakdown, then lock before confirm.',
    schemePickHintSimple: 'Tap a card to pick a plan; then pick a volume tier inside the same card — amount due updates instantly.',
    schemePickHintPaperLock: 'Paper contract locks annual fee and device cap; amount is not re-quoted from the price book. Confirm and sign back.',
    tierEmbedTitle: 'Pick a volume tier (more = cheaper)',
    tierEmbedHint: 'Tap a tier. Current band is marked. Higher tiers require prepaid min qty for a lower unit price.',
    storeTierEmbedTitle: 'Pick a store tier (more = cheaper)',
    storeTierEmbedHint: 'Tap a tier. Current band is marked. Higher tiers require prepaid min stores.',
    brandRoleTitleReadonly: 'Your type',
    brandRoleLockedHint: 'Set by platform; not editable',
    schemeCardBlurbDefault: 'Select to preview amount due and line details below.',
    deviceTierLadderHint: 'More devices = lower unit price. Table compares tiers at your current count.',
    storeTierLadderHint: 'More stores = lower per-store price. Table compares tiers at your current store count.',
    tierLadderTitle: 'Device volume tiers (more = cheaper)',
    storeTierLadderTitle: 'Store volume tiers (more = cheaper)',
    tierLadderBand: 'Tier',
    tierLadderRange: 'Qty range',
    tierLadderDiscount: 'Discount',
    tierLadderUnit: 'Effective unit',
    tierLadderQty: 'Billable devices',
    tierLadderQtyStore: 'Billable stores',
    tierLadderTotal: 'Subtotal',
    tierLadderSaveVsPrev: 'Save vs prior',
    tierLadderSaveVsPrevAmt: 'Save {amount} vs prior at same qty',
    tierLadderCurrent: 'Current band',
    tierLadderNegotiated: 'Negotiated',
    tierLadderNeedPrepaid: 'Prepaid ≥{count}',
    tierLadderNeedPrepaidStore: 'Prepaid ≥{count} stores',
    tierLadderFootnote: 'Compared at {count} devices. Prepaid lock needs the tier minimum for a lower unit price.',
    schemeHoverHint: 'Hover for scheme explanation and unit-price composition',
    schemeUnitComposeTitle: 'Unit price composition',
    schemeUnitComposeEmpty: 'No per-device/store unit breakdown for this scheme (use the total).',
    schemeUnitComposeFlat: 'Unit {unit} {currency} × {qty}',
    schemeUnitComposeTotalOnly: 'Quoted as a total of {total} {currency} (no finer unit split).',
    schemeExplain_DEFAULT: 'Amount is estimated from the company price book; locking writes amount due and lines onto the contract.',
    schemeExplain_T1: 'T1 Pure SOC: store SOC subscription only (per store / month). Device yearly fees are NOT on this bill. If you already have devices, pick T2 full-store or T4 SOC+devices instead.',
    schemeT1DeviceGuideTitle: 'T1 Pure SOC excludes device fees',
    schemeT1DeviceGuideDesc: 'About {count} device(s) under this brand. $49/mo is SOC only and will not auto-add device yearly fees. To bill devices, switch to Full-store pack or SOC+devices.',
    schemeT1DeviceBlockTitle: 'Note (T1 Pure SOC)',
    schemeT1DeviceBlockDesc: 'About {count} device(s) under this brand. With devices on file, T1 ($49 / Pure SOC) is usually not applicable; consider Full-store pack or SOC+devices before locking.',
    brandRoleTitle: 'Brand type (affects recommendation)',
    brandRoleOperator: 'Brand operator',
    brandRoleEquipment: 'Equipment maker / channel',
    schemeRecommendTitle: 'Recommended · best value',
    schemeRecommendBadge: 'Best',
    schemeRecommendApply: 'Apply recommendation',
    schemeRecommendApplied: 'Recommended scheme and payment cadence applied',
    schemeRecommendReasonNone: 'No recommendable scheme; please choose manually.',
    schemeRecommendReasonEquipment: 'Treated as equipment maker (~{deviceCount} devices, {storeCount} stores): SOC not needed; recommend device plan {code}, ~{amount} {currency}/year.',
    schemeRecommendReasonOperator: 'Treated as brand operator (~{storeCount} stores, {deviceCount} devices): {code} is cheapest at ~{amount} {currency}/year among options.',
    schemeRecommendReasonOperatorAnnual: 'Brand operator: recommend {code} with annual prepay 85%, ~{amount} {currency}/year.',
    schemeExplain_T2: 'T2 Full-store bundle: higher per-store / month SOC pack without splitting device lines yet.',
    schemeExplain_T3: 'T3 Devices only (yearly): per-device data fees under the brand subtree, line-by-line by model/imie; no SOC store fee.',
    schemeExplain_T4: 'T4 SOC + devices: store SOC subscription plus per-device yearly fees in one quote.',
    schemeExplain_PER_DEVICE_YEARLY: 'Per-device yearly: one line per device; unit price from the price-book SKU; total = sum of line amounts.',
    schemeExplain_TIERED_ANNUAL_POOL: 'Tiered annual pool: brand subtree device count maps to price tiers; lines may still list each device for reconciliation.',
    schemeLockBtn: 'Lock this scheme',
    schemeLockOk: 'Pricing scheme locked',
    schemeLockFail: 'Failed to lock scheme (backend select-scheme required)',
    deviceTierLockTitle: 'Device-count tier (device data)',
    deviceTierLockHint: 'Use current device count, or pick a prepaid tier: pay at least the tier minimum; unit price locks within the band.',
    deviceTierModeActual: 'Current count ({count} devices)',
    deviceTierModePrepaid: 'Prepaid tier lock',
    committedDeviceCountLabel: 'Committed devices',
    committedDeviceCountHint: 'Must be ≥ current count; billing uses the committed count after lock.',
    committedDeviceCountInvalid: 'Committed count must be at least {min}',
    storeTierLockTitle: 'Store-count tier (per-store plan)',
    storeTierLockHint: 'After a store plan, bill by current stores or pick a prepaid tier at the tier minimum.',
    storeTierModeActual: 'Current stores ({count})',
    storeTierModePrepaid: 'Prepaid tier lock',
    tierBandPickHint: 'Pick a tier; prepaid qty = max(tier min, current count).',
    tierBandPrepaidMin: 'Prepaid {count} devices',
    storeTierBandPrepaidMin: 'Prepaid {count} stores',
    tierBandRequired: 'Please select a tier',
    tierBandUnavailable: 'This tier is not available for the current count; pick a higher band',
    tierGrowthPolicyHint: 'Extra units still in-band are billed at the locked unit price × remaining term; crossing the next band requires an amendment (no auto-upgrade).',
    paymentCadenceTitle: 'Payment cadence (terms discount)',
    paymentCadenceHint: 'For fixed monthly fees, pay monthly or prepay 12 months at 85%. Yearly device lines stay full price. Lock to update amount due.',
    paymentCadenceMonthly: 'Pay monthly',
    paymentCadenceMonthlyNote: 'Current monthly fixed portion (+ other yearly lines)',
    paymentCadenceAnnual: 'Annual prepay · 15% off',
    paymentCadenceAnnualNote: 'Monthly ×12 ×0.85 once (other yearly lines unchanged)',
    paymentCadenceLockBtn: 'Lock this payment cadence',
    paymentCadenceLockOk: 'Payment cadence locked; amount due updated',
    paymentCadenceLockFail: 'Failed to lock payment cadence',
    billingConfirmDesc: 'After HQ approval, confirm terms here; then proceed to payment.',
    billingConfirmBtn: 'I confirm',
    billingConfirmOk: 'Confirmed; please pay',
    billingConfirmDone: 'Already confirmed or not available',
    billingConfirmMissing: 'Missing track/sourceId or no access',
    billingPayActive: 'Service is active'
  },
  opsAnalytics: {
    subtitle: 'Store/area charts + AI tips; competitor intel is a separate add-on',
    month: 'Month',
    storeId: 'Store ID',
    query: 'Query',
    goPnl: 'P&L desk',
    skuHint: 'Charts/area: COM_ANALYTICS_AI; competitor + deep AI: COM_COMPETITOR_INTEL + AI points',
    areaTitle: 'Area peer comparison',
    store: 'Store',
    compTitle: 'Competitor analysis',
    compSku: 'Competitor intel add-on',
    compName: 'Rival',
    rating: 'Rating',
    reviews: 'Reviews',
    priceBand: 'Price band',
    salesHonesty: 'Sales honesty',
    aiTitle: 'AI advice (short)',
    catalogTitle: 'Report catalog (max set)',
    kpi: { revenue: 'Revenue', gross: 'Gross', net: 'Net', aov: 'AOV', tickets: 'Tickets', labor: 'Labor %' },
    charts: { rev: 'Revenue trend', hour: 'Hourly heat', item: 'Item rank', channel: 'Channel mix', area: 'Area rank' }
  },
  tokenBilling: {
    pageTitle: 'AI Points Billing',
    pageLead: 'Summarize Leo usage and charges for the logged-in enterprise. Public label is AI Points; internal ledger remains token-based. Upstream cost and retail presets support margin estimates (last 30 days).'
  },
  leoE2: {
    webMarketSearch: 'Hot-sell web search',
    webMarketHintTitle: 'Hot-sell search is wired (draft only)',
    webMarketHintDesc: 'Searches public sources and parses ingredient drafts as DRAFT only. Material ID preflight and human gate still required. Not production-hard-green; no auto dispatch.',
    webQuery: 'Search query',
    webQueryPh: 'e.g. trending tea drinks recipe (blank = default hot-sell query)',
    webSearchBtn: 'Search and fill opener',
    webSearchFail: 'Hot-sell web search failed',
    e21Tab: 'E21 intelligent formula',
    e21AlertTitle: 'E21 trial-brew loop (tea P1 · simulator first)',
    e21Banner: 'Flow: open session → first-apply gate → trial brew → taste feedback → formal save PRIVATE+VERIFIED. PRODUCTION may chat but will not dispatch. Rule: tea-machine trial brew uses loose-leaf tea, not powder.',
    e21Entry: 'Entry',
    e21HasMenu: 'Have menu / item text',
    e21CompetitorPaste: 'Paste competitor recipe',
    e21MenuText: 'Menu text',
    e21MenuPh: 'Paste customer menu or competitor recipe; compiles a draft as the E21 opener',
    e21ApplyOpener: 'Fill opener',
    e21TrialMaterial: 'Current trial material: {label}',
    e21TeaLeaf: 'loose-leaf tea',
    e21TargetUrn: 'Target URN',
    e21DeviceOpsMode: 'deviceOpsMode',
    e21StartMessage: 'Opener',
    e21Start: 'Start session',
    e21ConfirmFirst: 'Confirm first apply',
    e21Trial: 'Trial brew',
    e21FormalSave: 'Formal save',
    e21TurnFeedback: 'Turns / feedback',
    e21TurnPh: 'e.g. a bit too bitter, lighter please / save formally',
    e21SendTurn: 'Send turn',
    e21SendFeedback: 'Send feedback',
    e21SessionState: 'Session',
    e21NeedUrnAndMessage: 'Fill target URN and opener',
    e21SessionOpened: 'E21 session started',
    e21StartFail: 'Failed to start session',
    e21FirstConfirmed: 'First apply confirmed',
    e21FirstCancelled: 'First apply cancelled',
    e21FirstFail: 'First apply failed',
    e21TrialStarted: 'Trial brew started',
    e21TrialFail: 'Trial brew failed',
    e21NeedUtterance: 'Enter an utterance',
    e21TurnFail: 'Turn failed',
    e21NeedFeedback: 'Enter feedback',
    e21FeedbackOk: 'Feedback received',
    e21FeedbackFail: 'Feedback failed',
    e21Saved: 'Saved PRIVATE+VERIFIED',
    e21SaveCancelled: 'Save cancelled',
    e21SaveFail: 'Formal save failed',
    e21HotSellOpener: 'Search hot-selling teas on the market'
  },
  x600hProductionOrder: {
    pageDesc: 'Dual-track factory: Android cloud provision or HF wireless, then bind / first-check / ship. Start the standard pipeline from this page.',
    startStandardPipeline: 'Start automated pipeline',
    socPipelineNodeTodo: 'Not started',
    socPipelineNodeCurrent: 'In progress',
    socPipelineNodeDone: 'Done',
    startOpenStorePipeline: 'Start store-open pipeline',
    startBusinessHoursPipeline: 'Start business-hours pipeline',
    pipelineStarted: 'Batch device simple pipeline started (includes factory setup) — follow the nodes.',
    togoOpen: 'To-go',
    togoTitle: 'Work-order to-go',
    togoRemain: '{n} steps left',
    togoAllDone: 'All four steps done',
    togoStuck: 'Stuck',
    togoHint: 'Checks come from system status. Tap a stuck step to open the real page, or talk to Leo on the same order.',
    togoVoice: 'Talk to Leo',
    togoClose: 'Close',
    togoLoadFail: 'Could not load to-go list',
    togoStep_demand_placed: 'Demand placed',
    togoStep_hq_confirm: 'HQ confirmed',
    togoStep_factory_ready: 'Factory ready',
    togoStep_customer_activate: 'Customer activated',
    flowNow: 'Now',
    flowHint: 'Boxes are one line: green done, yellow stuck, grey not yet. Tap a box to jump on this order.',
    flowNode_hq: 'HQ confirm',
    flowNode_open: 'Open order',
    flowNode_bind: 'Scan bind',
    flowNode_handshake: '9100 handshake',
    flowNode_ship: 'Factory confirm',
    flowNode_activate: 'Customer activate',
    simplePipelineTitle: 'Automated pipeline: batch add devices',
    simplePipelineDesc: 'For global device management: create factory → register supplier → create production order → wait for system confirm. Do not use device-list manual create as the main path.',
    pipelineNow: 'Now',
    pipelineDone: 'Done',
    pipelineTodo: 'Todo',
    pipelineWaitHq: 'Waiting system confirm',
    flowNode_bbds_create_factory: 'Create factory',
    flowNode_bbds_register_s0: 'Register supplier',
    flowNode_bbds_create_order: 'Create order',
    flowNode_bbds_wait_hq: 'Wait system confirm'
  },
  deviceOrderLifecycle: {
    title: 'Device order guide',
    desc: 'Order to customer: steps S1–S7 open real pages; start smart guide by HQ / brand / factory.',
    roleHq: 'HQ',
    roleBrand: 'Brand',
    roleFactory: 'Factory',
    hintHq: 'HQ: confirm orders, issue IDs, oversee the chain.',
    hintBrand: 'Brand: create orders, receive/delegate, customer activation entry.',
    hintFactory: 'Factory: cloud/HF provision, bind, first-check, ship confirm (primary UI is Leo factory pack).',
    startSmartGuide: 'Start smart guide for this role',
    openPage: 'Open this step page',
    prev: 'Previous',
    next: 'Next',
    guideStarted: 'Smart guide started — continue in Leo assistant.',
    guideStartFail: 'Could not start smart guide (permission or backend not restarted)',
    s1Title: 'Create production order',
    s1Short: 'Brand creates',
    s1Body: 'Create an order on Production Orders: qty, model, cloud region. Wait for HQ confirm.',
    s2Title: 'HQ confirm',
    s2Short: 'Lock fields',
    s2Body: 'After HQ confirm, qty/model/region are locked for issue and production.',
    s3Title: 'Issue & sync',
    s3Short: 'Cross-region IDs',
    s3Body: 'Confirm ID ranges and replica ACK on Issue Sync.',
    s4Title: 'Provision, bind & check',
    s4Short: 'Factory line',
    s4Body: 'Android: cloud provision first; 9100: HF wireless first; then scan-bind and first-check. No hand-typed primary path.',
    s5Title: 'Factory ship confirm',
    s5Short: 'Ready delivery',
    s5Body: 'Confirm ship after first-check. No activation without ship; ship ≠ billing start.',
    s6Title: 'Brand receive / delegate',
    s6Short: 'Store / customer',
    s6Body: 'Brand receives or delegates devices to stores/end customers.',
    s7Title: 'First boot / field Wi‑Fi',
    s7Short: 'Activate billing',
    s7Body: 'Leo Field Provision: pick cloud region → Wi‑Fi; Change Wi‑Fi is STA-only. Then customer_activated (factory confirm ≠ billing). Check registry gate on hardware cert page.'
  },
  globalDevice: {
    catalogTitle: 'Model catalog',
    catalogDesc: 'New models require apply-for-review; only Tokyo write-center can approve into the master table.',
    catalogHint: 'Global model catalog: node apply → Tokyo approve',
    catalogApply: 'Apply new model',
    applyManageTitle: 'Model apply',
    applyManageDesc: 'Manage node model applies: submit, pending list, Tokyo approve/reject.',
    submitApply: 'Submit apply',
    applyRequired: 'Model key and name are required',
    applySubmitted: 'Submitted as PENDING',
    modelKey: 'Model key',
    modelName: 'Model name',
    deviceFamily: 'Device family',
    applyStatus: 'Status',
    applicantRegion: 'Applicant region',
    publishedModelId: 'Published model ID',
    rejectReason: 'Reject reason',
    notes: 'Notes',
    approve: 'Approve',
    reject: 'Reject',
    confirmApprove: 'Approve and write into Tokyo master catalog?',
    approved: 'Approved and published',
    rejected: 'Rejected',
    waitingTokyo: 'Waiting Tokyo review',
    centerRole: 'Write-center role',
    statusPending: 'PENDING',
    statusApproved: 'APPROVED',
    statusRejected: 'REJECTED',
    openApplyManage: 'Open model apply desk',
    governanceGapJump: 'Governance gaps',
    simplePipelineTitle: 'Automated pipeline: apply new model',
    simplePipelineDesc: 'For global device management: open apply page → submit one → wait Tokyo approval. Do not create published models locally.',
    pipelineNow: 'Now',
    pipelineDone: 'Done',
    pipelineTodo: 'Todo',
    pipelineWaitTokyo: 'Waiting Tokyo',
    startSimplePipeline: 'Start automated pipeline',
    pipelineStarted: 'Model-apply automated pipeline started — follow the nodes.',
    flowNode_bcas_open_apply: 'Open apply page',
    flowNode_bcas_submit_apply: 'Submit apply',
    flowNode_bcas_wait_tokyo: 'Wait Tokyo review'
  },
  dispenserDataCenter: {
    precisionDesc: 'Precision = actual discharge ÷ recipe discharge for dispenser quality monitoring.',
    lossDesc: 'Compare recipe vs actual discharge by material to spot loss and over-dispense.',
    multiMachineDesc: 'Entry to the multi-machine interconnect workbench for dispenser ↔ tea bindings.',
    refresh: 'Refresh',
    imiePlaceholder: 'Device IMIE (empty = tenant summary)',
    days7: 'Last 7 days',
    days30: 'Last 30 days',
    days90: 'Last 90 days',
    avgPrecision: 'Avg precision',
    onTargetRate: 'On-target rate',
    dispenseCount: 'Dispenses',
    precisionTrend: 'Precision trend (daily)',
    recentDispenses: 'Recent dispenses',
    noTrend: 'No trend yet; will show after backend is available',
    noRows: 'No rows',
    colTime: 'Time',
    colMaterial: 'Material',
    colRecipe: 'Recipe',
    colActual: 'Actual',
    colPrecision: 'Precision',
    colDelta: 'Delta',
    totalRecipe: 'Recipe total',
    totalActual: 'Actual total',
    totalDelta: 'Loss delta',
    lossRate: 'Loss rate',
    lossByMaterial: 'Loss by material',
    loadFailedFriendly: 'Precision/loss API unavailable (backend pending or network). Page degraded to empty state.',
    multiMachineReuseTitle: 'Dispenser multi-machine interconnect',
    multiMachineReuseBody: 'Deep-links to the existing early-brew workbench for dispenser ↔ tea bindings.',
    openEarlyBrew: 'Open interconnect workbench',
    openInNewTab: 'Open in new tab'
  },
  leoAiBill: {
    pageDesc: 'USD hard cap blocks Cloud Healer only; desktop chat uses Cursor Spending.',
    startPipeline: 'Start standard pipeline',
    usdCapLine: 'Monthly USD cap (Cloud Healer only)',
    usdExhausted: 'USD cap reached',
    gateScope: 'Blocks new Cloud Healer runs only; desktop Cursor chat is not blocked',
    roundsCap: 'Monthly round cap',
    usdCap: 'Monthly USD cap',
    saveCaps: 'Save caps',
    savedCaps: 'Saved round and USD caps',
    tableTitle: 'Full bill (USD + tokens)',
    colSubject: 'Item',
    colUsd: 'USD',
    colTokens: 'Tokens',
    colGated: 'Gated',
    colHint: 'Note',
    colAgent: 'Agent',
    gatedYes: 'Blocks Cloud Healer',
    gatedNo: 'Display only',
    na: '—',
    tokenNotSecondMoney: 'Tokens are usage on the same Cloud Agent bill, not a second charge. Click a row for details.',
    detailTitle: 'Cloud Healer details',
    desktopHint: 'Desktop coding spend is on Cursor official Spending',
    guideStarted: 'Pipeline started',
    guideStartFail: 'Failed to start pipeline'
  },
  x600hAftersales: {
    title: 'X600H aftersales',
    desc: 'Track replace / return / policy FAQ. Nodes are clickable with live status. Public terms stay on the buy page.',
    openTerms: 'Warranty & returns',
    startLine: 'Start a line',
    startHint: 'Or say it in Leo — same playbook.',
    startReplace: 'Start replace-first',
    startReturn: 'Start 30-day return',
    startFaq: 'Ask warranty / return FAQ',
    myProcess: 'My process',
    refresh: 'Refresh',
    noActive: 'No active aftersales line yet — start one above or in Leo.',
    pleaseDo: 'Please do: ',
    followPipeline: 'Follow the pipeline',
    coachDefault: 'Blue box = current step. Tap nodes to review status.',
    openAssist: 'Open assistant',
    iDidCheck: 'I finished · re-check',
    statusDone: 'Done',
    statusCurrent: 'In progress',
    statusTodo: 'Not started'
  },
  coupon: {
    // XRROSS_I18N_UNION_FILL_20260916 en
    Text1: 'Name',
    Text2: 'Discount amount',
    Text3: 'Points cost',
    Text4: 'Status',
    Text5: 'Detail',
    Text6: 'Available',
    Text7: 'Unavailable',
    Text8: 'Valid days',
  },
  file: {
    // XRROSS_I18N_UNION_FILL_20260916 en
    archive: 'Archive',
    archiveConfirm: 'After archive, old devices stop fetching this build (file kept for rollback). Confirm',
    archived: 'Archived',
    backedUp: 'Backed up',
    backupNow: 'Back up now',
    backupRemoteGone: 'Cloud APK missing (404). Re-upload APK then back up.',
    backupStatus: 'Server backup',
    batchArchive: 'Batch archive',
    batchBackup: 'Batch back up',
    batchBackupConfirm: 'Run backup for selected items?',
    batchBackupDone: 'Batch backup finished',
    copyLink: 'Link',
    file: 'File',
    history: 'History',
    historyTitle: 'Version history',
    keyword: 'Keyword',
    linkCopied: 'Download link copied',
    linkCopyFailed: 'Copy failed; copy manually',
    name: 'Name',
    noDownloadLink: 'No download link yet',
    notBackedUp: 'Not backed up',
    otaArchivedBacked: 'Archived · backed up',
    otaArchivedNoBackup: 'Archived · no backup',
    otaBackupHint: 'After save, the package is backed up to the server artifact store; old devices keep the original URL.',
    otaForceUpgrade: 'Force upgrade',
    otaForceUpgradeHint: 'On = device cannot cancel update; can combine with gray.',
    otaGray: 'Gray',
    otaGrayHint: 'On = whitelist only; off or empty = full rollout.',
    otaGrayMachines: 'Gray machine codes',
    otaGrayMachinesPlaceholder: 'One machine code per line, or comma-separated',
    otaGrayOff: 'Full rollout',
    otaGrayOn: 'Gray ({n})',
    otaGraySet: 'Set gray list',
    otaLinkBroken: 'Broken link',
    otaLiveBacked: 'Live · backed up',
    otaLiveNoBackup: 'Live · no backup',
    otaPushForce: 'Push now',
    otaPushForceConfirm: 'Push force-upgrade check to gray whitelist now? Offline devices marked offline.',
    otaPushForceResult: 'Push done: total {total}, delivered {delivered}, offline {offline}',
    otaReuploadHint: 'If backup returns 404: cloud file deleted — re-upload APK here then confirm.',
    otaStatus: 'OTA status',
    otaStatusTipArchivedBacked: 'Gray = not live; rollback still possible.',
    otaStatusTipArchivedNoBackup: 'Red = archived with no backup; rollback unlikely — re-upload.',
    otaStatusTipLinkBroken: 'Red broken link = empty URL or cloud 404; re-upload APK.',
    otaStatusTipLiveBacked: 'Green = live and backed up on server.',
    otaStatusTipLiveNoBackup: 'Orange = live but not backed up; back up or re-upload.',
    otaStatusTipTitle: 'Status legend:',
    pendingIntentGate: 'PendingIntent gate',
    pendingIntentGateFail: 'Failed',
    pendingIntentGateNa: 'N/A',
    pendingIntentGatePass: 'Passed',
    pendingIntentGateSkip: 'Skipped',
    pendingIntentGateTipFail: 'Scanned: targetSdk≥31 and UpdateDialog missing PendingIntent fix — in-app OTA will crash.',
    pendingIntentGateTipNa: 'Low targetSdk or no UpdateDialog — hard gate N/A.',
    pendingIntentGateTipPass: 'Passed Android 12 PendingIntent hard gate at publish (safe OTA source).',
    pendingIntentGateTipSkip: 'Hard gate was manually skipped at publish — risk remains.',
    pendingIntentGateTipUnknown: 'Legacy builds have no gate mark; new publish or rescan writes it.',
    pendingIntentGateUnknown: 'Unmarked',
    publishStatus: 'Publish status',
    published: 'Live latest',
    recheckLinks: 'Recheck links',
    remark: 'Remark',
    rollback: 'Rollback',
    rollbackConfirm: 'Rollback to this version? Current live build will be archived.',
    selectFirst: 'Select APPs first',
    upload: 'Upload',
    version: 'Version',
  },
  storeHomeFeedTitle: 'Home Feed',
  storeHomeFeedDesc: 'Human direction, AI layout: pinned heroes + personalized mosaic',
  storeHomeFeedSave: 'Save direction',
  storeHomeFeedReload: 'Reload',
  storeHomeFeedAnalytics: 'Analytics',
  storeHomeFeedTheme: 'Campaign theme',
  storeHomeFeedMode: 'Mode',
  storeHomeFeedModeDirection: 'AI within direction',
  storeHomeFeedModeFull: 'More open (still no dump-all)',
  storeHomeFeedPins: 'Pinned product IDs',
  storeHomeFeedBoostCats: 'Boost categories',
  storeHomeFeedBan: 'Ban IDs',
  storeHomeFeedGuarantee: 'Guarantee %',
  storeHomeFeedExplore: 'Explore %',
  storeHomeFeedEnabled: 'Enabled',
  storeHomeFeedIdsHint: 'Comma-separated IDs',
  storeHomeFeedCatsHint: 'e.g. Signature,Tea',
  storeHomeFeedSaved: 'Saved',
  storeHomeFeedImp: 'Impressions',
  storeHomeFeedClick: 'Clicks',
  storeHomeFeedAdd: 'Add to cart',
  storeHomeFeedPay: 'Paid',
  storeHomeFeedPipeline: 'Standard pipeline',
  storeHomeFeedStartPipeline: 'Start standard pipeline',
  storeHomeFeedCheckGuide: 'Check guide',
}


// WEBPACK FOOTER //
// ./src/lang/en.js